import {ExclamationCircleIcon} from '@heroicons/react/20/solid';
import classNames from 'classnames';
import {ImageProps} from 'next/image';
import Image from 'next/legacy/image';
import {ComponentProps} from 'react';

import cropStumpsMiscanthus from './img/Crop-Stumps_Miscanthus.svg';
import cropStumpsWillow from './img/Crop-Stumps_Willow.svg';
import beetles from './img/events/Beetles.svg';
import carbonScheme from './img/events/CarbonScheme.svg';
import deer from './img/events/Deer.svg';
import harvest from './img/events/Harvest.svg';
import harvesterMachine from './img/events/HarvesterMachine.svg';
import newMarket from './img/events/NewMarket.svg';
import pests from './img/events/Pests.svg';
import plantingMachineEvent from './img/events/PlantingMachine.svg';
import rabbit from './img/events/Rabbit.svg';
import rust from './img/events/Rust.svg';
import transport from './img/events/Transport.svg';
import weed from './img/events/Weed.svg';
import expert from './img/expert.svg';
import money from './img/money.svg';
import neighbour from './img/neighbour.svg';
import plantingMachine from './img/plantingMachine.svg';
import tractor from './img/tractor.svg';

export {default as EnvirocropsLogo} from './EnvirocropsLogo';
export {default as InfoCircle} from './InfoCircle';
export {default as LeftArrow} from './LeftArrow';
export {default as RightArrow} from './RightArrow';

const ImportedIcon = ({
  src,
  alt,
  width,
  height,
  ...props
}: ComponentProps<'div'> & {
  src: any;
  alt?: string;
  width?: ImageProps['width'];
  height?: ImageProps['height'];
}) => {
  return (
    <div {...props}>
      <Image width={width} height={height} src={src} alt={alt} layout="responsive" />
    </div>
  );
};

export const NeighbourIcon = (props: ComponentProps<'div'>) => (
  <ImportedIcon src={neighbour} width={45} height={45} {...props} />
);
export const ExpertIcon = (props: ComponentProps<'div'>) => (
  <ImportedIcon src={expert} width={45} height={45} {...props} />
);

export const HelpIcon = (props: ComponentProps<'svg'>) => (
  <svg version="1.1" width="45px" height="45px" viewBox="0 0 45.0 45.0" {...props}>
    <defs>
      <clipPath id="100100117107109971204550108">
        <path d="M22.5,0 C34.9264069,0 45,10.0735931 45,22.5 C45,34.9264069 34.9264069,45 22.5,45 C10.0735931,45 0,34.9264069 0,22.5 C0,10.0735931 10.0735931,0 22.5,0 Z"></path>
      </clipPath>
      <clipPath id="52551121135605499110121">
        <path d="M22.5,0 C34.9264069,0 45,10.0735931 45,22.5 C45,34.9264069 34.9264069,45 22.5,45 C10.0735931,45 0,34.9264069 0,22.5 C0,10.0735931 10.0735931,0 22.5,0 Z M22.5,5.4 C13.0559308,5.4 5.4,13.0559308 5.4,22.5 C5.4,31.9440692 13.0559308,39.6 22.5,39.6 C31.9440692,39.6 39.6,31.9440692 39.6,22.5 C39.6,13.0559308 31.9440692,5.4 22.5,5.4 Z"></path>
      </clipPath>
      <clipPath id="48117122561075601099856">
        <path d="M24.2298826,0 C24.380276,-0.000786497001 24.5256453,0.0542180908 24.637756,0.154468851 C24.7432736,0.25962113 24.8027451,0.402352697 24.80311,0.551318612 L24.80311,17.9134956 C24.7972454,18.2154415 24.5538757,18.4588112 24.2519298,18.4646759 C15.1133617,18.5969591 12.401555,21.4961671 12.401555,21.4961671 L19.0157177,0.430058963 C20.7399892,0.151713892 22.4833069,0.00797310605 24.2298826,0 Z M0.573227432,0 C9.27291828,0.115707505 12.1342353,2.74489449 12.3833682,2.99112653 L12.401555,3.00958241 L12.401555,21.4961671 C12.401555,21.4961671 9.68974832,18.5969591 0.551180223,18.4646759 C0.249234379,18.4588112 0.00586467418,18.2154415 0,17.9134956 L0,0.551318612 C0.000364927386,0.402352697 0.0598364138,0.25962113 0.165354067,0.154468851 C0.277464777,0.0542180908 0.422834045,-0.000786497001 0.573227432,0 Z"></path>
      </clipPath>
      <clipPath id="985455121116489711810249">
        <path d="M5.82046315,0.0299607806 C6.00166544,-0.0265145548 6.19839741,-0.00242492573 6.36061977,0.0961024073 C6.51806939,0.187004473 6.61480558,0.355241317 6.61416586,0.537046586 L6.61416586,17.7448931 C4.76803525,18.124332 3.08720085,19.0726927 1.80787113,20.4566998 C0.807011926,21.4936045 0.172202545,22.8290266 0,24.2598434 L0,6.31341532 C0.191782916,4.8948235 0.824147174,3.57225679 1.80787113,2.53231899 C2.88484882,1.33910312 4.27509847,0.472106767 5.82046315,0.0299607806 Z"></path>
      </clipPath>
    </defs>
    <g clipPath="url(#100100117107109971204550108)">
      <polygon points="0,0 45,0 45,45 0,45 0,0" stroke="none" fill="#50A5F9"></polygon>
      <g clipPath="url(#52551121135605499110121)">
        <polygon points="0,0 45,0 45,45 0,45 0,0" stroke="none" fill="rgba(119, 119, 119, 0.2)"></polygon>
      </g>
      <g transform="translate(10.098444983595982 10.10000000000002)">
        <g transform="translate(0.0 3.303832916063527)">
          <g clipPath="url(#48117122561075601099856)">
            <polygon
              points="0,-8.31923917e-06 24.80311,-8.31923917e-06 24.80311,21.4961671 0,21.4961671 0,-8.31923917e-06"
              stroke="none"
              fill="#F4F4F4"
            ></polygon>
          </g>
          <path
            d="M19.0157177,0.430058963 C20.7399892,0.151713892 22.4833069,0.00797310605 24.2298826,0 C24.380276,-0.000786497001 24.5256453,0.0542180908 24.637756,0.154468851 C24.7432736,0.25962113 24.8027451,0.402352697 24.80311,0.551318612 L24.80311,17.9134956 C24.7972454,18.2154415 24.5538757,18.4588112 24.2519298,18.4646759 C15.1133617,18.5969591 12.401555,21.4961671 12.401555,21.4961671 L12.401555,3.00958241 C12.401555,3.00958241 9.70077192,0.121398038 0.573227432,0 C0.422834045,-0.000786497001 0.277464777,0.0542180908 0.165354067,0.154468851 C0.0598364138,0.25962113 0.000364927386,0.402352697 0,0.551318612 L0,17.9134956 C0.00586467418,18.2154415 0.249234379,18.4588112 0.551180223,18.4646759 C9.68974832,18.5969591 12.401555,21.4961671 12.401555,21.4961671 L19.0157177,0.430058963 Z"
            stroke="#F4F4F4"
            strokeWidth="1"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
        <g transform="translate(12.4015550164022 0.0)">
          <g clipPath="url(#985455121116489711810249)">
            <polygon
              points="0,1.38777878e-17 6.61416901,1.38777878e-17 6.61416901,24.2598434 0,24.2598434 0,1.38777878e-17"
              stroke="none"
              fill="#FFFFFF"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const MoneyIcon = ({className, ...props}: ComponentProps<'div'>) => (
  <div className={classNames('relative flex justify-center items-center', className)} {...props}>
    <Image src={money} layout={'fill'} objectFit={'contain'} alt="Money" />
  </div>
);

export const ToolsIcon = (props: any) => (
  <svg version="1.1" width="45px" height="45px" viewBox="0 0 45.0 45.0" className={props.className}>
    <defs>
      <clipPath id="i0">
        <path d="M22.5,0 C34.9264069,0 45,10.0735931 45,22.5 C45,34.9264069 34.9264069,45 22.5,45 C10.0735931,45 0,34.9264069 0,22.5 C0,10.0735931 10.0735931,0 22.5,0 Z"></path>
      </clipPath>
      <clipPath id="i1">
        <path d="M22.5,0 C34.9264069,0 45,10.0735931 45,22.5 C45,34.9264069 34.9264069,45 22.5,45 C10.0735931,45 0,34.9264069 0,22.5 C0,10.0735931 10.0735931,0 22.5,0 Z M22.5,5.4 C13.0559308,5.4 5.4,13.0559308 5.4,22.5 C5.4,31.9440692 13.0559308,39.6 22.5,39.6 C31.9440692,39.6 39.6,31.9440692 39.6,22.5 C39.6,13.0559308 31.9440692,5.4 22.5,5.4 Z"></path>
      </clipPath>
      <clipPath id="i2">
        <path d="M4.07865711,0 C4.91542852,0.0845220244 5.69774745,0.454026149 6.29455799,1.04662216 C6.80435735,1.55693597 7.15422238,2.20488474 7.30129549,2.91106519 C7.44835871,3.61724565 7.38624886,4.35098871 7.12255408,5.02239438 L14.7050406,12.6127955 L17.1890387,15.0967936 C17.9823788,14.7855519 18.8588221,14.7568614 19.6708604,15.015669 C20.4827997,15.2745754 21.1809666,15.8051506 21.6478293,16.5181574 C22.1146919,17.2312631 22.3217577,18.0832702 22.2342024,18.9310231 C22.1466471,19.778776 21.769912,20.570632 21.1673139,21.1732301 C20.5646169,21.7759271 19.7728598,22.1526622 18.9251069,22.2402175 C18.0772551,22.3276739 17.225248,22.1206081 16.5121423,21.6538444 C15.7991355,21.1869817 15.2685603,20.4888148 15.0097528,19.6767765 C14.7508463,18.8648372 14.7795368,17.9883939 15.0908775,17.1950538 L13.3349239,15.4400895 L5.01843707,7.12057542 C4.49021647,7.33013433 3.92065195,7.41454357 3.35436211,7.36719446 C2.78806237,7.31985524 2.2404312,7.14203389 1.75433607,6.84767991 C1.26825083,6.55332593 0.856909123,6.15042317 0.552553064,5.670541 C0.248187111,5.19064894 0.0590656931,4.64680689 0,4.08162509 C0.5678975,4.43639717 1.23929328,4.58819925 1.90458491,4.51223885 C2.56987655,4.43627845 3.18976805,4.13704709 3.66309099,3.66338778 C4.13640403,3.18972847 4.4351803,2.56961932 4.51065593,1.90426833 C4.58613156,1.23892722 4.43384471,0.567640276 4.07865711,0 Z M18.5246663,17.258905 C17.8176892,17.258905 17.244571,17.8320232 17.244571,18.5390003 C17.244571,19.2459774 17.8176892,19.8190956 18.5246663,19.8190956 C19.2316434,19.8190956 19.8047616,19.2459774 19.8047616,18.5390003 C19.8047616,17.8320232 19.2316434,17.258905 18.5246663,17.258905 Z"></path>
      </clipPath>
      <clipPath id="i3">
        <path d="M4.1253276,0 L6.9554352,2.82881318 L3.41673314,6.36748856 C3.04135155,6.74279008 2.53212434,6.95355356 2.001279,6.95343351 C1.47030021,6.95330001 0.96120645,6.74229633 0.585958309,6.36682133 C0.210710168,5.99133299 -0.000133381979,5.48215916 0,4.95127378 C0.000133508591,4.42038841 0.211110504,3.91130799 0.586625536,3.53600647 L4.1253276,0 Z"></path>
      </clipPath>
      <clipPath id="i4">
        <path d="M6.63007616,0 L9.63403551,3.00393102 L3.62610738,9.00811096 C3.22776103,9.40643842 2.68747453,9.6302911 2.12412299,9.6302911 C1.56077145,9.6302911 1.02049438,9.40643842 0.622138595,9.00811096 C0.223791303,8.60978349 0,8.06945923 0,7.50609824 C0,6.94273726 0.223791303,6.40250741 0.622138595,6.00417994 L6.63007616,0 Z"></path>
      </clipPath>
    </defs>
    <g clipPath="url(#i0)">
      <polygon points="0,0 45,0 45,45 0,45 0,0" stroke="none" fill="#02DE97"></polygon>
      <g clipPath="url(#i1)">
        <polygon points="0,0 45,0 45,45 0,45 0,0" stroke="none" fill="rgba(119, 119, 119, 0.35)"></polygon>
      </g>
      <g transform="translate(11.36958884732067 11.37009489232148)">
        <g transform="translate(5.759178816333588e-05 0.0)">
          <g clipPath="url(#i2)">
            <polygon
              points="0,0 22.2538329,0 22.2538329,22.2598102 0,22.2598102 0,0"
              stroke="none"
              fill="#F4F4F4"
            ></polygon>
          </g>
        </g>
        <g transform="translate(8.130710453091751 5.567336409342715)">
          <path
            d="M8.51064065,0 L0,8.51056512"
            stroke="#DDDDDD"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
        <g transform="translate(15.3053871045563 0.0)">
          <g clipPath="url(#i3)">
            <polygon
              points="-6.32456568e-08,0 6.9554352,0 6.9554352,6.95343356 -6.32456568e-08,6.95343356 -6.32456568e-08,0"
              stroke="none"
              fill="#F4F4F4"
            ></polygon>
          </g>
        </g>
        <g transform="translate(0.0 12.6287599596717)">
          <g clipPath="url(#i4)">
            <polygon
              points="0,0 9.63403551,0 9.63403551,9.6302911 0,9.6302911 0,0"
              stroke="none"
              fill="#50A4F8"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const ProductionIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="45px"
    height="45px"
    viewBox="0 0 45 45"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <title>Production</title>
    <defs>
      <circle id="path-1" cx="22.5" cy="22.5" r="22.5"></circle>
    </defs>
    <g id="Icon/Round/Production" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <mask id="mask-2" fill="white">
        <use xlinkHref="#path-1"></use>
      </mask>
      <use id="Oval" fill="#0D988B" xlinkHref="#path-1"></use>
      <path
        d="M22.5,0 C34.9264069,0 45,10.0735931 45,22.5 C45,34.9264069 34.9264069,45 22.5,45 C10.0735931,45 0,34.9264069 0,22.5 C0,10.0735931 10.0735931,0 22.5,0 Z M22.5,5.4 C13.0559308,5.4 5.4,13.0559308 5.4,22.5 C5.4,31.9440692 13.0559308,39.6 22.5,39.6 C31.9440692,39.6 39.6,31.9440692 39.6,22.5 C39.6,13.0559308 31.9440692,5.4 22.5,5.4 Z"
        id="Combined-Shape"
        fillOpacity="0.35"
        fill="#787878"
        mask="url(#mask-2)"
      ></path>
      <g id="Group" mask="url(#mask-2)">
        <g transform="translate(4.329051, 7.459822)">
          <g id="Group-13-Copy" transform="translate(21.723756, 4.500000)">
            <line
              x1="7.30848552"
              y1="34.5"
              x2="7.30848552"
              y2="8.85930289"
              id="Stroke-1"
              stroke="#C0F7E5"
              strokeWidth="1.5"
            ></line>
            <path
              d="M12.768344,8.85463973 L14.6181427,8.85463973 L14.6181427,10.7086563 C14.6181427,13.4624989 12.3856836,15.6949579 9.63184104,15.6949579 L7.7820424,15.6949579 L7.7820424,13.8409414 C7.7820424,11.0870988 10.0147358,8.85463973 12.768344,8.85463973"
              id="Fill-3"
              fill="#C0F7E5"
            ></path>
            <path
              d="M1.84956431,8.85463973 L0,8.85463973 L0,10.7086563 C0,13.4624989 2.2322247,15.6949579 4.98606731,15.6949579 L6.83586595,15.6949579 L6.83586595,13.8409414 C6.83586595,11.0870988 4.60340692,8.85463973 1.84956431,8.85463973"
              id="Fill-5"
              fill="#C0F7E5"
            ></path>
            <path
              d="M6.0139311,1.30990301 L7.32313112,0 L8.63209681,1.30990301 C10.575393,3.25905744 10.575393,6.41454115 8.63209681,8.36369558 L7.32313112,9.67359859 L6.0139311,8.36369558 C4.07040058,6.41454115 4.07040058,3.25905744 6.0139311,1.30990301"
              id="Fill-7"
              fill="#C0F7E5"
            ></path>
            <path
              d="M12.768344,16.4918429 L14.6181427,16.4918429 L14.6181427,18.3458595 C14.6181427,21.0997021 12.3856836,23.3321612 9.63184104,23.3321612 L7.7820424,23.3321612 L7.7820424,21.4781446 C7.7820424,18.724302 10.0147358,16.4918429 12.768344,16.4918429"
              id="Fill-9"
              fill="#C0F7E5"
            ></path>
            <path
              d="M1.84956431,16.4918429 L0,16.4918429 L0,18.3458595 C0,21.0997021 2.2322247,23.3321612 4.98606731,23.3321612 L6.83586595,23.3321612 L6.83586595,21.4781446 C6.83586595,18.724302 4.60340692,16.4918429 1.84956431,16.4918429"
              id="Fill-11"
              fill="#C0F7E5"
            ></path>
          </g>
          <g id="Group-13-Copy-2" transform="translate(0.000000, 4.500000)">
            <line
              x1="7.30848552"
              y1="34.5"
              x2="7.30848552"
              y2="8.85930289"
              id="Stroke-1"
              stroke="#C0F7E5"
              strokeWidth="1.5"
            ></line>
            <path
              d="M12.768344,8.85463973 L14.6181427,8.85463973 L14.6181427,10.7086563 C14.6181427,13.4624989 12.3856836,15.6949579 9.63184104,15.6949579 L7.7820424,15.6949579 L7.7820424,13.8409414 C7.7820424,11.0870988 10.0147358,8.85463973 12.768344,8.85463973"
              id="Fill-3"
              fill="#C0F7E5"
            ></path>
            <path
              d="M1.84956431,8.85463973 L0,8.85463973 L0,10.7086563 C0,13.4624989 2.2322247,15.6949579 4.98606731,15.6949579 L6.83586595,15.6949579 L6.83586595,13.8409414 C6.83586595,11.0870988 4.60340692,8.85463973 1.84956431,8.85463973"
              id="Fill-5"
              fill="#C0F7E5"
            ></path>
            <path
              d="M6.0139311,1.30990301 L7.32313112,0 L8.63209681,1.30990301 C10.575393,3.25905744 10.575393,6.41454115 8.63209681,8.36369558 L7.32313112,9.67359859 L6.0139311,8.36369558 C4.07040058,6.41454115 4.07040058,3.25905744 6.0139311,1.30990301"
              id="Fill-7"
              fill="#C0F7E5"
            ></path>
            <path
              d="M12.768344,16.4918429 L14.6181427,16.4918429 L14.6181427,18.3458595 C14.6181427,21.0997021 12.3856836,23.3321612 9.63184104,23.3321612 L7.7820424,23.3321612 L7.7820424,21.4781446 C7.7820424,18.724302 10.0147358,16.4918429 12.768344,16.4918429"
              id="Fill-9"
              fill="#C0F7E5"
            ></path>
            <path
              d="M1.84956431,16.4918429 L0,16.4918429 L0,18.3458595 C0,21.0997021 2.2322247,23.3321612 4.98606731,23.3321612 L6.83586595,23.3321612 L6.83586595,21.4781446 C6.83586595,18.724302 4.60340692,16.4918429 1.84956431,16.4918429"
              id="Fill-11"
              fill="#C0F7E5"
            ></path>
          </g>
          <g id="Group-13" transform="translate(9.251405, 0.000000)">
            <line
              x1="8.93645217"
              y1="39.097787"
              x2="8.91882978"
              y2="10.8113527"
              id="Stroke-1"
              stroke="#2D2D42"
              strokeWidth="2"
            ></line>
            <path
              d="M15.581708,10.805662 L17.8390894,10.805662 L17.8390894,13.0681907 C17.8390894,16.4288122 15.1147326,19.153169 11.7541111,19.153169 L9.49672971,19.153169 L9.49672971,16.8906403 C9.49672971,13.5300188 12.2213725,10.805662 15.581708,10.805662"
              id="Fill-3"
              fill="#2D2D42"
            ></path>
            <path
              d="M2.25709542,10.805662 L0,10.805662 L0,13.0681907 C0,16.4288122 2.72407082,19.153169 6.08469231,19.153169 L8.3420737,19.153169 L8.3420737,16.8906403 C8.3420737,13.5300188 5.61771691,10.805662 2.25709542,10.805662"
              id="Fill-5"
              fill="#2D2D42"
            ></path>
            <path
              d="M7.33903456,1.59852571 L8.93670239,0 L10.5340842,1.59852571 C12.9055643,3.97715484 12.9055643,7.82791462 10.5340842,10.2065438 L8.93670239,11.8050695 L7.33903456,10.2065438 C4.96726851,7.82791462 4.96726851,3.97715484 7.33903456,1.59852571"
              id="Fill-7"
              fill="#2D2D42"
            ></path>
            <path
              d="M15.581708,20.1256388 L17.8390894,20.1256388 L17.8390894,22.3881675 C17.8390894,25.748789 15.1147326,28.4731458 11.7541111,28.4731458 L9.49672971,28.4731458 L9.49672971,26.2106171 C9.49672971,22.8499956 12.2213725,20.1256388 15.581708,20.1256388"
              id="Fill-9"
              fill="#2D2D42"
            ></path>
            <path
              d="M2.25709542,20.1256388 L0,20.1256388 L0,22.3881675 C0,25.748789 2.72407082,28.4731458 6.08469231,28.4731458 L8.3420737,28.4731458 L8.3420737,26.2106171 C8.3420737,22.8499956 5.61771691,20.1256388 2.25709542,20.1256388"
              id="Fill-11"
              fill="#2D2D42"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const CropIcon = (props: ComponentProps<'svg'>) => (
  <svg version="1.1" width="100px" height="100px" viewBox="0 0 100.0 100.0" {...props}>
    <defs>
      <clipPath id="50481041181031144897102115">
        <path d="M50,0 C77.6142375,0 100,22.3857625 100,50 C100,77.6142375 77.6142375,100 50,100 C22.3857625,100 0,77.6142375 0,50 C0,22.3857625 22.3857625,0 50,0 Z"></path>
      </clipPath>
      <clipPath id="0103110103118118561200122">
        <path d="M14.4327959,0 L14.7863673,0.814285714 C14.7817581,0.816307278 14.7256472,0.841287698 14.6244099,0.891257663 L14.5083667,0.949632688 C13.5287685,1.4510474 10.1303565,3.39619946 7.00279588,7.64178571 C3.59958159,12.2617857 -0.210418407,20.4917857 1.14529588,34.1378571 L0.279581593,34.1564286 C-0.486132692,26.4510714 -0.042204121,15.6714286 6.32208159,7.06928571 C10.148153,1.89785714 14.2595816,0.075 14.4327959,0 Z"></path>
      </clipPath>
      <clipPath id="12154101571201219910750104">
        <path d="M17.5745602,0.00718423921 C17.9938459,-0.0746014751 18.171703,0.567184239 17.751703,0.649327096 C15.594203,1.0693271 13.466703,1.63646995 11.3863459,2.34611281 C8.62277446,3.28825567 5.93920303,4.47504138 3.39598875,5.91004138 C2.39956017,6.47254138 1.39670303,7.06039852 0.478131603,7.74611281 C0.134203031,8.00289852 -0.19722554,7.42468424 0.142060174,7.17111281 C0.453131603,6.93896995 0.779203031,6.72539852 1.10456017,6.5143271 C3.00277446,5.28468424 5.01991732,4.23396995 7.08634589,3.31861281 C10.4470602,1.82968424 13.9663459,0.709684239 17.5745602,0.00718423921 Z"></path>
      </clipPath>
      <clipPath id="9510501041211029911750116">
        <path d="M7.87366957,1.10518858 C11.2679553,0.215188575 14.8183124,-0.176597139 18.3225981,0.0748314326 C19.6908124,0.173045718 21.1215267,0.322331433 22.439741,0.728402861 C22.8486696,0.85447429 22.6733124,1.49697429 22.2625981,1.37054572 C21.8340267,1.23840286 21.3883124,1.15126 20.9479553,1.06911715 C18.414741,0.598760004 15.7658124,0.565545718 13.1911696,0.818045718 C8.76009815,1.25304572 4.45331243,2.63054572 0.503669575,4.66697429 C0.122955289,4.86340286 -0.213473282,4.28840286 0.167598146,4.09197429 C2.62081243,2.82697429 5.202241,1.80554572 7.87366957,1.10518858 Z"></path>
      </clipPath>
      <clipPath id="995557551081155510755104">
        <path d="M0.320224349,0.0821767931 C2.61808149,-0.0688946354 4.92701006,-0.0131803497 7.21308149,0.26181965 C10.2230815,0.623605365 13.1962958,1.33824822 16.0191529,2.44967679 C17.1362958,2.88967679 18.2762958,3.36717679 19.3041529,3.99646251 C19.6695101,4.22003394 19.3345101,4.79574822 18.9680815,4.57146251 C18.6337958,4.36681965 18.2812958,4.18896251 17.9305815,4.01467679 C15.8937958,3.00467679 13.7195101,2.26324822 11.5148672,1.71824822 C7.85951006,0.814676793 4.07629578,0.501105365 0.320224349,0.748248222 C-0.10834708,0.776462507 -0.105132794,0.110391079 0.320224349,0.0821767931 Z"></path>
      </clipPath>
      <clipPath id="12011350100100454811895108">
        <path d="M0.321429074,0.0119689132 C1.99428622,-0.0444596582 3.6700005,0.0991117703 5.31035765,0.432683199 C7.54607193,0.887683199 9.71535765,1.69839748 11.7121434,2.80161177 C12.5464291,3.2626832 13.3828576,3.76875463 14.1196434,4.37839748 C14.4503576,4.65196891 13.9767862,5.12054034 13.6489291,4.84911177 C13.6321434,4.83554034 13.6150005,4.82196891 13.5978576,4.80839748 L13.572007,4.78816217 C13.5570923,4.7767211 13.5144393,4.74380565 13.5003576,4.73339748 C13.3125005,4.59304034 13.1217862,4.45696891 12.9275005,4.3251832 C9.25357193,1.83196891 4.75535765,0.52911177 0.321429074,0.677683199 C-0.108213783,0.691968913 -0.106070926,0.0262546275 0.321429074,0.0119689132 Z"></path>
      </clipPath>
      <clipPath id="121561010555552101121108">
        <path d="M12.3209406,7.68736206 C12.2802263,7.6377192 12.2398691,7.58807634 12.1984406,7.53879063 C12.0484406,7.36057634 11.8927263,7.18664777 11.7337977,7.01593348 C10.5559406,5.7502192 9.20594057,4.64164777 7.75736914,3.7002192 C5.46879771,2.21307634 2.92129771,1.16736206 0.24022628,0.64914777 C-0.180845148,0.568076341 -0.00155943396,-0.0737093731 0.417011995,0.00700491266 C2.06486914,0.325576341 3.66594057,0.842004913 5.19415485,1.5352192 C7.27022628,2.47700491 9.19808342,3.74950491 10.8973691,5.26843348 C11.6080834,5.90379063 12.3062977,6.58236206 12.8887977,7.34057634 C12.9980834,7.48307634 12.9105834,7.71593348 12.769512,7.79629063 C12.5987977,7.89307634 12.4241549,7.8202192 12.3137977,7.67664777 L12.3372067,7.7074037 Z"></path>
      </clipPath>
      <clipPath id="51531031111061225411949104">
        <path d="M6.90563747,0.144209523 C10.0267089,-0.163290477 13.1992089,0.0256380942 16.2681375,0.66635238 C17.5284946,0.929566666 18.8177803,1.24349524 20.0106375,1.73920952 C20.4013518,1.90170952 20.2288518,2.54563809 19.8334946,2.38135238 C19.4381375,2.21706667 19.0274232,2.08528095 18.6188518,1.95849524 C16.3274232,1.24635238 13.934566,0.845280951 11.5409946,0.713495237 C7.76706605,0.505638094 3.9817089,1.00528095 0.405994618,2.23599524 C-0.000791096508,2.37599524 -0.174005382,1.73242381 0.228851761,1.59385238 C2.38992319,0.850280951 4.63135176,0.368138094 6.90563747,0.144209523 Z"></path>
      </clipPath>
      <clipPath id="55531101181021081189711951">
        <path d="M0.220604025,0.668622455 C-0.170467403,0.506836741 0.0020325968,-0.137448973 0.397746883,0.0264795982 C1.52024688,0.491122455 2.53417545,1.15755103 3.40560403,2.00540817 C4.70810403,3.27326531 5.65346117,4.86612246 6.32488974,6.54505103 C6.63846117,7.3289796 6.9195326,8.15290817 7.06774688,8.98683674 C7.14238974,9.4064796 6.50060403,9.58505103 6.42560403,9.1639796 C6.37774688,8.8939796 6.30774688,8.62683674 6.23524688,8.36255103 C5.35810403,5.16433674 3.39274688,1.98183674 0.220604025,0.668622455 Z"></path>
      </clipPath>
      <clipPath id="11512211112212210750117115114">
        <path d="M0.17153632,0.610592282 C-0.216320823,0.427377997 0.122250605,-0.146907718 0.507607748,0.0352351394 C1.77082203,0.632377997 2.98796489,1.32273514 4.14475061,2.10666371 C5.66225061,3.13594943 7.08546489,4.317378 8.34832203,5.64809228 C8.84689346,6.17344943 9.34260775,6.72273514 9.75689346,7.31916371 C10.0022506,7.672378 9.42475061,8.004878 9.18189346,7.65523514 C9.02046489,7.42309228 8.98796489,7.39023514 8.79617918,7.15630657 C6.49617918,4.35059228 3.43582203,2.15344943 0.17153632,0.610592282 Z"></path>
      </clipPath>
      <clipPath id="11895991101215510110498116">
        <path d="M9.60199419,0 L10.311637,0.533571429 C10.2827085,0.5725 7.36592276,4.49857143 4.80985133,11.6189286 C2.45199419,18.1875 -0.110862952,28.7557143 1.25199419,42.4728571 L0.386279905,42.4914286 C-0.995148666,28.5896429 1.59199419,17.9417857 3.98806562,11.2803571 C6.25902666,4.96711039 8.74950694,1.20485679 9.42737699,0.241914966 L9.55790578,0.0596422089 C9.56544029,0.0493366792 9.57211457,0.04025511 9.57791026,0.0323997467 L9.60199419,0 Z"></path>
      </clipPath>
      <clipPath id="97535095511161211215751">
        <path d="M8.24241796,0.136708632 C8.50098938,-0.203291368 9.06098938,0.157065774 8.80206081,0.49778006 C7.47241796,2.2481372 6.2627751,4.08778006 5.18313224,6.00242292 C3.74920367,8.5456372 2.53706081,11.2181372 1.59563224,13.9824229 C1.22670367,15.0652801 0.869917956,16.1717086 0.641346527,17.2949229 C0.555632242,17.7156372 -0.0768677583,17.5049229 0.0077750988,17.0899229 C0.0849179559,16.7095658 0.185989385,16.3331372 0.288489385,15.9588515 C0.885632242,13.7774229 1.69098938,11.6502801 2.62313224,9.59135149 C4.13884653,6.24278006 6.01848938,3.06385149 8.24241796,0.136708632 Z"></path>
      </clipPath>
      <clipPath id="1140107545312011711611499">
        <path d="M14.3998734,0.0328754818 C14.788802,-0.145338804 15.0859449,0.450732625 14.6955877,0.629661196 C14.2877306,0.816804053 13.8970163,1.04823262 13.513802,1.28073262 C11.3105877,2.61644691 9.31237343,4.35573262 7.55987343,6.25858977 C4.54344486,9.53358977 2.24808771,13.4289469 0.657373428,17.5785898 C0.504159142,17.9782326 -0.129769429,17.7735898 0.0238019996,17.3732326 C1.01165914,14.7957326 2.25737343,12.3146612 3.783802,10.0132326 C5.72344486,7.08930405 8.111302,4.43287548 10.8930877,2.28680405 C11.9791591,1.44894691 13.1459449,0.607875482 14.3998734,0.0328754818 Z"></path>
      </clipPath>
      <clipPath id="9753105120116981021225657">
        <path d="M16.8684492,0.00621278996 C17.2898778,-0.0702157815 17.4234492,0.582284219 17.000592,0.659069933 C16.6148778,0.729069933 16.2334492,0.830855647 15.8559492,0.934427076 C13.6634492,1.53728422 11.5477349,2.43228422 9.5402349,3.49371279 C6.21130633,5.25335565 3.1802349,7.53871279 0.542734899,10.2244271 C0.242020613,10.5308556 -0.199407958,10.0315699 0.0995206134,9.72728422 C1.7127349,8.08478422 3.47237776,6.58871279 5.36130633,5.27121279 C7.8477349,3.53692708 10.5416635,2.0904985 13.3877349,1.03978422 C14.5141635,0.624069933 15.6827349,0.22121279 16.8684492,0.00621278996 Z"></path>
      </clipPath>
      <clipPath id="45531211071161055610448121">
        <path d="M13.1640192,0.670867012 C13.1524157,0.67206508 13.0987131,0.675796859 13.0811621,0.677429512 C12.8475906,0.697786655 12.6143764,0.72350094 12.3818764,0.754215226 C7.98080493,1.34100094 3.75759064,3.36421523 0.548662072,6.42778665 C0.237590643,6.72457237 -0.204195071,6.22635808 0.105090643,5.93100094 C1.31580493,4.77528665 2.66151921,3.76600094 4.10759064,2.92278665 C6.07830493,1.77350094 8.23651921,0.93350094 10.4604478,0.427072369 C11.3904478,0.215286655 12.3511621,0.0363580831 13.3068764,0.000286654536 C13.7358049,-0.015784774 13.6943764,0.649215226 13.2690192,0.665286655 C13.2472335,0.66600094 13.2258049,0.667072369 13.2040192,0.66850094 C13.1772335,0.669929512 13.1508049,0.671715226 13.1240192,0.67350094 Z"></path>
      </clipPath>
      <clipPath id="1161189910610911554103102101">
        <path d="M14.176,0.858 L14.1633357,0.856790273 C14.0997643,0.847147416 14.03655,0.836790273 13.9729786,0.827504559 C13.7422643,0.794647416 13.5101214,0.768575988 13.2779786,0.746790273 C11.55655,0.586790273 9.81083572,0.658933131 8.10333572,0.921075988 C5.40583572,1.33571884 2.80905,2.25179027 0.463692861,3.65107599 C0.0954785757,3.87071884 -0.198092853,3.27250456 0.167978576,3.05393313 C1.60940715,2.19393313 3.14762143,1.51321884 4.74940715,1.0128617 C6.92547858,0.332861702 9.21083572,-0.00142401225 11.4901214,0 C12.4436929,0.000718844888 13.4161929,0.0425045592 14.3558357,0.220004559 C14.5322643,0.253218845 14.6219071,0.485361702 14.5701214,0.639290273 C14.5076214,0.825361702 14.3286929,0.887147416 14.1508357,0.853575988 L14.176,0.858 Z"></path>
      </clipPath>
      <clipPath id="10650121521211151089511857">
        <path d="M14.9004252,0.0208687238 C15.300068,-0.118059848 15.6004252,0.476940152 15.1961395,0.617654438 C14.7914966,0.758725867 14.3972109,0.933725867 14.0079252,1.11122587 C11.8243538,2.10586872 9.7722109,3.40015444 7.89863947,4.89551158 C4.9447109,7.25336872 2.45363947,10.1469402 0.605425183,13.4462259 C0.39506804,13.821583 -0.16243196,13.4569402 0.0457823259,13.0851544 C1.16256804,11.0912259 2.51399661,9.23908301 4.06149661,7.55765444 C6.18506804,5.2497973 8.67756804,3.27801158 11.3939966,1.71265444 C12.5093538,1.0697973 13.6804252,0.445511581 14.9004252,0.0208687238 Z"></path>
      </clipPath>
      <clipPath id="555795112571135711752121">
        <path d="M3.34933135,5.78696716e-06 L3.75362931,0.0089720813 C5.56970074,0.0875435099 7.33541503,0.646114938 8.95470074,1.45147208 C9.71041503,1.82754351 10.4686293,2.25540065 11.1347007,2.77861494 C11.4700579,3.04218637 11.1100579,3.60254351 10.7736293,3.3382578 C10.557915,3.16897208 10.327915,3.01611494 10.097915,2.86718637 C7.31398646,1.06540065 3.72827217,-0.000313632982 0.487200742,1.13254351 C0.0879150274,1.27218637 -0.212442115,0.676829224 0.191843599,0.535400653 C1.33862931,0.134686367 2.53898646,-0.0435279187 3.75362931,0.0089720813 Z"></path>
      </clipPath>
      <clipPath id="9555511101161039811811049">
        <path d="M4.34201538,0.238442989 C6.15951538,-0.00441415385 8.00808681,-0.0708427253 9.8363011,0.0813001319 C10.5580868,0.141300132 11.2938011,0.220585846 11.9998725,0.38987156 C12.4180868,0.490228703 12.2088011,1.1227287 11.7948725,1.02344299 C11.5195154,0.957728703 11.473444,0.95487156 11.1745154,0.908085846 C7.59022967,0.346300132 3.84415824,0.745228703 0.381301099,1.76808585 C-0.0297703294,1.88951442 -0.159770329,1.23594299 0.249158242,1.1152287 C1.58915824,0.719514418 2.95701538,0.423442989 4.34201538,0.238442989 Z"></path>
      </clipPath>
      <clipPath id="1204910348116455510753103">
        <path d="M0.18066887,0.3161789 C0.217811727,-0.109535386 0.883883156,-0.103463957 0.846740299,0.322964614 C0.656026013,2.51260747 0.614954585,4.71403604 0.723526013,6.90939319 C0.867811727,9.82546461 1.2692403,12.7322503 1.94781173,15.5726075 C2.21388316,16.6854646 2.50245458,17.811536 2.90852601,18.8833218 C3.06066887,19.2847503 2.41316887,19.444036 2.26316887,19.0479646 C2.12566887,18.6851075 2.01031173,18.3126075 1.89709744,17.941536 C1.23816887,15.7783218 0.783883156,13.5493932 0.473526013,11.3108218 C-0.0314739869,7.67010747 -0.138259701,3.97832176 0.18066887,0.3161789 Z"></path>
      </clipPath>
      <clipPath id="5653112501225311151107100">
        <path d="M3.6610899,0.151125778 C3.89501848,-0.207445651 4.46430419,0.138625778 4.22966133,0.498268635 C3.98466133,0.87398292 3.77751848,1.27826863 3.57751848,1.67898292 C2.42716133,3.98469721 1.66537562,6.52184006 1.1985899,9.06648292 C0.395375618,13.4457686 0.532875618,17.9654115 1.40180419,22.3232686 C1.48573276,22.7432686 0.840375618,22.9082686 0.756447047,22.4879115 C0.216447047,19.7807686 -0.0539100963,17.0179115 0.00894704658,14.2568401 C0.0889470466,10.7489829 0.690732761,7.22791149 1.89823276,3.92862578 C2.36966133,2.64041149 2.90751848,1.30648292 3.6610899,0.151125778 Z"></path>
      </clipPath>
      <clipPath id="4551112114118951119510995">
        <path d="M9.00300459,0.0895487362 C9.31871888,-0.200094121 9.77979031,0.280620165 9.46300459,0.570977308 C9.17443316,0.835977308 8.90586173,1.12562016 8.64229031,1.41490588 C7.10979031,3.09454874 5.79800459,4.98026302 4.66657602,6.94954874 C2.79050459,10.2141916 1.44657602,13.7645487 0.649076019,17.4431202 C0.558004591,17.862763 -0.0816382662,17.6763345 0.00871887661,17.2595487 C0.496576019,15.0091916 1.18657602,12.805263 2.08086173,10.6831202 C3.25836173,7.88954874 4.76443316,5.22847731 6.61086173,2.82133445 C7.34157602,1.86812016 8.11479031,0.904191593 9.00300459,0.0895487362 Z"></path>
      </clipPath>
      <clipPath id="10811410111310598116121120101">
        <path d="M8.01144449,0.057745249 C8.36537306,-0.184754751 8.68537306,0.399888106 8.33430164,0.640245249 C8.31644449,0.652388106 8.29858735,0.665245249 8.28108735,0.677745249 L8.25951925,0.693191938 C8.26292408,0.690937669 8.19940368,0.737439127 8.18180164,0.750959535 C7.99537306,0.892745249 7.81180164,1.03881668 7.63180164,1.18917382 C4.22251592,4.03381668 1.73037306,7.99845953 0.651444493,12.302031 C0.547158779,12.7188167 -0.0928412214,12.5331024 0.0114444929,12.1184595 C0.41858735,10.4948881 1.01823021,8.92345953 1.79108735,7.43845953 C2.84430164,5.41488811 4.22144449,3.55274525 5.83215878,1.93774525 C6.50537306,1.26238811 7.22251592,0.598102392 8.01144449,0.057745249 Z"></path>
      </clipPath>
      <clipPath id="119111955255045981140">
        <path d="M10.752,0.636 C10.7349398,0.643738237 10.7195899,0.650181386 10.7027532,0.657528325 C10.6441818,0.682885468 10.5848961,0.708242611 10.5263246,0.734314039 C10.3134675,0.829314039 10.1034675,0.931099754 9.89561035,1.03681404 C8.35453892,1.82002832 6.91668178,2.81252832 5.61239607,3.94574261 C3.55203892,5.73574261 1.84489607,7.89609975 0.608110351,10.3310998 C0.413824637,10.7132426 -0.153675363,10.3639569 0.0395389228,9.9839569 C0.799538923,8.48752832 1.73703892,7.09109975 2.82489607,5.81288547 C4.30239607,4.07681404 6.05668178,2.57431404 7.98525321,1.35931404 C8.79203892,0.851099754 9.63668178,0.367171182 10.5259675,0.0160997535 C10.6927532,-0.0499716751 10.8927532,0.0985997535 10.9309675,0.256456896 C10.9773961,0.446814039 10.8591818,0.595028325 10.6906104,0.661456896 C10.7065797,0.655130366 10.7194369,0.650006459 10.7295733,0.645945651 L10.752,0.636 Z"></path>
      </clipPath>
      <clipPath id="98113511181015510910297118">
        <path d="M5.63060974,0.134346781 C5.89418117,-0.196367505 6.46596688,0.146846781 6.19918117,0.481489638 C5.93203831,0.816489638 5.69239545,1.17506107 5.45775259,1.53256107 C4.14203831,3.53898964 3.09703831,5.7286325 2.31060974,7.9936325 C1.07060974,11.5636325 0.507752595,15.3404182 0.705609737,19.1168468 C0.727752595,19.5464896 0.061681166,19.5354182 0.039181166,19.1100611 C-0.0801045483,16.8275611 0.074181166,14.5400611 0.485609737,12.2922039 C1.05025259,9.20756107 2.10632402,6.20970392 3.56810974,3.4361325 C4.16846688,2.29756107 4.82525259,1.14470392 5.63060974,0.134346781 Z"></path>
      </clipPath>
      <clipPath id="57118121119975698499549">
        <path d="M7.96908902,0.0889070095 C8.80873188,0.00354986663 9.67837474,-0.0393072762 10.5208747,0.0478355809 C10.9448033,0.0917641523 10.9398033,0.757835581 10.514089,0.713907009 C10.2412319,0.685692724 9.96516045,0.678907009 9.69123188,0.676049867 C6.37516045,0.637835581 2.77408902,1.64997844 0.63766045,4.33747844 C0.374446164,4.66890701 -0.19733955,4.32533558 0.0690890214,3.99033558 C0.82516045,3.03926415 1.74551759,2.24819272 2.80051759,1.64426415 C4.37837474,0.741407009 6.16980331,0.271764152 7.96908902,0.0889070095 Z"></path>
      </clipPath>
      <clipPath id="501091219710249104104120106">
        <path d="M9.6387597,0.0193408407 C10.0459026,-0.119230588 10.2062597,0.527555126 9.80340256,0.664697984 C9.53554541,0.755769412 9.49483113,0.778269412 9.21733113,0.897912269 C5.8862597,2.33576941 2.93090256,4.67219798 0.548045414,7.38469798 C0.265188271,7.70684084 -0.193383158,7.22362656 0.0880454138,6.90326941 C1.01018827,5.85362656 2.00911684,4.87362656 3.08161684,3.97791227 C4.48911684,2.80255513 6.01697399,1.76005513 7.64411684,0.912912269 C8.28661684,0.578269412 8.9512597,0.252912269 9.6387597,0.0193408407 Z"></path>
      </clipPath>
      <clipPath id="10711397531165697095107">
        <path d="M0,0 C18.1382143,0.88 19.4339286,15.3917857 19.4339286,15.3917857 C12.6321429,5.265 0,0 0,0 Z"></path>
      </clipPath>
      <clipPath id="102106971061111185598116121">
        <path d="M0,0 C13.6082143,0.660357143 14.5803571,11.5478571 14.5803571,11.5478571 C9.47714286,3.95 0,0 0,0 Z"></path>
      </clipPath>
      <clipPath id="10410552115111110505110057">
        <path d="M0,0.45733243 C8.71857143,-1.77766757 11.4535714,4.90554672 11.4535714,4.90554672 C6.75178571,1.10411814 0,0.45733243 0,0.45733243 Z"></path>
      </clipPath>
      <clipPath id="509748100108118114106112110">
        <path d="M19.0164286,0 C19.0164286,0 6.65571429,5.15178571 0,15.0610714 C0,15.0610714 0.00202857143,15.0383514 0.00705933714,14.9946739 L0.0169788343,14.9136598 C0.211473429,13.4050916 2.33277143,0.809407143 19.0164286,0 Z"></path>
      </clipPath>
      <clipPath id="11210912098122565012211249">
        <path d="M0,0 C13.3517857,4.22928571 11.4592857,15.3053571 11.4592857,15.3053571 C8.38214286,6.41428571 0,0 0,0 Z"></path>
      </clipPath>
      <clipPath id="117104119103106481204851113">
        <path d="M14.8060714,0 C14.8060714,0 5.18214286,4.01107143 0,11.7264286 C0,11.7264286 0.987142857,0.670357143 14.8060714,0 Z"></path>
      </clipPath>
      <clipPath id="10895991015410810210412153">
        <path d="M13.8267857,5.69083067 C13.8267857,5.69083067 13.6486942,5.56660331 13.3191811,5.35809844 L13.103516,5.22320182 C11.1973428,4.04417424 5.78360656,1.03348289 0,0.891187811 C0,0.891187811 7.63821429,-3.06416933 13.8267857,5.69083067 Z"></path>
      </clipPath>
      <clipPath id="1081195199491111221205752">
        <path d="M0,0 C0,0 8.08642857,2.93178571 5.84857143,13.4167857 C5.84857143,13.4167857 4.75214286,5.41178571 0,0 Z"></path>
      </clipPath>
      <clipPath id="491201115554113561069950">
        <path d="M1.50399231,0 L2.3222066,0.344642857 C-2.86243626,12.6535714 7.84613517,36.2292857 7.95506374,36.4660714 L6.99077803,36.4846429 C6.96327803,36.4246429 4.36934946,30.7553571 2.30899231,23.2664286 C-0.471364829,13.1607143 -0.742079115,5.3325 1.50399231,0 Z"></path>
      </clipPath>
    </defs>
    <g clipPath="url(#50481041181031144897102115)">
      <polygon points="0,0 100,0 100,100 0,100 0,0" stroke="none" fill="#086B61"></polygon>
    </g>
    <g transform="translate(20.178571428571416 20.0)">
      <g transform="translate(0.7021997012107271 0.19680308959798154)">
        <g transform="translate(21.292346978095473 25.646768338973438)">
          <g clipPath="url(#0103110103118118561200122)">
            <polygon
              points="-6.66133815e-16,0 14.7863673,0 14.7863673,34.1564286 -6.66133815e-16,34.1564286 -6.66133815e-16,0"
              stroke="none"
              fill="#FBFBB8"
            ></polygon>
          </g>
        </g>
        <g transform="translate(35.59168982578352 18.595369814046066)">
          <g clipPath="url(#12154101571201219910750104)">
            <polygon
              points="1.38777878e-15,-2.44249065e-15 17.9915456,-2.44249065e-15 17.9915456,7.81042465 1.38777878e-15,7.81042465 1.38777878e-15,-2.44249065e-15"
              stroke="none"
              fill="#F9FF1A"
            ></polygon>
          </g>
        </g>
        <g transform="translate(35.566116139484635 21.674544049271987)">
          <g clipPath="url(#9510501041211029911750116)">
            <polygon
              points="-1.77635684e-15,9.02056208e-16 22.6723416,9.02056208e-16 22.6723416,4.70728073 -1.77635684e-15,4.70728073 -1.77635684e-15,9.02056208e-16"
              stroke="none"
              fill="#F8F8E3"
            ></polygon>
          </g>
        </g>
        <g transform="translate(35.581382794303615 25.63873440298488)">
          <g clipPath="url(#995557551081155510755104)">
            <polygon
              points="1.11022302e-16,9.99200722e-16 19.461982,9.99200722e-16 19.461982,4.62240482 1.11022302e-16,4.62240482 1.11022302e-16,9.99200722e-16"
              stroke="none"
              fill="#F8F8E3"
            ></polygon>
          </g>
        </g>
        <g transform="translate(35.58046378348407 25.709227997215578)">
          <g clipPath="url(#12011350100100454811895108)">
            <polygon
              points="0,2.33146835e-15 14.2319104,2.33146835e-15 14.2319104,4.93087359 0,4.93087359 0,2.33146835e-15"
              stroke="none"
              fill="#FBFBB8"
            ></polygon>
          </g>
        </g>
        <g transform="translate(35.5560237196765 25.762049140597867)">
          <g clipPath="url(#121561010555552101121108)">
            <polygon
              points="1.05471187e-15,7.72819309e-16 12.9379719,7.72819309e-16 12.9379719,7.84034719 1.05471187e-15,7.84034719 1.05471187e-15,7.72819309e-16"
              stroke="none"
              fill="#D5C4BC"
            ></polygon>
          </g>
        </g>
        <g transform="translate(35.584326810793385 24.13902310188412)">
          <g clipPath="url(#51531031111061225411949104)">
            <polygon
              points="-8.32667268e-17,-1.99840144e-15 20.2309857,-1.99840144e-15 20.2309857,2.40794989 -8.32667268e-17,2.40794989 -8.32667268e-17,-1.99840144e-15"
              stroke="none"
              fill="#F9FF1A"
            ></polygon>
          </g>
        </g>
        <g transform="translate(35.58743168891007 25.717610169339153)">
          <g clipPath="url(#55531101181021081189711951)">
            <polygon
              points="-2.33146835e-15,-8.95117314e-16 7.07377495,-8.95117314e-16 7.07377495,9.40438797 -2.33146835e-15,9.40438797 -2.33146835e-15,-8.95117314e-16"
              stroke="none"
              fill="#FBFBB8"
            ></polygon>
          </g>
        </g>
        <g transform="translate(35.562320823221086 25.73110462817153)">
          <g clipPath="url(#11512211112212210750117115114)">
            <polygon
              points="-2.10942375e-15,2.51881849e-15 9.8163718,2.51881849e-15 9.8163718,7.80359373 -2.10942375e-15,7.80359373 -2.10942375e-15,2.51881849e-15"
              stroke="none"
              fill="#F8F8E3"
            ></polygon>
          </g>
        </g>
        <g transform="translate(21.185648666067742 17.311768338973437)">
          <g clipPath="url(#11895991101215510110498116)">
            <polygon
              points="9.43689571e-16,0 10.311637,0 10.311637,42.4914286 9.43689571e-16,42.4914286 9.43689571e-16,0"
              stroke="none"
              fill="#FBFBB8"
            ></polygon>
          </g>
        </g>
        <g transform="translate(30.50118918691365 0.28352399311522447)">
          <g clipPath="url(#97535095511161211215751)">
            <polygon
              points="4.98732999e-16,4.60742555e-15 8.86881652,4.60742555e-15 8.86881652,17.5244506 4.98732999e-16,17.5244506 4.98732999e-16,4.60742555e-15"
              stroke="none"
              fill="#F9FF1A"
            ></polygon>
          </g>
        </g>
        <g transform="translate(30.48509085756516 0.0)">
          <g clipPath="url(#1140107545312011711611499)">
            <polygon
              points="-3.78169718e-16,-8.8817842e-16 14.8788466,-8.8817842e-16 14.8788466,17.7948258 -3.78169718e-16,17.7948258 -3.78169718e-16,-8.8817842e-16"
              stroke="none"
              fill="#F8F8E3"
            ></polygon>
          </g>
        </g>
        <g transform="translate(30.504622243761993 7.500019834729555)">
          <g clipPath="url(#9753105120116981021225657)">
            <polygon
              points="-1.73472348e-15,-4.5519144e-15 17.2588415,-4.5519144e-15 17.2588415,10.320336 -1.73472348e-15,10.320336 -1.73472348e-15,-4.5519144e-15"
              stroke="none"
              fill="#F8F8E3"
            ></polygon>
          </g>
        </g>
        <g transform="translate(30.498945070824334 11.29644597015216)">
          <g clipPath="url(#45531211071161055610448121)">
            <polygon
              points="9.29811783e-16,-4.77395901e-15 13.6089937,-4.77395901e-15 13.6089937,6.51888535 9.29811783e-16,6.51888535 9.29811783e-16,-4.77395901e-15"
              stroke="none"
              fill="#FBFBB8"
            ></polygon>
          </g>
        </g>
        <g transform="translate(30.521199995706816 14.161942351227804)">
          <g clipPath="url(#1161189910610911554103102101)">
            <polygon
              points="1.05471187e-15,-4.53018192e-06 14.5846974,-4.53018192e-06 14.5846974,3.69875326 1.05471187e-15,3.69875326 1.05471187e-15,-4.53018192e-06"
              stroke="none"
              fill="#D5C4BC"
            ></polygon>
          </g>
        </g>
        <g transform="translate(30.50014624550777 4.2101139008843615)">
          <g clipPath="url(#10650121521211151089511857)">
            <polygon
              points="1.08940634e-15,-3.66373598e-15 15.3879696,-3.66373598e-15 15.3879696,13.6040448 1.08940634e-15,13.6040448 1.08940634e-15,-3.66373598e-15"
              stroke="none"
              fill="#F9FF1A"
            ></polygon>
          </g>
        </g>
        <g transform="translate(30.489692115428248 16.653689114812465)">
          <g clipPath="url(#555795112571135711752121)">
            <polygon
              points="4.16333634e-16,9.88792381e-16 11.2686428,9.88792381e-16 11.2686428,3.40737392 4.16333634e-16,3.40737392 4.16333634e-16,9.88792381e-16"
              stroke="none"
              fill="#FBFBB8"
            ></polygon>
          </g>
        </g>
        <g transform="translate(30.51048461511074 16.034361064253567)">
          <g clipPath="url(#9555511101161039811811049)">
            <polygon
              points="6.38378239e-16,-2.01227923e-15 12.2280159,-2.01227923e-15 12.2280159,1.78305605 6.38378239e-16,1.78305605 6.38378239e-16,-2.01227923e-15"
              stroke="none"
              fill="#F8F8E3"
            ></polygon>
          </g>
        </g>
        <g transform="translate(13.794045415484113 4.766125153141994)">
          <g clipPath="url(#1204910348116455510753103)">
            <polygon
              points="9.43689571e-16,4.82947016e-15 2.93150691,4.82947016e-15 2.93150691,19.2767309 9.43689571e-16,19.2767309 9.43689571e-16,4.82947016e-15"
              stroke="none"
              fill="#F9FF1A"
            ></polygon>
          </g>
        </g>
        <g transform="translate(15.300660096275879 1.3263211327861164)">
          <g clipPath="url(#5653112501225311151107100)">
            <polygon
              points="-5.98479599e-16,4.60742555e-15 4.28526666,4.60742555e-15 4.28526666,22.7325517 -5.98479599e-16,22.7325517 -5.98479599e-16,4.60742555e-15"
              stroke="none"
              fill="#F8F8E3"
            ></polygon>
          </g>
        </g>
        <g transform="translate(16.05103112338579 6.380469602802675)">
          <g clipPath="url(#4551112114118951119510995)">
            <polygon
              points="5.34294831e-16,-1.55431223e-15 9.56945474,-1.55431223e-15 9.56945474,17.6798658 5.34294831e-16,17.6798658 5.34294831e-16,-1.55431223e-15"
              stroke="none"
              fill="#F8F8E3"
            ></polygon>
          </g>
        </g>
        <g transform="translate(16.048484078577147 11.521594518588113)">
          <g clipPath="url(#10811410111310598116121120101)">
            <polygon
              points="3.1918912e-16,-1.88737914e-15 8.48633169,-1.88737914e-15 8.48633169,12.5369314 3.1918912e-16,12.5369314 3.1918912e-16,-1.88737914e-15"
              stroke="none"
              fill="#FBFBB8"
            ></polygon>
          </g>
        </g>
        <g transform="translate(16.0862825057393 13.600775728310719)">
          <g clipPath="url(#119111955255045981140)">
            <polygon
              points="7.56339436e-16,-2.49800181e-15 10.9411335,-2.49800181e-15 10.9411335,10.4965201 7.56339436e-16,10.4965201 7.56339436e-16,-2.49800181e-15"
              stroke="none"
              fill="#D5C4BC"
            ></polygon>
          </g>
        </g>
        <g transform="translate(16.007461691147007 4.618350129606464)">
          <g clipPath="url(#98113511181015510910297118)">
            <polygon
              points="-5.55111512e-16,-1.83186799e-15 6.26842938,-1.83186799e-15 6.26842938,19.4341139 -5.55111512e-16,19.4341139 -5.55111512e-16,-1.83186799e-15"
              stroke="none"
              fill="#F9FF1A"
            ></polygon>
          </g>
        </g>
        <g transform="translate(16.035625264265565 19.575968472346172)">
          <g clipPath="url(#57118121119975698499549)">
            <polygon
              points="6.52256027e-16,1.10328413e-15 10.8361133,1.10328413e-15 10.8361133,4.4722009 6.52256027e-16,4.4722009 6.52256027e-16,1.10328413e-15"
              stroke="none"
              fill="#FBFBB8"
            ></polygon>
          </g>
        </g>
        <g transform="translate(16.061776014734548 16.587713212511723)">
          <g clipPath="url(#501091219710249104104120106)">
            <polygon
              points="4.4408921e-16,-1.55431223e-15 10.0367543,-1.55431223e-15 10.0367543,7.49095746 4.4408921e-16,7.49095746 4.4408921e-16,-1.55431223e-15"
              stroke="none"
              fill="#F8F8E3"
            ></polygon>
          </g>
        </g>
        <g transform="translate(2.148107142857043 33.52398262468772)">
          <g clipPath="url(#10711397531165697095107)">
            <polygon
              points="0,0 19.4339286,0 19.4339286,15.3917857 0,15.3917857 0,0"
              stroke="none"
              fill="#07BA92"
            ></polygon>
          </g>
        </g>
        <g transform="translate(0.0 23.26176833897344)">
          <g clipPath="url(#102106971061111185598116121)">
            <polygon
              points="0,0 14.5803571,0 14.5803571,11.5478571 0,11.5478571 0,0"
              stroke="none"
              fill="#07BA92"
            ></polygon>
          </g>
        </g>
        <g transform="translate(6.138214285714253 44.010257337305745)">
          <g clipPath="url(#10410552115111110505110057)">
            <polygon
              points="0,0 11.4535714,0 11.4535714,4.90554672 0,4.90554672 0,0"
              stroke="none"
              fill="#07BA92"
            ></polygon>
          </g>
        </g>
        <g transform="translate(15.0265357142858 20.644161196116293)">
          <g clipPath="url(#509748100108118114106112110)">
            <polygon
              points="0,0 19.0164286,0 19.0164286,15.0610714 0,15.0610714 0,0"
              stroke="none"
              fill="#02DE97"
            ></polygon>
          </g>
        </g>
        <g transform="translate(12.360035714285527 18.13591119611629)">
          <g clipPath="url(#11210912098122565012211249)">
            <polygon
              points="0,0 11.5516085,0 11.5516085,15.3053571 0,15.3053571 0,0"
              stroke="none"
              fill="#07BA92"
            ></polygon>
          </g>
        </g>
        <g transform="translate(22.47735714285748 37.18912548183057)">
          <g clipPath="url(#117104119103106481204851113)">
            <polygon
              points="0,0 14.8060714,0 14.8060714,11.7264286 0,11.7264286 0,0"
              stroke="none"
              fill="#02DE97"
            ></polygon>
          </g>
        </g>
        <g transform="translate(25.54332142857156 29.118616242440112)">
          <g clipPath="url(#10895991015410810210412153)">
            <polygon
              points="0,-1.88737914e-15 13.8267857,-1.88737914e-15 13.8267857,5.69083067 0,5.69083067 0,-1.88737914e-15"
              stroke="none"
              fill="#02DE97"
            ></polygon>
          </g>
        </g>
        <g transform="translate(25.703285714285563 14.966161196116293)">
          <g clipPath="url(#1081195199491111221205752)">
            <polygon
              points="0,0 6.24006307,0 6.24006307,13.4167857 0,13.4167857 0,0"
              stroke="none"
              fill="#02DE97"
            ></polygon>
          </g>
        </g>
        <g transform="translate(14.48279340083186 23.318554053259156)">
          <g clipPath="url(#491201115554113561069950)">
            <polygon
              points="1.33226763e-15,0 7.95506374,0 7.95506374,36.4846429 1.33226763e-15,36.4846429 1.33226763e-15,0"
              stroke="none"
              fill="#FBFBB8"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const QuestionIcon = (props: ComponentProps<'svg'>) => (
  <svg version="1.1" width="45px" height="45px" viewBox="0 0 45.0 45.0" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval" fill="#50A5F9" cx="22.5" cy="22.5" r="22.5"></circle>
      <path
        d="M22.5,0 C34.9264069,0 45,10.0735931 45,22.5 C45,34.9264069 34.9264069,45 22.5,45 C10.0735931,45 0,34.9264069 0,22.5 C0,10.0735931 10.0735931,0 22.5,0 Z M22.5,5.4 C13.0559308,5.4 5.4,13.0559308 5.4,22.5 C5.4,31.9440692 13.0559308,39.6 22.5,39.6 C31.9440692,39.6 39.6,31.9440692 39.6,22.5 C39.6,13.0559308 31.9440692,5.4 22.5,5.4 Z"
        id="Combined-Shape"
        fillOpacity="0.2"
        fill="#787878"
      ></path>
      <circle id="Oval-Copy-2" fillOpacity="0.197532814" fill="#FFFFFF" cx="22.5" cy="22.5" r="13.5"></circle>
      <g id="?" transform="translate(16.700425, 13.000000)" fill="#FFFFFF" fillRule="nonzero">
        <path
          d="M4.62889518,13.509915 L6.99716714,13.509915 L6.99716714,11.4915014 C6.99716714,9.41926346 11.5991501,10.0113314 11.5991501,5.19405099 C11.5991501,1.80311615 8.93484419,0 5.67847025,0 C2.28753541,0 0,2.09915014 0,5.65155807 L2.4490085,5.65155807 C2.4490085,3.52549575 3.52549575,2.31444759 5.7592068,2.31444759 C7.80453258,2.31444759 9.15014164,3.20254958 9.15014164,5.14022663 C9.15014164,8.45042493 4.62889518,7.21246459 4.62889518,11.4645892 L4.62889518,13.509915 Z M4.25212465,19 L7.42776204,19 L7.42776204,15.6898017 L4.25212465,15.6898017 L4.25212465,19 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
);

export const WheelSelectorIcon = (props: ComponentProps<'svg'>) => (
  <svg version="1.1" width="30px" height="49px" viewBox="0 0 30.0 49.0" {...props}>
    <defs>
      <clipPath id="10512211610810211897579956">
        <path d="M1919.693,0 L1919.693,1080 L0,1080 L0,0 L1919.693,0 Z"></path>
      </clipPath>
      <clipPath id="11011712004510410110110755">
        <path d="M1300.0169,0 L1300.0169,223.524 L0,223.524 L0,0 L1300.0169,0 Z"></path>
      </clipPath>
      <clipPath id="489810811411555499751112">
        <path d="M1290.31565,0 C1324.60717,0 1352.40672,27.804 1352.40672,62.101 L1352.40672,223.524 L0,223.524 L0,102.335 C0,73.058 23.7292052,49.325 53.0015239,49.325 C76.0108442,49.325 95.5887133,63.994 102.915542,84.488 C106.36299,83.053 110.143386,82.257 114.110751,82.257 C126.884708,82.257 137.732974,90.476 141.677343,101.912 C145.912665,97.233 152.032687,94.292 158.840598,94.292 C160.82828,94.292 162.756972,94.543 164.597677,95.015 C164.593678,94.773 164.57968,94.534 164.57968,94.292 C164.57968,71.607 182.96674,53.216 205.649112,53.216 C210.556328,53.216 215.261575,54.08 219.623877,55.659 C223.8582,39.852 238.273895,28.211 255.414154,28.211 C260.412354,28.211 265.176593,29.206 269.526897,31 C280.270179,12.467 300.318973,0 323.280301,0 C355.640126,0 382.214876,24.761 385.105413,56.373 C389.971635,54.342 395.308782,53.216 400.909886,53.216 C422.160488,53.216 439.640692,69.359 441.762353,90.052 C445.441764,88.435 449.505115,87.531 453.781431,87.531 C464.030792,87.531 473.071346,92.69 478.460484,100.551 C485.367379,91.994 495.935689,86.516 507.787794,86.516 C510.746321,86.516 513.620861,86.868 516.382419,87.513 C522.969366,61.794 546.297635,42.782 574.066195,42.782 C584.804477,42.782 594.877866,45.626 603.576475,50.6 C612.98797,30.107 633.68666,15.874 657.710818,15.874 C680.990095,15.874 701.144872,29.237 710.936306,48.709 C723.41531,39.91 738.634876,34.739 755.064249,34.739 C782.247902,34.739 806.125083,48.889 819.739906,70.225 C823.535299,69.067 827.562655,68.44 831.735988,68.44 C850.417,68.44 866.17348,80.918 871.155684,97.993 C875.43,95.636 880.341215,94.292 885.567379,94.292 C887.739032,94.292 889.853693,94.529 891.894367,94.969 C897.767428,79.465 912.745033,68.44 930.304224,68.44 C932.153929,68.44 933.971638,68.574 935.756353,68.811 C945.480797,47.221 967.183327,32.191 992.395295,32.191 C1026.68781,32.191 1054.48637,59.995 1054.48637,94.292 L1054.48637,94.337 C1055.07927,94.312 1055.67418,94.292 1056.27408,94.292 C1071.99656,94.292 1085.64838,103.132 1092.55028,116.109 C1098.97425,111.944 1106.62903,109.516 1114.85471,109.516 C1118.93106,109.516 1122.86543,110.118 1126.58284,111.224 C1126.55684,110.658 1126.53984,110.089 1126.53984,109.516 C1126.53984,88.702 1143.40914,71.83 1164.21882,71.83 C1174.88111,71.83 1184.50157,76.266 1191.35548,83.385 C1200.89595,74.14 1213.89087,68.44 1228.22458,68.44 L1228.54453,68.448 C1228.33356,66.361 1228.22458,64.244 1228.22458,62.101 C1228.22458,27.804 1256.02413,0 1290.31565,0 Z"></path>
      </clipPath>
      <clipPath id="109121116103120511191139748">
        <path d="M1595.20739,0 L1595.20739,309.121 L0,309.121 L0,0 L1595.20739,0 Z"></path>
      </clipPath>
      <clipPath id="103105118454512253114103121">
        <path d="M796.117684,0 L985.893335,64.04 L1041.7704,37.131 L1089.51476,60.283 L1175.69998,17.398 L1357.31794,114.276 L1416.10353,88.934 L1630.8292,161.921 L1490.24368,197.777 L691.734377,309.121 L0,148.157 L335.177398,43.301 L565.023641,73.128 L796.117684,0 Z"></path>
      </clipPath>
      <clipPath id="121451225211710701070110">
        <path d="M1080,0 C1096.56854,-3.04359188e-15 1110,13.4314575 1110,30 L1110,604 C1110,620.568542 1096.56854,634 1080,634 L37,634 C16.5654643,634 -4.60291848e-15,617.434536 0,597 L0,30 C-2.02906125e-15,13.4314575 13.4314575,-7.61454916e-15 30,0 L1080,0 Z"></path>
      </clipPath>
      <clipPath id="57105120113116112110116109112">
        <path d="M1080,0 C1096.56854,-3.04359188e-15 1110,13.4314575 1110,30 L1110,604 C1110,620.568542 1096.56854,634 1080,634 L30,634 C13.4314575,634 2.02906125e-15,620.568542 0,604 L0,30 C-2.02906125e-15,13.4314575 13.4314575,-7.61454916e-15 30,0 L1080,0 Z"></path>
      </clipPath>
      <clipPath id="106535510811710211349111109">
        <path d="M25.4981944,0 C28.2596182,3.80913106e-16 30.4981944,2.23857625 30.4981944,5 C30.4981944,5.43503882 30.4414178,5.86821731 30.329303,6.28856126 L19.8681861,45.5096623 C19.2988639,47.6441803 17.1069683,48.9130223 14.9724502,48.3437001 C13.5884948,47.9745692 12.5075433,46.8936177 12.1384124,45.5096623 L1.67729546,6.28856126 C0.965642725,3.62041368 2.55169517,0.88054418 5.21984275,0.168891445 C5.6401867,0.0567766111 6.0733652,2.74445059e-15 6.50840401,0 L25.4981944,0 Z"></path>
      </clipPath>
    </defs>
    <g transform="translate(-903.0 -304.0)">
      <g transform="translate(901.5301440832974 304.1589062330049)">
        <g clipPath="url(#106535510811710211349111109)">
          <polygon
            points="1.50716666,0 30.4981944,0 30.4981944,48.4798031 1.50716666,48.4798031 1.50716666,0"
            stroke="none"
            fill="#2D2D41"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
);

export const CelebrationIcon = (props: ComponentProps<'svg'>) => (
  <svg version="1.1" width="45px" height="45px" viewBox="0 0 45.0 45.0" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath id="4855116113981181001071000">
        <path d="M22.5,0 C34.9264069,0 45,10.0735931 45,22.5 C45,34.9264069 34.9264069,45 22.5,45 C10.0735931,45 0,34.9264069 0,22.5 C0,10.0735931 10.0735931,0 22.5,0 Z"></path>
      </clipPath>
      <clipPath id="11110312112110198484551101">
        <path d="M22.5,0 C34.9264069,0 45,10.0735931 45,22.5 C45,34.9264069 34.9264069,45 22.5,45 C10.0735931,45 0,34.9264069 0,22.5 C0,10.0735931 10.0735931,0 22.5,0 Z M22.5,5.4 C13.0559308,5.4 5.4,13.0559308 5.4,22.5 C5.4,31.9440692 13.0559308,39.6 22.5,39.6 C31.9440692,39.6 39.6,31.9440692 39.6,22.5 C39.6,13.0559308 31.9440692,5.4 22.5,5.4 Z"></path>
      </clipPath>
      <clipPath id="45118491225610150561220">
        <path d="M7.33369717,0 C11.3839863,0 14.6673943,0.733538483 14.6673943,1.63840406 C14.6673943,1.7539865 14.613822,1.86677355 14.5119221,1.9755935 L7.78741606,16.4964553 C7.67138477,16.7470374 7.37418595,16.8561123 7.12360393,16.740081 C7.01609691,16.6903002 6.9297591,16.6039624 6.87997828,16.4964553 L0.157217179,1.97745158 C0.0541840044,1.8680576 9.09494702e-13,1.75464448 9.09494702e-13,1.63840406 C9.09494702e-13,0.733538483 3.28340806,0 7.33369717,0 Z"></path>
      </clipPath>
      <clipPath id="5411211545117561024510495">
        <path d="M7.33369717,0 C11.3839863,0 14.6673943,0.733538483 14.6673943,1.63840406 C14.6673943,2.54326963 11.3839863,3.27680812 7.33369717,3.27680812 C3.28340806,3.27680812 0,2.54326963 0,1.63840406 C0,0.733538483 3.28340806,0 7.33369717,0 Z"></path>
      </clipPath>
      <clipPath id="102509810311111099115110120">
        <path d="M1.31307984,0 C2.03827381,0 2.62615968,0.58788587 2.62615968,1.31307984 C2.62615968,2.03827381 2.03827381,2.62615968 1.31307984,2.62615968 C0.58788587,2.62615968 0,2.03827381 0,1.31307984 C0,0.58788587 0.58788587,0 1.31307984,0 Z"></path>
      </clipPath>
      <clipPath id="5210610455991021165110995">
        <path d="M0.863790685,0 C1.34084911,0 1.72758137,0.386732262 1.72758137,0.863790685 C1.72758137,1.34084911 1.34084911,1.72758137 0.863790685,1.72758137 C0.386732262,1.72758137 0,1.34084911 0,0.863790685 C0,0.386732262 0.386732262,0 0.863790685,0 Z"></path>
      </clipPath>
      <clipPath id="951015499451071035011456">
        <path d="M2.62615968,0 L2.62615968,2.62615968 L0,2.62615968 L0,0 L2.62615968,0 Z"></path>
      </clipPath>
      <clipPath id="45501165556561125312257">
        <path d="M1.72758137,0 L1.72758137,1.72758137 L0,1.72758137 L0,0 L1.72758137,0 Z"></path>
      </clipPath>
    </defs>
    <g clipPath="url(#4855116113981181001071000)">
      <polygon points="0,0 45,0 45,45 0,45 0,0" stroke="none" fill="#086B61"></polygon>
    </g>
    <g clipPath="url(#11110312112110198484551101)">
      <polygon points="0,0 45,0 45,45 0,45 0,0" stroke="none" fill="rgba(119, 119, 119, 0.2)"></polygon>
    </g>
    <g transform="translate(18.452861641580263 15.69958617233814) rotate(45.00000000000001)">
      <g transform="">
        <g clipPath="url(#45118491225610150561220)">
          <polygon
            points="0,9.09494702e-13 14.6673943,9.09494702e-13 14.6673943,16.7864823 0,16.7864823 0,9.09494702e-13"
            stroke="none"
            fill="#F9FF1A"
          ></polygon>
        </g>
      </g>
      <g transform="">
        <g clipPath="url(#5411211545117561024510495)">
          <polygon
            points="0,0 14.6673943,0 14.6673943,3.27680812 0,3.27680812 0,0"
            stroke="none"
            fill="rgba(24, 24, 33, 0.193031)"
          ></polygon>
        </g>
      </g>
    </g>
    <g transform="translate(19.87384031785132 13.0734264901912)">
      <g clipPath="url(#102509810311111099115110120)">
        <polygon
          points="0,0 2.62615968,0 2.62615968,2.62615968 0,2.62615968 0,0"
          stroke="none"
          fill="#0C978A"
        ></polygon>
      </g>
    </g>
    <g transform="translate(29.94654966163125 11.73229657652064)">
      <g clipPath="url(#5210610455991021165110995)">
        <polygon
          points="0,0 1.72758137,0 1.72758137,1.72758137 0,1.72758137 0,0"
          stroke="none"
          fill="#07BA92"
        ></polygon>
      </g>
    </g>
    <g transform="translate(35.50187082086472 21.63620931543755)">
      <g clipPath="url(#5210610455991021165110995)">
        <polygon
          points="0,0 1.72758137,0 1.72758137,1.72758137 0,1.72758137 0,0"
          stroke="none"
          fill="#7BBBFA"
        ></polygon>
      </g>
    </g>
    <g transform="translate(28.82427564084446 21.18692015892611)">
      <g clipPath="url(#951015499451071035011456)">
        <polygon
          points="0,0 2.62615968,0 2.62615968,2.62615968 0,2.62615968 0,0"
          stroke="none"
          fill="#FFFFFF"
        ></polygon>
      </g>
    </g>
    <g transform="translate(20.323129474364446 8.426584193892962) rotate(45.00000000000001)">
      <g clipPath="url(#45501165556561125312257)">
        <polygon
          points="9.09494702e-13,9.09494702e-13 1.72758137,9.09494702e-13 1.72758137,1.72758137 9.09494702e-13,1.72758137 9.09494702e-13,9.09494702e-13"
          stroke="none"
          fill="#50A4F8"
        ></polygon>
      </g>
    </g>
    <g transform="translate(25.17778964050087 8.426584193894087)">
      <path
        d="M1.45411357,10.9058518 L0,8.72468142 L1.45411357,6.54351107 L0,4.36234071 L1.45411357,2.18117036 L0,0"
        stroke="#FF3C3C"
        strokeWidth="1.3"
        fill="none"
        strokeLinecap="square"
        strokeMiterlimit="10"
      ></path>
    </g>
    <g transform="translate(31.339878448874813 14.961223390033489) rotate(24.0)">
      <path
        d="M0,3.42562887 L1.29852825,1.48625168 L3.58875405,1.93937719 L4.88728231,0"
        stroke="#F9FF1A"
        strokeWidth="1.3"
        fill="none"
        strokeMiterlimit="10"
      ></path>
    </g>
  </svg>
);

export const LossIcon = (props: ComponentProps<'svg'>) => (
  <svg
    version="1.1"
    width="100px"
    height="101px"
    viewBox="0 0 100.0 101.0"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <clipPath id="102118118541191181175095107">
        <path d="M1919.693,0 L1919.693,1080 L0,1080 L0,0 L1919.693,0 Z"></path>
      </clipPath>
      <clipPath id="010099451091164911311848">
        <path d="M1300.0169,0 L1300.0169,223.524 L0,223.524 L0,0 L1300.0169,0 Z"></path>
      </clipPath>
      <clipPath id="9851111109991031039510954">
        <path d="M1290.31565,0 C1324.60717,0 1352.40672,27.804 1352.40672,62.101 L1352.40672,223.524 L0,223.524 L0,102.335 C0,73.058 23.7292052,49.325 53.0015239,49.325 C76.0108442,49.325 95.5887133,63.994 102.915542,84.488 C106.36299,83.053 110.143386,82.257 114.110751,82.257 C126.884708,82.257 137.732974,90.476 141.677343,101.912 C145.912665,97.233 152.032687,94.292 158.840598,94.292 C160.82828,94.292 162.756972,94.543 164.597677,95.015 C164.593678,94.773 164.57968,94.534 164.57968,94.292 C164.57968,71.607 182.96674,53.216 205.649112,53.216 C210.556328,53.216 215.261575,54.08 219.623877,55.659 C223.8582,39.852 238.273895,28.211 255.414154,28.211 C260.412354,28.211 265.176593,29.206 269.526897,31 C280.270179,12.467 300.318973,0 323.280301,0 C355.640126,0 382.214876,24.761 385.105413,56.373 C389.971635,54.342 395.308782,53.216 400.909886,53.216 C422.160488,53.216 439.640692,69.359 441.762353,90.052 C445.441764,88.435 449.505115,87.531 453.781431,87.531 C464.030792,87.531 473.071346,92.69 478.460484,100.551 C485.367379,91.994 495.935689,86.516 507.787794,86.516 C510.746321,86.516 513.620861,86.868 516.382419,87.513 C522.969366,61.794 546.297635,42.782 574.066195,42.782 C584.804477,42.782 594.877866,45.626 603.576475,50.6 C612.98797,30.107 633.68666,15.874 657.710818,15.874 C680.990095,15.874 701.144872,29.237 710.936306,48.709 C723.41531,39.91 738.634876,34.739 755.064249,34.739 C782.247902,34.739 806.125083,48.889 819.739906,70.225 C823.535299,69.067 827.562655,68.44 831.735988,68.44 C850.417,68.44 866.17348,80.918 871.155684,97.993 C875.43,95.636 880.341215,94.292 885.567379,94.292 C887.739032,94.292 889.853693,94.529 891.894367,94.969 C897.767428,79.465 912.745033,68.44 930.304224,68.44 C932.153929,68.44 933.971638,68.574 935.756353,68.811 C945.480797,47.221 967.183327,32.191 992.395295,32.191 C1026.68781,32.191 1054.48637,59.995 1054.48637,94.292 L1054.48637,94.337 C1055.07927,94.312 1055.67418,94.292 1056.27408,94.292 C1071.99656,94.292 1085.64838,103.132 1092.55028,116.109 C1098.97425,111.944 1106.62903,109.516 1114.85471,109.516 C1118.93106,109.516 1122.86543,110.118 1126.58284,111.224 C1126.55684,110.658 1126.53984,110.089 1126.53984,109.516 C1126.53984,88.702 1143.40914,71.83 1164.21882,71.83 C1174.88111,71.83 1184.50157,76.266 1191.35548,83.385 C1200.89595,74.14 1213.89087,68.44 1228.22458,68.44 L1228.54453,68.448 C1228.33356,66.361 1228.22458,64.244 1228.22458,62.101 C1228.22458,27.804 1256.02413,0 1290.31565,0 Z"></path>
      </clipPath>
      <clipPath id="111120104110454511512095112">
        <path d="M1595.20739,0 L1595.20739,309.121 L0,309.121 L0,0 L1595.20739,0 Z"></path>
      </clipPath>
      <clipPath id="117561171184812111210399116">
        <path d="M796.117684,0 L985.893335,64.04 L1041.7704,37.131 L1089.51476,60.283 L1175.69998,17.398 L1357.31794,114.276 L1416.10353,88.934 L1630.8292,161.921 L1490.24368,197.777 L691.734377,309.121 L0,148.157 L335.177398,43.301 L565.023641,73.128 L796.117684,0 Z"></path>
      </clipPath>
      <clipPath id="119115122971035548555556">
        <path d="M1080,0 C1096.56854,-3.04359188e-15 1110,13.4314575 1110,30 L1110,626 C1110,642.568542 1096.56854,656 1080,656 L37,656 C16.5654643,656 -4.60291848e-15,639.434536 0,619 L0,30 C-2.02906125e-15,13.4314575 13.4314575,-7.61454916e-15 30,0 L1080,0 Z"></path>
      </clipPath>
      <clipPath id="1031061041075112011911110449">
        <path d="M1080,0 C1096.56854,-3.04359188e-15 1110,13.4314575 1110,30 L1110,626 C1110,642.568542 1096.56854,656 1080,656 L30,656 C13.4314575,656 2.02906125e-15,642.568542 0,626 L0,30 C-2.02906125e-15,13.4314575 13.4314575,-7.61454916e-15 30,0 L1080,0 Z"></path>
      </clipPath>
      <clipPath id="11152116511069795101115103">
        <path d="M50,0 C77.6142375,0 100,22.3857625 100,50 C100,77.6142375 77.6142375,100 50,100 C22.3857625,100 0,77.6142375 0,50 C0,22.3857625 22.3857625,0 50,0 Z"></path>
      </clipPath>
      <clipPath id="1185111411945111104485057">
        <path d="M50,0 C77.6142375,0 100,22.3857625 100,50 C100,77.6142375 77.6142375,100 50,100 C22.3857625,100 0,77.6142375 0,50 C0,22.3857625 22.3857625,0 50,0 Z M50,12 C29.0131795,12 12,29.0131795 12,50 C12,70.9868205 29.0131795,88 50,88 C70.9868205,88 88,70.9868205 88,50 C88,29.0131795 70.9868205,12 50,12 Z"></path>
      </clipPath>
      <clipPath id="10910249102561091055452117">
        <path d="M6.69786152,1.08223834 C6.84227583,1.16781054 6.96282514,1.28835985 7.04839734,1.43277415 C10.5998982,7.43875731 12.3761769,11.4988392 12.3761769,13.6136458 C12.3761769,15.2546804 11.7242251,16.8287845 10.5638501,17.9891596 C9.40322713,19.1497825 7.82937088,19.8017343 6.18808844,19.8017343 C4.54705389,19.8017343 2.97294975,19.1497825 1.81257472,17.9891596 C0.651951792,16.8287845 0,15.2546804 0,13.6136458 C0,11.4988392 1.77627867,7.43875731 5.32883601,1.43340016 C5.60931944,0.957638667 6.22272604,0.800698437 6.69786152,1.08223834 Z"></path>
      </clipPath>
      <clipPath id="9751105116481221214812145">
        <path d="M16.5324634,0.410217462 C17.5333045,1.12055617 17.7688032,2.50774146 17.0584645,3.50858253 C15.3775725,5.87689745 13.1395937,7.79509049 10.5420175,9.09387862 C7.94447754,10.3926734 5.06712336,11.0321321 2.16387427,10.9558564 C0.936998171,10.9236233 -0.0314513005,9.90291358 0.000781828386,8.67603749 C0.0330149573,7.44916139 1.05372466,6.48071192 2.28060075,6.51294505 C4.45465544,6.57006295 6.60929233,6.09121985 8.55438627,5.11865427 C10.4995344,4.14608021 12.1753971,2.70968221 13.4340983,0.936218531 C14.144437,-0.0646225415 15.5316223,-0.300121242 16.5324634,0.410217462 Z"></path>
      </clipPath>
      <clipPath id="12051118111575111210910752">
        <path d="M4.03449368,0.936091899 C5.29344383,2.70964397 6.9694025,4.14608343 8.91449987,5.11866935 C10.8595132,6.09121322 13.01423,6.57006351 15.1883874,6.51294487 C16.4152635,6.48071284 17.4359723,7.44916323 17.4682044,8.67603935 C17.5004364,9.90291548 16.531986,10.9236243 15.3051099,10.9558563 C12.4017615,11.032132 9.52431631,10.3926672 6.92682301,9.09387087 C4.32938374,7.79510151 2.09140379,5.87696191 0.410307118,3.5087089 C-0.300101449,2.50791741 -0.0646995847,1.12071568 0.936091899,0.410307118 C1.93688338,-0.300101449 3.32408511,-0.0646995847 4.03449368,0.936091899 Z"></path>
      </clipPath>
      <clipPath id="531169812295481141019550">
        <path d="M18.208949,0 C22.0285144,0 25.7637319,1.11956525 28.953732,3.2200001 C32.1432973,5.32086973 34.6476452,8.31000026 36.1563409,11.818696 C36.4167757,12.4230439 36.4850366,13.0930439 36.3515583,13.7373917 C36.2185148,14.3821744 35.8902539,14.9700005 35.4115583,15.4217396 C34.9328626,15.8734787 34.3267756,16.166957 33.6754713,16.2626092 C33.0246017,16.3582614 32.359819,16.2513048 31.7715582,15.9560874 C27.567645,13.8591309 22.903297,12.8543482 18.208949,13.0343482 C13.5146011,12.8543482 8.85051398,13.8591309 4.64664428,15.9560874 C4.05833992,16.2513048 3.39355729,16.3582614 2.74238335,16.2626092 C2.09120942,16.166957 1.48516592,15.8734787 1.00647026,15.4217396 C0.527774591,14.9700005 0.199600668,14.3821744 0.0663832722,13.7373917 C-0.066790645,13.0930439 0.00142674842,12.4230439 0.261861539,11.818696 C1.77060072,8.31000026 4.27473123,5.32086973 7.46447046,3.2200001 C10.6541662,1.11956525 14.3898185,0 18.208949,0 Z"></path>
      </clipPath>
      <clipPath id="11254114121511034849107104">
        <path d="M3.42681278,0 C5.31938922,0 6.85362556,1.53423634 6.85362556,3.42681278 C6.85362556,5.31938922 5.31938922,6.85362556 3.42681278,6.85362556 C1.53423634,6.85362556 0,5.31938922 0,3.42681278 C0,1.53423634 1.53423634,0 3.42681278,0 Z"></path>
      </clipPath>
      <clipPath id="489711911499110951189797">
        <path d="M3.42681278,0 C5.31938922,0 6.85362556,1.53423634 6.85362556,3.42681278 C6.85362556,5.31938922 5.31938922,6.85362556 3.42681278,6.85362556 C1.53423634,6.85362556 0,5.31938922 0,3.42681278 C0,1.53423634 1.53423634,0 3.42681278,0 Z"></path>
      </clipPath>
    </defs>
    <g transform="translate(-910.0 -258.0)">
      <rect x="0px" y="0px" width="1920px" height="1080px" fill="#FFFFFF"></rect>
      <g transform="">
        <g clipPath="url(#102118118541191181175095107)">
          <polygon points="0,0 1919.693,0 1919.693,1080 0,1080 0,0" stroke="none" fill="#A7D1FA"></polygon>
        </g>
        <g transform="translate(0.0 0.0003000000001520675)">
          <g transform="translate(619.6761005279168 301.9999)">
            <g transform="">
              <g clipPath="url(#010099451091164911311848)">
                <g transform="">
                  <g transform="">
                    <g clipPath="url(#9851111109991031039510954)">
                      <polygon
                        points="0,0 1300.0169,0 1300.0169,223.524 0,223.524 0,0"
                        stroke="none"
                        fill="#FFFFFF"
                      ></polygon>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g transform="translate(0.0 351.3748999999997)">
            <g transform="">
              <g clipPath="url(#111120104110454511512095112)">
                <g transform="">
                  <g transform="translate(-35.62180331119794 1.1368683772161603e-13)">
                    <g clipPath="url(#117561171184812111210399116)">
                      <polygon
                        points="35.6218033,0 1630.8292,0 1630.8292,309.121 35.6218033,309.121 35.6218033,0"
                        stroke="none"
                        fill="#7BBAF9"
                      ></polygon>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g transform="translate(405.0 152.5)">
        <g transform="translate(0.0 35.0)">
          <g transform="translate(-8.0 8.0)">
            <g clipPath="url(#119115122971035548555556)">
              <polygon points="0,0 1110,0 1110,656 0,656 0,0" stroke="none" fill="#0C978A"></polygon>
            </g>
          </g>
          <g clipPath="url(#1031061041075112011911110449)">
            <polygon points="0,0 1110,0 1110,656 0,656 0,0" stroke="none" fill="#2D2D41"></polygon>
          </g>
          <path
            d="M30,0 L1080,0 C1096.56854,-3.04359188e-15 1110,13.4314575 1110,30 L1110,626 C1110,642.568542 1096.56854,656 1080,656 L30,656 C13.4314575,656 2.02906125e-15,642.568542 0,626 L0,30 C-2.02906125e-15,13.4314575 13.4314575,-7.61454916e-15 30,0 Z"
            stroke="#02DE97"
            strokeWidth="4"
            fill="none"
            strokeMiterlimit="10"
          ></path>
        </g>
        <g transform="translate(505.0 106.0)">
          <g clipPath="url(#11152116511069795101115103)">
            <polygon points="0,0 100,0 100,100 0,100 0,0" stroke="none" fill="#F9FF1A"></polygon>
          </g>
          <g clipPath="url(#1185111411945111104485057)">
            <polygon points="0,0 100,0 100,100 0,100 0,0" stroke="none" fill="rgba(119, 119, 119, 0.2)"></polygon>
          </g>
          <g transform="translate(15.292194734818672 23.921367633776953)">
            <g transform="translate(64.82946092469166 22.513507473789403)">
              <g clipPath="url(#10910249102561091055452117)">
                <polygon
                  points="0,0.942390903 12.3761769,0.942390903 12.3761769,19.8017343 0,19.8017343 0,0.942390903"
                  stroke="none"
                  fill="#50A4F8"
                ></polygon>
              </g>
            </g>
            <g clipPath="url(#9751105116481221214812145)">
              <polygon
                points="0,-1.11022302e-16 17.4686819,-1.11022302e-16 17.4686819,10.9619615 0,10.9619615 0,-1.11022302e-16"
                stroke="none"
                fill="#2D2D41"
              ></polygon>
            </g>
            <g transform="translate(52.095838715217724 1.3266091869468255e-07)">
              <g clipPath="url(#12051118111575111210910752)">
                <polygon
                  points="5.55111512e-17,-1.11022302e-16 17.4689861,-1.11022302e-16 17.4689861,10.9619614 5.55111512e-17,10.9619614 5.55111512e-17,-1.11022302e-16"
                  stroke="none"
                  fill="#2D2D41"
                ></polygon>
              </g>
            </g>
            <g transform="translate(16.5732025059141 41.28427129746747)">
              <g clipPath="url(#531169812295481141019550)">
                <polygon
                  points="-1.44328993e-15,0 36.4181445,0 36.4181445,16.2966686 -1.44328993e-15,16.2966686 -1.44328993e-15,0"
                  stroke="none"
                  fill="#086B61"
                ></polygon>
              </g>
            </g>
            <g transform="translate(7.749069927112184 13.99176213053175)">
              <g clipPath="url(#11254114121511034849107104)">
                <polygon
                  points="0,0 6.85362556,0 6.85362556,6.85362556 0,6.85362556 0,0"
                  stroke="none"
                  fill="#2D2D41"
                ></polygon>
              </g>
            </g>
            <g transform="translate(54.961853989477596 13.99176213053175)">
              <g clipPath="url(#489711911499110951189797)">
                <polygon
                  points="0,0 6.85362556,0 6.85362556,6.85362556 0,6.85362556 0,0"
                  stroke="none"
                  fill="#2D2D41"
                ></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const AudioOnIcon = (props: ComponentProps<'svg'>) => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Icon/Music/On" stroke="#FFFFFF" strokeWidth="1.5">
        <g id="streamlinehq-entertainment-volume-level-off-entertainment-14" transform="translate(2.956709, 2.254113)">
          <path
            d="M3.88252757,4.63986529 L1.55301103,4.63986529 C0.695306721,4.63986529 0,5.33517201 0,6.19287632 L0,9.29889838 C0,10.1566027 0.695306721,10.8519094 1.55301103,10.8519094 L3.88252757,10.8519094 L3.88252757,4.63986529 Z"
            id="Path"
          ></path>
          <path
            d="M3.88252757,10.8519094 L9.95480069,15.2158704 C10.4127536,15.5327316 11.005308,15.5801359 11.5078117,15.3401113 C12.0542447,15.0946565 12.410792,14.556814 12.4240882,13.9579315 L12.4240882,1.53384324 C12.4376189,0.965750999 12.1397975,0.435628984 11.6475827,0.151663421 C11.1450789,-0.0883612513 10.5525246,-0.0409569024 10.0945717,0.275904303 L3.88252757,4.63986529"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const AudioOffIcon = (props: ComponentProps<'svg'>) => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Icon/Music/Of" stroke="#FFFFFF" strokeWidth="1.5">
        <g id="streamlinehq-entertainment-volume-off-entertainment-14">
          <line x1="20" y1="20" x2="0" y2="0" id="Path"></line>
          <path
            d="M3.07692308,8.46153846 L3.07692308,11.5384615 C3.07692308,11.9464923 3.23901538,12.3378 3.52752308,12.6263231 C3.81604615,12.9148308 4.20735385,13.0769231 4.61538462,13.0769231 L6.92307692,13.0769231 L6.92307692,10.7692308"
            id="Path"
          ></path>
          <path
            d="M15.3846154,15.3846154 L15.3846154,3.84615385 C15.3912308,3.56987692 15.3232308,3.29692308 15.1878462,3.05598462 C15.0524615,2.81504615 14.8547692,2.61503077 14.6153846,2.47692308 C14.3708308,2.36010769 14.0997538,2.30996923 13.8296,2.33158462 C13.5594462,2.3532 13.2998,2.4458 13.0769231,2.6 L6.92307692,6.92307692"
            id="Path"
          ></path>
          <line x1="6.92307692" y1="13.0769231" x2="12.9384615" y2="17.4" id="Path"></line>
        </g>
      </g>
    </g>
  </svg>
);

export const FullScreenIcon = (props: ComponentProps<'svg'>) => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Icon/Screen/Full" stroke="#FFFFFF" strokeWidth="1.5">
        <g
          id="streamlinehq-interface-edit-maximize-screen-interface-essential-14"
          transform="translate(1.999971, 2.000000)"
        >
          <path
            d="M0.571469391,14.3348525 L0.571469391,9.98514751 C0.571469391,9.38101293 1.06121866,8.89126366 1.66535438,8.89126366 L6.01508222,8.89126366 C6.6192168,8.89126366 7.10896607,9.38101293 7.10896607,9.98514751 L7.10896607,14.3348525 C7.10896607,14.9390099 6.6192168,15.4287592 6.01508222,15.4287592 L1.66535438,15.4287592 C1.06121752,15.4287592 0.571469391,14.9390099 0.571469391,14.3348525 Z"
            id="Path"
          ></path>
          <line x1="9.19005186" y1="6.80952639" x2="15.4285889" y2="0.571469391" id="Path"></line>
          <polyline id="Path" points="12.4588911 0.571469391 15.4304176 0.571469391 15.4304176 3.5430645"></polyline>
          <line x1="0.571469391" y1="5.91804557" x2="0.571469391" y2="4.7294121" id="Path"></line>
          <line x1="5.62285992" y1="0.571469391" x2="4.43422644" y2="0.571469391" id="Path"></line>
          <line x1="9.78474577" y1="0.571469391" x2="8.59611229" y2="0.571469391" id="Path"></line>
          <line x1="10.082367" y1="15.4285306" x2="11.2710005" y2="15.4285306" id="Path"></line>
          <line x1="15.4285889" y1="10.3771984" x2="15.4285889" y2="11.5658547" id="Path"></line>
          <line x1="15.4285889" y1="6.21534681" x2="15.4285889" y2="7.40399171" id="Path"></line>
          <path
            d="M14.2407326,15.4295593 C14.8972367,15.4295593 15.429389,14.897407 15.429389,14.2410172"
            id="Path"
          ></path>
          <path
            d="M0.571469391,1.76010286 C0.571469391,1.10363997 1.10363997,0.571469391 1.76010401,0.571469391"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const RestartIcon = (props: ComponentProps<'svg'>) => (
  <svg height="22" viewBox="0 0 24 22" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#FFFFFF"
      strokeLinecap="round"
      strokeWidth="1.5"
      transform="translate(1.138325 1.3)"
    >
      <path d="m0 7.25585989 2.44414011 2.44414011 2.4441401-2.44414011" strokeLinejoin="round" />
      <path d="m4.21453572 15.2881076c1.75614608 2.4874395 4.65316959 4.1118924 7.92960438 4.1118924 5.3571621 0 9.7-4.3428379 9.7-9.7 0-5.35716207-4.3428379-9.7-9.7-9.7-5.35716207 0-9.69999999 4.34283793-9.69999999 9.7" />
    </g>
  </svg>
);

export const NormalScreenIcon = (props: ComponentProps<'svg'>) => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Icon/Screen/Small" stroke="#FFFFFF" strokeWidth="1.5">
        <g
          id="streamlinehq-interface-edit-minimize-screen-interface-essential-14"
          transform="translate(2.001070, 2.000000)"
        >
          <line x1="15.9978597" y1="0.0015569111" x2="9.27728371" y2="6.7214006" id="Path"></line>
          <polyline id="Path" points="12.4769022 6.7214006 9.27729602 6.7214006 9.27729602 3.52184368"></polyline>
          <path d="M7.35899693,14.7201329 C7.35899693,15.4269583 6.78599211,16 6.07916678,16" id="Path"></path>
          <path d="M0,14.7201329 C0,15.4269583 0.572997438,16 1.27981908,16" id="Path"></path>
          <path d="M0,10.5603988 C0,9.85357343 0.572997438,9.28058092 1.27981908,9.28058092" id="Path"></path>
          <path
            d="M7.35899693,10.5603988 C7.35899693,9.85357343 6.78599211,9.28058092 6.07916678,9.28058092"
            id="Path"
          ></path>
          <path
            d="M10.2385932,15.9976616 L14.8421763,15.9976616 C15.4804483,15.9976616 15.9978597,15.4802502 15.9978597,14.8421012 L15.9978597,4.47922708"
            id="Path"
          ></path>
          <path d="M0,5.75920493 L0,1.15559726 C0,0.517379405 0.517379405,0 1.1555985,0 L11.5184234,0" id="Path"></path>
        </g>
      </g>
    </g>
  </svg>
);

export const LinkedInIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" role={'img'} {...props}>
    <title>LinkedIn</title>
    <path
      d="m17 0c1.6568542 0 3 1.34314575 3 3v14c0 1.6568542-1.3431458 3-3 3h-14c-1.65685425 0-3-1.3431458-3-3v-14c0-1.65685425 1.34314575-3 3-3zm-11 7h-3v10h3zm8.1337934.2543886c-1.4922098-.14411502-2.5928179.22617712-3.3018241 1.11087642l.0000255-.96773226h-3.00000002v9.60246724h3.00000002v-5.6148926l.0251122-.166129c.1650749-.9408831.6673883-1.4113246 1.5069401-1.4113246 1.3380359 0 1.6498433.8783357 1.6498433 1.9094905 0 .035557.003557.0702561.0104264.1040708l.0005854 5.1787849h3v-4.9996624c.0195851-1.0575694.2379552-4.44374946-2.8911088-4.745949zm-9.66093287-4.4955482c-.91937908 0-1.66468309.745304-1.66468309 1.66468309 0 .91937908.74530401 1.66468309 1.66468309 1.66468309.91937909 0 1.66468309-.74530401 1.66468309-1.66468309 0-.91937909-.745304-1.66468309-1.66468309-1.66468309z"
      fillRule="evenodd"
    />
  </svg>
);

export const FacebookIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" role={'img'} {...props}>
    <title>Facebook</title>
    <path
      d="m12.3339478.79938823c-.0885851-.49599194-.5323994-.80225271-1.005105-.79938823-1.2121887.00742081-2.3091234.0441705-3.26893575.20711725-.96132359.16321344-1.79983706.45526415-2.48700474.98361431-1.3534892 1.04067234-2.04474611 2.93551721-2.07377072 6.28445958h-2.40784267c-.45772657 0-.89339799.28989053-.98322316.77593054-.10223509.5532011-.18323731 1.44171869.0059116 2.54865422.0883806.5172426.55003194.8582929 1.05202882.8582929h2.332192v7.4025205c0 .3690082.20650589.7435279.62809615.8238901.31918183.0608939.82095647.1155206 1.59639809.1155206.77419706 0 1.32099763-.0544489 1.68760559-.1140094.47955059-.0779175.7582402-.4998634.7582402-.9445666v-7.2833552h3.13532479c.4862622 0 .9443444-.3215376 1.0352852-.8293571.1834818-1.02439549.0948523-1.95180517-.0076006-2.53807565-.0876517-.50133016-.5330661-.81544491-1.0127056-.81544491h-3.14950372c.00542267-.71588116.03849206-1.27357151.11787637-1.71076306.08725163-.48035066.22668533-.79353199.42656845-1.00808299.19814964-.21268418.47883942-.35309573.89962961-.44123632.42439049-.08889621.97083549-.12058771 1.68187179-.13014405.4891514-.00657832.950656-.33224958 1.0408857-.84524736.1856597-1.05596249.1001416-1.96710861-.0022224-2.54032913z"
      fillRule="evenodd"
      transform="translate(3.777264)"
    />
  </svg>
);

export const InstagramIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" role={'img'} {...props}>
    <title>Instagram</title>
    <g fillRule="evenodd">
      <path
        d="m10 6.44444444c-1.96368889 0-3.55555556 1.59186667-3.55555556 3.55555556 0 1.9636889 1.59186667 3.5555556 3.55555556 3.5555556 1.9636889 0 3.5555556-1.5918667 3.5555556-3.5555556 0-1.96368889-1.5918667-3.55555556-3.5555556-3.55555556z"
        fillRule="nonzero"
      />
      <path d="m10 20c-2.09875556 0-3.79764444-.0503111-5.13017778-.1174222-2.61782222-.1318222-4.62059111-2.1345778-4.75241333-4.7524-.06710222-1.3325334-.11740889-3.0314222-.11740889-5.1301778 0-2.09875556.05031111-3.79764444.11740889-5.13017778.13182222-2.61782666 2.13459111-4.62059111 4.75241333-4.75241333 1.33253334-.06710222 3.03142222-.11740889 5.13017778-.11740889 2.0987556 0 3.7976444.05030667 5.1301778.11740889 2.6178222.13182222 4.6205778 2.13459111 4.7524 4.75241333.0671111 1.33253334.1174222 3.03142222.1174222 5.13017778 0 2.0987556-.0503111 3.7976444-.1174222 5.1302222-.1318222 2.6177778-2.1345778 4.6205334-4.7524 4.7523556-1.3325334.0671111-3.0314222.1174222-5.1301778.1174222zm-5.33333333-10c0-2.94551111 2.38782222-5.33333333 5.33333333-5.33333333 2.9455111 0 5.3333333 2.38782222 5.3333333 5.33333333 0 2.9455111-2.3878222 5.3333333-5.3333333 5.3333333-2.94551111 0-5.33333333-2.3878222-5.33333333-5.3333333zm11.11111113-7.11111111c-.4909334 0-.8888889.39796889-.8888889.88888889 0 .49093333.3979555.88888889.8888889.88888889h.4444444c.4909334 0 .8888889-.39795556.8888889-.88888889 0-.49092-.3979555-.88888889-.8888889-.88888889z" />
    </g>
  </svg>
);

export const TwitterIcon = (props: ComponentProps<'svg'>) => (
  <svg width="300" height="271" viewBox="0 0 300 271" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>X</title>
    <path d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z" />
  </svg>
);

export const IdentifyCropIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" role={'img'} {...props}>
    <title>Identify crop</title>
    <g fill="none" fillRule="evenodd">
      <rect fill="#096b62" height="60" rx="16" width="60" />
      <path
        d="m22.3765389 31.357044h7.6233564c0-3.2099582-1.5098605-6.0674412-3.858387-7.9004694-1.6985277-1.3261652-3.8361448-2.1161598-6.1582422-2.1161598h-7.6233564c0 2.765897 1.1210125 5.2701197 2.9338918 7.0827374 1.8126177 1.8126176 4.3165787 2.9338918 7.0827374 2.9338918"
        fill="#7cbcfb"
      />
      <path
        d="m22.3765389 41.3737256h7.6233564c0-2.7661586-1.1210125-5.2701197-2.9336302-7.0827373-1.8126176-1.8128794-4.3168404-2.9338919-7.082999-2.9338919h-7.6233564c0 3.3271883 1.6221187 6.2754722 4.1187529 8.0969868 1.6545664 1.2073651 3.6930089 1.9196424 5.8978763 1.9196424"
        fill="#0d988b"
      />
      <path
        d="m22.3765389 51.75h7.6233564c0-2.6842546-1.055594-5.1217504-2.7745322-6.919976-1.8238697-1.9081287-4.3940343-3.0966533-7.242097-3.0966533h-7.6233564c0 3.1484648 1.4525538 5.9575381 3.7241481 7.7939681 1.7197233 1.3900137 3.9088902 2.2226612 6.2924811 2.2226612"
        fill="#2d2d42"
      />
      <path
        d="m37.6234611 31.357044h-7.6233564c0-3.2099582 1.5098605-6.0674412 3.858387-7.9004694 1.6985277-1.3261652 3.8361448-2.1161598 6.1582422-2.1161598h7.6233564c0 2.765897-1.1210125 5.2701197-2.9338918 7.0827374-1.8126177 1.8126176-4.3165787 2.9338918-7.0827374 2.9338918"
        fill="#7cbcfb"
      />
      <path
        d="m37.6234611 41.3737256h-7.6233564c0-2.7661586 1.1210125-5.2701197 2.9336302-7.0827373 1.8126176-1.8128794 4.3168404-2.9338919 7.082999-2.9338919h7.6233564c0 3.3271883-1.6221187 6.2754722-4.1187529 8.0969868-1.6545664 1.2073651-3.6930089 1.9196424-5.8978763 1.9196424"
        fill="#0d988b"
      />
      <path
        d="m37.6234611 51.75h-7.6233564c0-2.6842546 1.055594-5.1217504 2.7745322-6.919976 1.8238697-1.9081287 4.3940343-3.0966533 7.242097-3.0966533h7.6233564c0 3.1484648-1.4525538 5.9575381-3.7241481 7.7939681-1.7197233 1.3900137-3.9088902 2.2226612-6.2924811 2.2226612"
        fill="#2d2d42"
      />
      <path
        d="m22.4547534 13.7951158c0-4.16716269 3.3782147-7.5451158 7.5451158-7.5451158 4.1671627 0 7.5453774 3.37795311 7.5453774 7.5451158 0 4.1671627-3.3782147 7.5451158-7.5453774 7.5451158-4.1669011 0-7.5451158-3.3779531-7.5451158-7.5451158"
        fill="#02de98"
      />
      <g
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        transform="translate(16.813864 16.724655)"
      >
        <path d="m2.1779666 13.3275609c0 6.1577508 4.99184339 11.1495942 11.1495943 11.1495942 6.1577508 0 11.1495942-4.9918434 11.1495942-11.1495942 0-6.15775091-4.9918434-11.1495943-11.1495942-11.1495943-6.15775091 0-11.1495943 4.99184339-11.1495943 11.1495943z" />
        <path d="m27.822033 27.822033-6.610594-6.610594" />
      </g>
    </g>
  </svg>
);

export const CostIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" role={'img'} {...props}>
    <title>Cost</title>
    <g fill="none" fillRule="evenodd">
      <rect fill="#2d2d42" height="60" rx="16" width="60" />
      <circle cx="30" cy="30" fill="#02de98" r="22.5" />
      <circle cx="30" cy="30" fill="#c0f7e5" r="16" />
      <g
        stroke="#2d2d42"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        transform="translate(23.95 21.5)"
      >
        <path d="m.566667 9.066667h9.066666" />
        <path d="m10.7666667 3.96666667c0-2.19072951-1.77593719-3.96666667-3.9666667-3.96666667s-3.96666667 1.77593716-3.96666667 3.96666667v10.20000003c0 1.5648068-1.26852654 2.8333333-2.83333333 2.8333333h10.7666667" />
      </g>
    </g>
  </svg>
);

export const CalculatorIcon = (props: ComponentProps<'svg'>) => (
  <svg
    height="60"
    viewBox="0 0 60 60"
    width="60"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    {...props}
  >
    <title>Calculator</title>
    <mask id="a" fill="#fff">
      <rect fill="#fff" fillRule="evenodd" height="45" rx="9" width="44.969042" />
    </mask>
    <g fill="none" fillRule="evenodd">
      <rect fill="#02de98" height="60" rx="16" width="60" />
      <g transform="translate(7.53098 7.45353)">
        <path d="m22.5.01548983h22.5v22.49999997h-22.5z" fill="#c0f7e5" mask="url(#a)" />
        <path d="m22.5 22.5154898h22.5v22.5h-22.5z" fill="#096b62" mask="url(#a)" />
        <path d="m0 .01548983h22.5v22.49999997h-22.5z" fill="#2d2d42" mask="url(#a)" />
        <path d="m0 22.5154898h22.5v22.5h-22.5z" fill="#a8d2fc" mask="url(#a)" />
        <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
          <path d="m11.333149 7.659203v7.511012" stroke="#fff" />
          <path d="m7.577643 11.414709h7.511012" stroke="#fff" />
          <path d="m15.088655 30.009984-7.511012 7.511012" stroke="#2d2d42" />
          <path d="m7.577643 30.009984 7.511012 7.511012" stroke="#2d2d42" />
          <path d="m29.845275 11.414709h7.511012" stroke="#2d2d42" />
          <path d="m29.845275 32.059537h7.511012" stroke="#fff" />
          <path d="m29.845275 35.815043h7.511012" stroke="#fff" />
        </g>
      </g>
    </g>
  </svg>
);

export const GrowingCropsIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" role={'img'} {...props}>
    <title>Growing crops</title>
    <g fill="none" fillRule="evenodd">
      <rect fill="#a8d2fc" height="60" rx="16" width="60" />
      <g transform="translate(17.981477 22.5)">
        <path
          d="m6.82451664 17.1058981h5.19393516c0-2.1870045-1.0286962-4.133861-2.62879121-5.3827374-1.15723863-.9035411-2.61363708-1.4417792-4.19572545-1.4417792h-5.19393514c0 1.8844573.7637668 3.590631 1.99891535 4.8256013 1.23497026 1.2349703 2.94096571 1.9989153 4.82560129 1.9989153"
          fill="#50a5f9"
        />
        <path
          d="m6.82451664 23.9304504h5.19393516c0-1.8846355-.7637668-3.590631-1.9987371-4.8256013-1.23497025-1.2351485-2.94114398-1.9989153-4.82577956-1.9989153h-5.19393514c0 2.2668755 1.10517983 4.2755965 2.80618333 5.5166284 1.12728699.8226004 2.51611598 1.3078882 4.01833331 1.3078882"
          fill="#0d988b"
        />
        <path
          d="m6.82451664 31h5.19393516c0-1.8288328-.7191959-3.4895442-1.8903407-4.7147089-1.24263644-1.3000438-2.99373763-2.1098077-4.93417596-2.1098077h-5.19393514c0 2.1451078.98965208 4.0589819 2.53733172 5.310176 1.17167959.9470423 2.66319991 1.5143406 4.28718492 1.5143406"
          fill="#2d2d42"
        />
        <path
          d="m17.2125295 17.1058981h-5.1939351c0-2.1870045 1.0286962-4.133861 2.6287912-5.3827374 1.1572386-.9035411 2.6136371-1.4417792 4.1957254-1.4417792h5.1939352c0 1.8844573-.7637668 3.590631-1.9989154 4.8256013-1.2349702 1.2349703-2.9409657 1.9989153-4.8256013 1.9989153"
          fill="#50a5f9"
        />
        <path
          d="m17.2125295 23.9304504h-5.1939351c0-1.8846355.7637668-3.590631 1.9987371-4.8256013 1.2349702-1.2351485 2.941144-1.9989153 4.8257795-1.9989153h5.1939352c0 2.2668755-1.1051799 4.2755965-2.8061834 5.5166284-1.1272869.8226004-2.5161159 1.3078882-4.0183333 1.3078882"
          fill="#0d988b"
        />
        <path
          d="m17.2125295 31h-5.1939351c0-1.8288328.7191959-3.4895442 1.8903407-4.7147089 1.2426364-1.3000438 2.9937376-2.1098077 4.9341759-2.1098077h5.1939352c0 2.1451078-.9896521 4.0589819-2.5373317 5.310176-1.1716796.9470423-2.6632 1.5143406-4.287185 1.5143406"
          fill="#2d2d42"
        />
        <path
          d="m6.87780559 5.14062835c0-2.83916579 2.30164085-5.14062835 5.14062831-5.14062835 2.8391658 0 5.1408067 2.30146256 5.1408067 5.14062835 0 2.8391658-2.3016409 5.14062835-5.1408067 5.14062835-2.83898746 0-5.14062831-2.30146255-5.14062831-5.14062835"
          fill="#fff"
        />
      </g>
      <g transform="translate(38.496114 10)">
        <path
          d="m4.40291396 11.0360633h3.35092589c0-1.41097064-.66367495-2.66700712-1.69599431-3.47273381-.74660557-.58292976-1.68621747-.93018013-2.70691964-.93018013h-3.3509259c0 1.2157789.49275277 2.31653614 1.2896228 3.11329115.79675501.79675499 1.89739724 1.28962279 3.11329116 1.28962279"
          fill="#fff"
        />
        <path
          d="m4.40291396 15.4390003h3.35092589c0-1.2158939-.49275277-2.3165362-1.28950778-3.1132912-.79675501-.79687-1.89751225-1.2896228-3.11340617-1.2896228h-3.3509259c0 1.4625004.71301924 2.7584494 1.81044086 3.5591151.72728193.5307099 1.62330063.8437989 2.5924731.8437989"
          fill="#0d988b"
        />
        <path
          d="m4.40291396 20h3.35092589c0-1.1798921-.46399735-2.2513189-1.21957461-3.0417477-.80170094-.8387379-1.93144364-1.3611663-3.18333934-1.3611663h-3.3509259c0 1.3839406.63848521 2.6186981 1.6369882 3.4259201.75592233.610995 1.7181935.9769939 2.76592576.9769939"
          fill="#50a5f9"
        />
        <path
          d="m11.1048578 11.0360633h-3.35092593c0-1.41097064.66367495-2.66700712 1.69599431-3.47273381.74660562-.58292976 1.68621752-.93018013 2.70691962-.93018013h3.3509259c0 1.2157789-.4927527 2.31653614-1.2896228 3.11329115-.796755.79675499-1.8973972 1.28962279-3.1132911 1.28962279"
          fill="#fff"
        />
        <path
          d="m11.1048578 15.4390003h-3.35092593c0-1.2158939.49275277-2.3165362 1.28950778-3.1132912.79675501-.79687 1.89751225-1.2896228 3.11340615-1.2896228h3.3509259c0 1.4625004-.7130192 2.7584494-1.8104408 3.5591151-.727282.5307099-1.6233007.8437989-2.5924731.8437989"
          fill="#0d988b"
        />
        <path
          d="m11.1048578 20h-3.35092593c0-1.1798921.46399736-2.2513189 1.21957462-3.0417477.80170094-.8387379 1.93144361-1.3611663 3.18333931-1.3611663h3.3509259c0 1.3839406-.6384852 2.6186981-1.6369882 3.4259201-.7559223.610995-1.7181935.9769939-2.7659257.9769939"
          fill="#50a5f9"
        />
        <path
          d="m4.43729393 3.31653442c0-1.83171987 1.48492958-3.31653442 3.31653442-3.31653442 1.83171987 0 3.31664945 1.48481455 3.31664945 3.31653442s-1.48492958 3.31653442-3.31664945 3.31653442c-1.83160484 0-3.31653442-1.48481455-3.31653442-3.31653442"
          fill="#2d2d42"
        />
      </g>
      <g transform="translate(5.996114 10)">
        <path
          d="m4.40291396 11.0360633h3.35092589c0-1.41097064-.66367495-2.66700712-1.69599431-3.47273381-.74660557-.58292976-1.68621747-.93018013-2.70691964-.93018013h-3.3509259c0 1.2157789.49275277 2.31653614 1.2896228 3.11329115.79675501.79675499 1.89739724 1.28962279 3.11329116 1.28962279"
          fill="#2d2d42"
        />
        <path
          d="m4.40291396 15.4390003h3.35092589c0-1.2158939-.49275277-2.3165362-1.28950778-3.1132912-.79675501-.79687-1.89751225-1.2896228-3.11340617-1.2896228h-3.3509259c0 1.4625004.71301924 2.7584494 1.81044086 3.5591151.72728193.5307099 1.62330063.8437989 2.5924731.8437989"
          fill="#50a5f9"
        />
        <path
          d="m4.40291396 20h3.35092589c0-1.1798921-.46399735-2.2513189-1.21957461-3.0417477-.80170094-.8387379-1.93144364-1.3611663-3.18333934-1.3611663h-3.3509259c0 1.3839406.63848521 2.6186981 1.6369882 3.4259201.75592233.610995 1.7181935.9769939 2.76592576.9769939"
          fill="#0d988b"
        />
        <path
          d="m11.1048578 11.0360633h-3.35092593c0-1.41097064.66367495-2.66700712 1.69599431-3.47273381.74660562-.58292976 1.68621752-.93018013 2.70691962-.93018013h3.3509259c0 1.2157789-.4927527 2.31653614-1.2896228 3.11329115-.796755.79675499-1.8973972 1.28962279-3.1132911 1.28962279"
          fill="#2d2d42"
        />
        <path
          d="m11.1048578 15.4390003h-3.35092593c0-1.2158939.49275277-2.3165362 1.28950778-3.1132912.79675501-.79687 1.89751225-1.2896228 3.11340615-1.2896228h3.3509259c0 1.4625004-.7130192 2.7584494-1.8104408 3.5591151-.727282.5307099-1.6233007.8437989-2.5924731.8437989"
          fill="#50a5f9"
        />
        <path
          d="m11.1048578 20h-3.35092593c0-1.1798921.46399736-2.2513189 1.21957462-3.0417477.80170094-.8387379 1.93144361-1.3611663 3.18333931-1.3611663h3.3509259c0 1.3839406-.6384852 2.6186981-1.6369882 3.4259201-.7559223.610995-1.7181935.9769939-2.7659257.9769939"
          fill="#0d988b"
        />
        <path
          d="m4.43729393 3.31653442c0-1.83171987 1.48492958-3.31653442 3.31653442-3.31653442 1.83171987 0 3.31664945 1.48481455 3.31664945 3.31653442s-1.48492958 3.31653442-3.31664945 3.31653442c-1.83160484 0-3.31653442-1.48481455-3.31653442-3.31653442"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);

export const StarFillIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m10 14.5572808-5.35740495 2.8165545 1.0231733-5.9655581-4.33423164-4.22483166 5.98976082-.87036319 2.67870247-5.42764405 2.6787025 5.42764405 5.9897608.87036319-4.3342317 4.22483166 1.0231733 5.9655581z"
      fill="#02de98"
      fillRule="evenodd"
      stroke="#e7e7e7"
    />
  </svg>
);

export const StarHalfIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="m10 14.5572808-5.35740495 2.8165545 1.0231733-5.9655581-4.33423164-4.22483166 5.98976082-.87036319 2.67870247-5.42764405z"
        fill="#02de98"
      />
      <path
        d="m10 14.5572808-5.35740495 2.8165545 1.0231733-5.9655581-4.33423164-4.22483166 5.98976082-.87036319 2.67870247-5.42764405 2.6787025 5.42764405 5.9897608.87036319-4.3342317 4.22483166 1.0231733 5.9655581z"
        stroke="#e7e7e7"
      />
    </g>
  </svg>
);

export const StarEmptyIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m10 14.5572808-5.35740495 2.8165545 1.0231733-5.9655581-4.33423164-4.22483166 5.98976082-.87036319 2.67870247-5.42764405 2.6787025 5.42764405 5.9897608.87036319-4.3342317 4.22483166 1.0231733 5.9655581z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#e7e7e7"
    />
  </svg>
);

export const EconomicIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="60px"
    height="60px"
    viewBox="0 0 60 60"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role={'img'}
    {...props}
  >
    <title>Economic predictions</title>
    <g id="Icon/Circle/Economic" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#7CBCFB" x="0" y="0" width="60" height="60" rx="16"></rect>
      <rect id="Rectangle" fill="#FFFFFF" x="7.53097967" y="7.4535305" width="44.9690416" height="45" rx="9"></rect>
      <polyline
        id="Path-8"
        stroke="#02DE98"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="15.550176 44.4288096 23.9531737 36.0258119 27.0640676 39.1367058 28.9531852 37.2475882 30.8423027 39.1367058 38.5813542 31.3976543 39.6643432 32.4806433 44.4808037 27.6641828"
      ></polyline>
      <polyline
        id="Path-7"
        stroke="#2D2D42"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="15.550176 15.4782513 15.550176 44.4288096 44.4808037 44.4288096"
      ></polyline>
      <circle id="Oval" fill="#02DE98" cx="30" cy="21.5535305" r="8.4"></circle>
      <circle id="Oval" fill="#C0F7E5" cx="30" cy="21.5535305" r="5.97333333"></circle>
      <g
        id="Icon/Cost"
        transform="translate(27.741333, 18.380197)"
        stroke="#2D2D42"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <g id="streamlinehq-currency-pound-money-payments-finance-48">
          <line x1="0.211555556" y1="3.38488889" x2="3.59644444" y2="3.38488889" id="Path"></line>
          <path
            d="M4.01955556,1.48088889 C4.01955556,0.663016539 3.35653902,0 2.53866667,0 C1.72079432,0 1.05777778,0.663016539 1.05777778,1.48088889 L1.05777778,5.28888889 C1.05777778,5.87308342 0.584194535,6.34666667 0,6.34666667 L4.01955556,6.34666667"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const MarketplaceIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="60px"
    height="60px"
    viewBox="0 0 60 60"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role={'img'}
    {...props}
  >
    <title>Marketplace</title>
    <g id="Icon/Circle/Marketplace" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#D3E9FE" x="0" y="0" width="60" height="60" rx="16"></rect>
      <path
        d="M47.5755323,21.245574 L47.5755323,46.6505874 C47.5755323,47.6723503 46.7472299,48.5006527 45.725467,48.5006527 L14.2743574,48.5006527 C13.2525946,48.5006527 12.4242922,47.6723503 12.4242922,46.6505874 L12.4242922,21.245574"
        id="Path"
        fill="#2D2D42"
      ></path>
      <polygon
        id="Path"
        fill="#FFFFFF"
        points="18.5911764 33.5502753 28.4581912 33.5502753 28.4581912 40.9505363 18.5911764 40.9505363"
      ></polygon>
      <path
        d="M42.8754018,48.5006527 L33.6250754,48.5006527 L33.6250754,33.6988064 C33.6250754,33.2179338 34.0392266,32.8281096 34.550108,32.8281096 L41.9503691,32.8281096 C42.4612505,32.8281096 42.8754018,33.2179338 42.8754018,33.6988064 L42.8754018,48.5006527 Z"
        id="Path"
        fill="#02DE98"
      ></path>
      <path
        d="M17.974488,18.8996084 L17.974488,24.4498042 C16.4911049,26.1164856 14.1223426,26.6748837 12.0507256,25.8462369 C9.97910865,25.0175901 8.64890005,22.9796037 8.72416162,20.7496737 L8.72416162,18.8996084 L17.974488,18.8996084 Z"
        id="Path--Path-Copy--Path-Copy-2--Path-Copy-3-∩-Path-Copy-2"
        fill="#0D988B"
      ></path>
      <path
        d="M19.8245532,11.4993473 L17.974488,18.8996084 L8.72416162,18.8996084 L11.9136741,12.5224334 C12.2268227,11.8957619 12.8670762,11.4997214 13.5676325,11.4993473 L19.8245532,11.4993473 Z"
        id="Path-∩-Path"
        fill="#096B62"
      ></path>
      <path
        d="M51.2724518,18.899 L51.2724518,20.7490653 C51.3499105,22.9800209 50.0198636,25.0199164 47.9472251,25.8489718 C45.8745867,26.6780272 43.5046248,26.1181352 42.0221254,24.4491958 L42.0221254,18.899 L51.2724518,18.899 Z"
        id="Path--Path-Copy--Path-Copy-2--Path-Copy-3---Path-Copy-2---Path-Copy---Path-Copy-3-1"
        fill="#FFFFFF"
      ></path>
      <path
        d="M46.432192,11.4993473 C47.1327482,11.4997214 47.7730017,11.8957619 48.0861503,12.5224334 L51.2756628,18.8996084 L42.0253365,18.8996084 L40.1752712,11.4993473 L46.432192,11.4993473 Z"
        id="Path--Path---Path-Copy---Path-Copy-2-1"
        fill="#F5F5F5"
      ></path>
      <path
        d="M42.0253365,18.8996084 L42.0253365,24.4498042 C40.8102887,26.5045598 38.6884764,27.8569807 36.3128399,28.0908895 C33.9372034,28.3247983 31.592371,27.4121702 29.9999122,25.633846 L29.999,18.899 L42.0253365,18.8996084 Z"
        id="Path--Path-Copy--Path-Copy-2--Path-Copy-3---Path-Copy-2-∩-Path-Copy---Path-Copy-3"
        fill="#0D988B"
      ></path>
      <polygon
        id="Path--Path-∩-Path-Copy---Path-Copy-2"
        fill="#096B62"
        points="40.1752712 11.4993473 42.0253365 18.8996084 29.999 18.899 29.9999122 11.4993473"
      ></polygon>
      <path
        d="M29.999,18.899 L29.9999122,25.633846 C28.4074535,27.4121702 26.062621,28.3247983 23.6869845,28.0908895 C21.311348,27.8569807 19.1895358,26.5045598 17.974488,24.4498042 L17.974488,18.8996084 L29.999,18.899 Z"
        id="Path--Path-Copy--Path-Copy-2--Path-Copy-3---Path-Copy-2---Path-Copy---Path-Copy-3"
        fill="#FFFFFF"
      ></path>
      <polygon
        id="Path--Path---Path-Copy---Path-Copy-2"
        fill="#F5F5F5"
        points="29.9999122 11.4993473 29.999 18.899 17.974488 18.8996084 19.8245532 11.4993473"
      ></polygon>
    </g>
  </svg>
);

export const SimpleCrop = (props: ComponentProps<'svg'>) => (
  <svg
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    fillRule="evenodd"
    {...props}
  >
    <g transform="translate(.870562 .872178)">
      <path d="m0 18.221817c1.33581839.165329 2.67490608-.2810336 3.6443634-1.2147878.69821278.7733576 1.69135939 1.214738 2.73327255 1.214738 1.04191317 0 2.03505977-.4413804 2.73327255-1.214738.69821278.7733576 1.6913594 1.214738 2.7332726 1.214738 1.0419131 0 2.0350597-.4413804 2.7332725-1.214738.9694573.9337542 2.308545 1.3801168 3.6443634 1.2147878" />
      <path d="m15.7922949 5.53457322c-1.7793528.00664502-3.4830993.72001507-4.7363167 1.98310511-1.25321743 1.26309005-1.95319655 2.97238177-1.94593635 4.75167847 1.77928945-.0068597 3.48291075-.7202982 4.73608175-1.9833415 1.253171-1.26304328 1.9532197-2.97221038 1.9461713-4.75144208z" />
      <path d="m10.8683015 7.71633211c.9355539-2.69527064.2571009-5.6880021-1.74929441-7.71633211-2.01457098 2.03605136-2.69002403 5.04351548-1.73957613 7.74548701" />
      <path d="m2.42951878 5.53457322c1.77907496.00707358 3.48240549.72063255 4.73527292 1.98367601 1.25286743 1.26304347 1.95262444 2.97209037 1.94536376 4.75110757-1.77907496-.0070736-3.48240549-.7206326-4.73527292-1.983676-1.25286742-1.2630435-1.95262444-2.97209043-1.94536376-4.75110758z" />
      <path d="m9.110909 15.184848v-2.916301" />
    </g>
  </svg>
);

export const SimplePound = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <g fill="none" fillRule="evenodd" strokeWidth="1.5">
      <circle cx="10" cy="10" r="9.25" />
      <g strokeLinecap="round" strokeLinejoin="round" transform="translate(7.2775 6.175)">
        <path d="m.255 4.08h4.08" />
        <path d="m4.845 1.785c0-.98582828-.79917172-1.785-1.785-1.785s-1.785.79917172-1.785 1.785v4.59c0 .70416306-.57083694 1.275-1.275 1.275h4.845" />
      </g>
    </g>
  </svg>
);

export const HomeIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path
      d="m15.100574 15.6018128h-14.41418427c-.37908258 0-.68638973-.3073072-.68638973-.6863897v-8.58879472c0-.21100404.09735594-.41021026.26357366-.54018872l7.20709216-5.6407508c.2484109-.19425181.59722123-.19425181.84563214 0l7.20709214 5.6407508c.1662177.12997846.2635737.32918468.2635737.54018872v8.58879472c0 .3790825-.3073072.6863897-.6863898.6863897z"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(2.106518 2.081813)"
    />
  </svg>
);
export const ProfileIcon = (props: ComponentProps<'svg'>) => (
  <svg
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#2D2D42"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    fillRule="evenodd"
    {...props}
  >
    <g transform="translate(1.98904 .98767)">
      <circle cx="8.01096" cy="4.506165" r="4.506165" />
      <path d="m16.0219193 18.0246592c-.5394389-4.0117243-3.9631298-7.0058597-8.01095964-7.0058597s-7.47152071 2.9941354-8.01095966 7.0058597" />
    </g>
  </svg>
);

export const SignOutIcon = (props: ComponentProps<'svg'>) => (
  <svg
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#2D2D42"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    fillRule="evenodd"
    {...props}
  >
    <g transform="translate(0 1.595067)">
      <path d="m0 8.404627h12.606186" />
      <path d="m9.60471276 11.4060999 3.00147274-3.00147277-3.00147274-3.00147273" />
      <path d="m2.04580382 12.0832321c1.70031896 3.4930446 5.57320145 5.3654364 9.36688558 4.528534 3.7936841-.8369025 6.5193268-4.1649563 6.5921914-8.04917247.0728647-3.88421622-2.5260411-7.31215412-6.285668-8.2907504-3.75962689-.97859627-7.70000888.74722518-9.53013868 4.17404146" />
    </g>
  </svg>
);

export const GoogleIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m19.2275771 8.57665465c-.0364503-.3056861-.2947519-.53643557-.6025978-.53832074h-8.3801273c-.33099663.00432731-.59827057.27160125-.60259787.60259785v2.81212324c.0043273.3309966.27160124.5982706.60259787.6025979h4.4833279c-1.1940443 2.5172642-4.0510876 3.7809441-6.71682332 2.9708736-2.66573568-.8100705-4.33662814-3.449711-3.9282181-6.20571579.40841004-2.75600475 2.77301511-4.79762829 5.55911565-4.79979575 1.22700747-.00060713 2.42055157.40006253 3.39865187 1.14091859.2416678.19313577.5910599.16867832.8034638-.05624247l1.9845555-2.00062484c.1212494-.12065182.185511-.28714771.176762-.45797436-.0102348-.16812444-.0885766-.32480787-.2169352-.43387044-3.4780025-2.87783134-8.487165-2.95719347-12.05458824-.19098556-3.56742324 2.7662079-4.7379353 7.63733803-2.81684632 11.72241232 1.92108899 4.0850743 6.41941048 6.2903205 10.82524546 5.3069421 4.4058349-.9833784 7.539528-4.8920834 7.5413198-9.40632881.0012371-.35697497-.0175401-.71374058-.0563057-1.06860684z"
      fill="#2d2d42"
      transform="translate(.357951 .357955)"
    />
  </svg>
);

export const PencilIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g stroke="currentColor" strokeWidth="1.5">
        <g transform="translate(1.159954, 1.160237)">
          <path d="M16.8466481,0.83317845 C16.3060132,0.294847368 15.5726594,-0.0050992791 14.809731,0 C14.0468026,0.00523050618 13.317577,0.315078562 12.7842801,0.860679975 L1.39079138,12.2541687 L0,17.6798266 L5.4256579,16.2882494 L16.8191466,4.89476074 C17.3648956,4.36170483 17.6748605,3.63257117 17.6800916,2.86970562 C17.6851915,2.10684007 17.3851286,1.37357582 16.8466481,0.83317845 Z"></path>
          <line x1="12.4589763" y1="1.18676948" x2="16.4930571" y2="5.22085024"></line>
          <line x1="1.39157714" y1="12.2533829" x2="5.42958669" y2="16.2843207"></line>
        </g>
      </g>
    </g>
  </svg>
);

export const YieldIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="45px"
    height="45px"
    viewBox="0 0 45 45"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role={'img'}
    {...props}
  >
    <title>Yield</title>
    <g id="Icon/Round/Yeild" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval" fill="#C0F7E5" cx="22.5" cy="22.5" r="22.5"></circle>
      <path
        d="M22.5,0 C34.9264069,0 45,10.0735931 45,22.5 C45,34.9264069 34.9264069,45 22.5,45 C10.0735931,45 0,34.9264069 0,22.5 C0,10.0735931 10.0735931,0 22.5,0 Z M22.5,5.4 C13.0559308,5.4 5.4,13.0559308 5.4,22.5 C5.4,31.9440692 13.0559308,39.6 22.5,39.6 C31.9440692,39.6 39.6,31.9440692 39.6,22.5 C39.6,13.0559308 31.9440692,5.4 22.5,5.4 Z"
        id="Combined-Shape"
        fillOpacity="0.2"
        fill="#787878"
      ></path>
      <g id="Group-2" transform="translate(15.644823, 7.538406)" fill="#FFFFFF">
        <path
          d="M6.85517705,-3.81250587e-13 L8.21589231,1.6076246 C8.6068065,2.03793435 8.85125788,2.65138465 8.85125788,3.33225907 C8.85125788,3.95488273 8.64684432,4.52112543 8.31294643,4.94250193 L8.2660541,4.99838861 L6.85517705,6.66451814 L5.4443,4.99838861 L5.39740767,4.94250193 C5.06350977,4.52112543 4.85909621,3.95488273 4.85909621,3.33225907 C4.85909621,2.65138465 5.10354759,2.03793435 5.49446178,1.6076246 L6.85517705,-3.81250587e-13 Z"
          id="Combined-Shape"
        ></path>
        <g id="Group" transform="translate(0.000000, 4.056008)">
          <path
            d="M9.87463952,0.338762406 L11.2353548,1.94638701 C11.626269,2.37669676 11.8707204,2.99014706 11.8707204,3.67102148 C11.8707204,4.29364514 11.6663068,4.85988784 11.3324089,5.28126433 L11.2855166,5.33715101 L9.87463952,7.00328055 L8.46376247,5.33715101 L8.41687014,5.28126433 C8.08297224,4.85988784 7.87855868,4.29364514 7.87855868,3.67102148 C7.87855868,2.99014706 8.12301007,2.37669676 8.51392425,1.94638701 L9.87463952,0.338762406 Z"
            id="Combined-Shape-Copy"
            transform="translate(9.874640, 3.671021) rotate(50.000000) translate(-9.874640, -3.671021) "
          ></path>
          <path
            d="M3.83571458,0.338762406 L5.19642984,1.94638701 C5.58734403,2.37669676 5.83179541,2.99014706 5.83179541,3.67102148 C5.83179541,4.29364514 5.62738185,4.85988784 5.29348395,5.28126433 L5.24659163,5.33715101 L3.83571458,7.00328055 L2.42483752,5.33715101 L2.3779452,5.28126433 C2.0440473,4.85988784 1.83963374,4.29364514 1.83963374,3.67102148 C1.83963374,2.99014706 2.08408512,2.37669676 2.47499931,1.94638701 L3.83571458,0.338762406 Z"
            id="Combined-Shape-Copy-2"
            transform="translate(3.835715, 3.671021) scale(-1, 1) rotate(50.000000) translate(-3.835715, -3.671021) "
          ></path>
        </g>
        <g id="Group-Copy" transform="translate(0.000000, 9.061590)">
          <path
            d="M9.87463952,0.338762406 L11.2353548,1.94638701 C11.626269,2.37669676 11.8707204,2.99014706 11.8707204,3.67102148 C11.8707204,4.29364514 11.6663068,4.85988784 11.3324089,5.28126433 L11.2855166,5.33715101 L9.87463952,7.00328055 L8.46376247,5.33715101 L8.41687014,5.28126433 C8.08297224,4.85988784 7.87855868,4.29364514 7.87855868,3.67102148 C7.87855868,2.99014706 8.12301007,2.37669676 8.51392425,1.94638701 L9.87463952,0.338762406 Z"
            id="Combined-Shape-Copy"
            transform="translate(9.874640, 3.671021) rotate(50.000000) translate(-9.874640, -3.671021) "
          ></path>
          <path
            d="M3.83571458,0.338762406 L5.19642984,1.94638701 C5.58734403,2.37669676 5.83179541,2.99014706 5.83179541,3.67102148 C5.83179541,4.29364514 5.62738185,4.85988784 5.29348395,5.28126433 L5.24659163,5.33715101 L3.83571458,7.00328055 L2.42483752,5.33715101 L2.3779452,5.28126433 C2.0440473,4.85988784 1.83963374,4.29364514 1.83963374,3.67102148 C1.83963374,2.99014706 2.08408512,2.37669676 2.47499931,1.94638701 L3.83571458,0.338762406 Z"
            id="Combined-Shape-Copy-2"
            transform="translate(3.835715, 3.671021) scale(-1, 1) rotate(50.000000) translate(-3.835715, -3.671021) "
          ></path>
        </g>
      </g>
      <g id="Group-3" transform="translate(14.901345, 17.911240)">
        <path
          d="M10.7647616,4.848239 C13.4568673,6.12004388 15.1804806,8.82365441 15.1973105,11.8010086 C15.1973105,15.4736919 11.7905801,17.5 7.59865526,17.5 C3.40673044,17.5 0,15.4736919 0,11.8010086 C0.0168298931,8.82365441 1.74044316,6.12004388 4.4325489,4.848239 C6.85928689,4.00036907 8.97002446,4.00036907 10.7647616,4.848239 Z"
          id="Path"
          fill="#02DE98"
        ></path>
        <g
          id="Group-2"
          transform="translate(5.721499, 8.118229)"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.7"
        >
          <line x1="0" y1="2.65072707" x2="3.31340884" y2="2.65072707" id="Path"></line>
          <path
            d="M3.75431311,1.21491658 C3.75431311,0.543936679 3.21037644,0 2.53939654,0 C1.86841664,0 1.32447996,0.543936679 1.32447996,1.21491658 L1.32447996,3.97609061 C1.32447996,4.58607234 0.829992072,5.08056023 0.220010347,5.08056023 L3.75431311,5.08056023"
            id="Path"
          ></path>
        </g>
        <path
          d="M4.17926039,0.000366816538 C3.9576082,0.00152747121 3.75203395,0.116266587 3.6346901,0.304313027 C3.52610058,0.492395596 3.52610058,0.724122878 3.6346901,0.912205447 L5.68632702,5.06613699 L9.48565465,5.06613699 L11.5626204,0.912205447 C11.6712099,0.724122878 11.6712099,0.492395596 11.5626204,0.304313027 C11.4405878,0.108469065 11.2233434,-0.00739457571 10.9927213,0.000366816538 L4.17926039,0.000366816538 Z"
          id="Path"
          fill="#02DE98"
        ></path>
      </g>
    </g>
  </svg>
);

export const BeetlesEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={beetles} {...props} />;
export const CarbonSchemeEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={carbonScheme} {...props} />;
export const DeerEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={deer} {...props} />;
export const HarvestEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={harvest} {...props} />;
export const HarvesterMachineEventIcon = (props: ComponentProps<'div'>) => (
  <ImportedIcon src={harvesterMachine} {...props} />
);
export const NewMarketEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={newMarket} {...props} />;
export const PestsEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={pests} {...props} />;
export const PlantingMachineEventIcon = (props: ComponentProps<'div'>) => (
  <ImportedIcon src={plantingMachineEvent} {...props} />
);
export const RabbitEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={rabbit} {...props} />;
export const RustEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={rust} {...props} />;
export const TransportEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={transport} {...props} />;
export const WeedEventIcon = (props: ComponentProps<'div'>) => <ImportedIcon src={weed} {...props} />;

export const TractorImage = (props: ComponentProps<'div'>) => <ImportedIcon src={tractor} {...props} />;
export const PlantingMachine = (props: ComponentProps<'div'>) => <ImportedIcon src={plantingMachine} {...props} />;

export const CropStumpsMiscanthus = (props: ComponentProps<'div'>) => (
  <ImportedIcon src={cropStumpsMiscanthus} {...props} />
);
export const CropStumpsWillow = (props: ComponentProps<'div'>) => <ImportedIcon src={cropStumpsWillow} {...props} />;

export const ResourcesIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path
        d="m9.03869159.77679485c-2.59176068-.97663567-5.46050722-1.03417604-8.09237607-.1623142-.56410745.17208472-.9470639.67593596-.94631552 1.24494992v11.63549353c-.00157255.4038668.19147352.7856841.52282405 1.033911.33135054.248227.76361635.3348539 1.17051899.2345744 2.42357503-.6524647 5.00260908-.524777 7.34366035.3635839 0 0 .0016882-14.35019855.0016882-14.35019855z"
        transform="translate(.9613 2.4365)"
      />
      <path
        d="m9.03869159.77679485c-2.59176068-.97663567-5.46050722-1.03417604-8.09237607-.1623142-.56410745.17208472-.9470639.67593596-.94631552 1.24494992v11.63549353c-.00157255.4038668.19147352.7856841.52282405 1.033911.33135054.248227.76361635.3348539 1.17051899.2345744 2.42357503-.6524647 5.00260908-.524777 7.34366035.3635839 0 0 .0016882-14.35019855.0016882-14.35019855z"
        transform="matrix(-1 0 0 1 19.0386 2.4365)"
      />
    </g>
  </svg>
);

export const GameIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(.5798 .5798)">
      <path
        d="m11.2877797.70710683-10.58067297 10.58067447c-.39052598.3905226-.39052594 1.0236876-.00000162 1.4142118.00000058.0000006.00000115.0000012.00000344 0l5.43134817 5.431321c.39052635.3905209 1.02368997.3905201 1.41421534-.0000018l10.58063854-10.58063853c.3905217-.39052542.3905226-1.02368897.0000019-1.41421542l-5.4313212-5.43134971c-.3905213-.39052723-1.0236863-.39052889-1.4142116-.00000563-.0000007.00000064-.0000013.00000128 0 .00000382z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="m6.021492 6.022445 6.853953 6.853944" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.5" />
      <g fill="currentColor" fillRule="nonzero">
        <path d="m6.44986236 13.7331297c.70974129 0 1.28513703-.5753872 1.28513703-1.2851113 0-.7097242-.57539574-1.2851113-1.28513703-1.2851113-.70974985 0-1.28511132.5753871-1.28511132 1.2851113 0 .7097241.57536147 1.2851113 1.28511132 1.2851113z" />
        <path d="m10.7335925 7.73594352c.7097241 0 1.2851113-.57537861 1.2851113-1.28512846s-.5753872-1.28511133-1.2851113-1.28511133c-.7098098 0-1.28511134.57536148-1.28511134 1.28511133s.57530154 1.28512846 1.28511134 1.28512846z" />
        <path d="m14.160556 7.73594352c.7097242 0 1.2851113-.57537861 1.2851113-1.28512846s-.5753871-1.28511133-1.2851113-1.28511133c-.7098098 0-1.2851113.57536148-1.2851113 1.28511133s.5753015 1.28512846 1.2851113 1.28512846z" />
      </g>
    </g>
  </svg>
);

export const EditIcon = (props: ComponentProps<'svg'>) => (
  <svg height="21" viewBox="0 0 20 21" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="1.5">
      <circle cx="10" cy="10.5" r="9.25" />
      <g strokeLinecap="round" strokeLinejoin="round" transform="translate(6.021979 6.522106)">
        <path d="m7.58099166.3749303c-.24328571-.24224898-.57329492-.37722498-.91661271-.3749303-.3433178.00235373-.67146932.14178535-.91145291.38730599l-5.12706992 5.12706992-.62585612 2.44154605 2.44154605-.62620971 5.12706992-5.12706992c.24558704-.23987516.38507127-.56798531.38742525-.9112748.00229494-.3432895-.13273335-.67325841-.37504956-.91643723z" />
        <path d="m5.606539.534046 1.815337 1.815337" />
        <path d="m.62621 5.514022 1.817104 1.813922" />
      </g>
    </g>
  </svg>
);

export const Spinner = ({className, ...props}: ComponentProps<'svg'>) => (
  <svg
    className={classNames('animate-spin h-7 w-7', className)}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export const CheckIcon = (props: ComponentProps<'svg'>) => (
  <svg height="37" viewBox="0 0 36 37" width="36" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="18" cy="18.775" fill="#02de98" r="18" />
      <path
        d="m13.2663316 0-8.89846562 12.7115041c-.23817644.3422453-.62635518.5491311-1.04326329.5560231-.41690811.0068921-.81171302-.18705-1.06107171-.5212358l-2.26353098-3.01764822"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        transform="translate(11.367579 12.141148)"
      />
    </g>
  </svg>
);

export const SearchIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" role={'img'} {...props}>
    <title>Search</title>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path d="m1.45197774 8.88504057c0 4.10516723 3.32789558 7.43306283 7.43306283 7.43306283 4.10516723 0 7.43306283-3.3278956 7.43306283-7.43306283 0-4.10516725-3.3278956-7.43306283-7.43306283-7.43306283-4.10516725 0-7.43306283 3.32789558-7.43306283 7.43306283z" />
      <path d="m18.548022 18.548022-4.407063-4.407063" />
    </g>
  </svg>
);

export const SimpleCalculations = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(.68516 .68516)"
    >
      <path d="m0 0h18.6296795v18.6296795h-18.6296795z" />
      <path d="m9.31484 0v18.62968" />
      <path d="m0 9.31484h18.62968" />
      <path d="m4.65742 3.104947v3.104946" />
      <path d="m3.104947 4.65742h3.104946" />
      <path d="m6.209893 12.419786-3.104946 3.104947" />
      <path d="m3.104947 12.419786 3.104946 3.104947" />
      <path d="m12.419786 4.65742h3.104947" />
      <path d="m12.419786 12.419786h3.104947" />
      <path d="m12.419786 15.524733h3.104947" />
    </g>
  </svg>
);

export const RedoIcon = (props: ComponentProps<'svg'>) => (
  <svg height="18" viewBox="0 0 20 18" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth={1.5} transform="translate(1.741157 1.568446)">
      <path d="m9.37425745 14.8631089c4.10433415 0 7.43155445-3.3272203 7.43155445-7.43155446 0-4.10433419-3.3272203-7.43155444-7.43155445-7.43155444-4.10433418 0-7.43155443 3.32722025-7.43155443 7.43155444v.57165803" />
      <path d="m0 6.46020293 1.94270302 1.94270301 1.94270301-1.94270301" />
    </g>
  </svg>
);

export const NoResultsIcon = (props: ComponentProps<'svg'>) => (
  <svg height="59" viewBox="0 0 60 59" width="60" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="30.116832" cy="29.500467" fill="#d3e9fe" r="29.233197" />
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <g transform="translate(17.064668 16.448303)">
          <path d="m1.8951451 11.5969004c0 5.3581314 4.34362379 9.7017552 9.7017553 9.7017552 5.3581314 0 9.7017552-4.3436238 9.7017552-9.7017552 0-5.35813151-4.3436238-9.7017553-9.7017552-9.7017553-5.35813151 0-9.7017553 4.34362379-9.7017553 9.7017553z" />
          <path d="m24.209182 24.209182-5.75217-5.75217" />
        </g>
        <g transform="translate(24.816776 24.444626)">
          <path d="m.182146.182146 7.285848 7.285848" />
          <path d="m.182146.182146 7.285848 7.285848" transform="matrix(-1 0 0 1 7.65014 0)" />
        </g>
      </g>
    </g>
  </svg>
);

export const CoalIcon = (props: ComponentProps<'svg'>) => (
  <svg height="19" viewBox="0 0 20 19" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="1.5" transform="translate(.925878 1.577588)">
      <path
        d="m5.21027376 0h7.80703374l5.1309373 6.61677313-4.2766466 9.23101997h-8.66132444l-5.21027376-9.23101997z"
        strokeLinejoin="round"
      />
      <path
        d="m18.1482448 6.61677313-9.06555869 2.76021137-9.08268611-2.76021137"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="m5.210274 0 3.872412 9.376985" />
    </g>
  </svg>
);

export const GasIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 18 20" width="18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m14.8205581 10.5300919c.0010137 3.4352652-2.3591559 6.4208132-5.70189962 7.2127179-3.34274369.7919046-6.79146975-.8175009-8.33169935-3.8881264s-.76805727-6.79723892 1.86547368-9.00304107c.29269341.99074346.79253161 1.90799973 1.46641279 2.69102349.62345359-1.11250808.94858372-2.36734916.94380824-3.64263179.00451762-1.36677137-.34768759-2.71106606-1.02180892-3.90003403 5.52244819.88140769 8.40847338 6.43505615 8.04187018 9.75008508.8892112-.28651714 1.7134393-.74501058 2.4258212-1.34941178.2085106.69052094.3136511 1.40810511.3120218 2.1294186z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(1.589721 1.028446)"
    />
  </svg>
);

export const LPGIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 15 20" width="15" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(1.364512 .969506)"
    >
      <path d="m10.2083844 3.92630168c1.3349425 0 2.355781 1.02083844 2.355781 2.35578101v7.06734301c0 1.3349426-1.0208385 2.355781-2.355781 2.355781h-7.85260339c-1.33494257 0-2.35578101-1.0208384-2.35578101-2.355781v-7.06734301c0-1.33494257 1.02083844-2.35578101 2.35578101-2.35578101z" />
      <path d="m.628208 9.815754h11.935957" />
      <path d="m6.282083 3.634149v-1.115726" />
      <path d="m9.42312403.39263017h-6.28208269v3.53367151h6.28208269z" />
      <path d="m10.2083844 15.7052067h-7.85260339v2.355781h7.85260339z" />
      <path d="m1.570521.39263h9.423124" />
    </g>
  </svg>
);

export const HouseIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(1.059698 1.059698)"
    >
      <path d="m10.7283619 13.1124423v4.7681609h-4.76816085" />
      <path d="m8.344281 15.496523v2.38408" />
      <path d="m5.96020105 13.5892584v4.2913448h-4.76816084v-3.5761207" />
      <path d="m5.36418095 14.3044825 2.98010052-3.5761206h-5.36418094l-2.98010053 3.5761206z" />
      <path d="m11.920402 14.304483-3.576121-3.576121" />
      <path d="m8.91407669 4.76816084 4.19836561-4.76816084h-5.36418093l-4.19836562 4.76816084z" />
      <path d="m17.880603 4.768161-4.768161-4.768161" />
      <path d="m9.536322 4.061678v4.282603" />
      <path d="m16.6885629 3.57612063v10.72836187h-2.3840804" />
      <path d="m4.768161 8.344281v-3.57612" />
      <path d="m11.920402 5.364181v.59602" />
      <path d="m14.304483 5.364181v.59602" />
      <path d="m11.920402 8.344281v.596021" />
      <path d="m14.304483 8.344281v.596021" />
      <path d="m14.304483 11.324382v.59602" />
    </g>
  </svg>
);

export const OilIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 14 20" width="14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m0 12.2421093c0 3.4277906 2.69326405 6.1210547 6.12105465 6.1210547 3.42779061 0 6.12105465-2.6932641 6.12105465-6.1210547s-6.12105465-12.2421093-6.12105465-12.2421093-6.12105465 8.8143187-6.12105465 12.2421093z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(.878945 .818418)"
    />
  </svg>
);

export const CO2Icon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(.761974 1.174758)"
    >
      <path d="m.90239253 10.7896081c-.61258841-.6514495-.93683431-1.52225933-.89948968-2.41571128.00457139-.23790282.03208546-.47480966.08215979-.70742783.32488713-1.60038233 1.71663833-2.76113564 3.34934533-2.79343296h.03521134c.48634152-2.77327179 2.86683679-4.8149097 5.68182983-4.87303603h.09923196c2.1166306.00687722 4.0645449 1.1562854 5.0939072 3.00576801 1.0613215.05035986 2.0645877.49921958 2.8094381 1.25693813.833681.84143775 1.3077235 1.9739363 1.3220257 3.15835048v.04374743c-.0284208.83176235-.2753536 1.64137805-.7159639 2.34742265" />
      <path d="m7.02703164 7.49041229c-1.46829118.03208679-2.63445137 1.24498878-2.60884018 2.71340721v1.3561701c-.02561119 1.4684184 1.140549 2.6813204 2.60884018 2.7134072" />
      <path d="m11.4092429 7.49041229c-.945378.0186821-1.69720103.79914599-1.68054118 1.74456184v3.28532467c-.02697778.6180895.28740218 1.2011307.81863878 1.518227s1.1936352.3170963 1.7248718 0 .8456166-.9001375.8186389-1.518227v-3.28532467c.0160643-.94559172-.7360647-1.72587782-1.6816083-1.74456184z" />
      <path d="m15.6132635 14.0439895c-.012497-.6519855.5057273-1.1907477 1.1577062-1.2035876.3130057.0061642.6107354.1364488.8276605.362179.216925.2257302.3352667.5284054.3289786.8414086.0001136.3857811-.1270271.7608274-.3617164 1.0670103l-1.9526289 2.5394846h2.3143453" />
    </g>
  </svg>
);

export const PlantIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(.870562 .872178)"
    >
      <path d="m0 18.221817c1.33581839.165329 2.67490608-.2810336 3.6443634-1.2147878.69821278.7733576 1.69135939 1.214738 2.73327255 1.214738 1.04191317 0 2.03505977-.4413804 2.73327255-1.214738.69821278.7733576 1.6913594 1.214738 2.7332726 1.214738 1.0419131 0 2.0350597-.4413804 2.7332725-1.214738.9694573.9337542 2.308545 1.3801168 3.6443634 1.2147878" />
      <path d="m15.7922949 5.53457322c-1.7793528.00664502-3.4830993.72001507-4.7363167 1.98310511-1.25321743 1.26309005-1.95319655 2.97238177-1.94593635 4.75167847 1.77928945-.0068597 3.48291075-.7202982 4.73608175-1.9833415 1.253171-1.26304328 1.9532197-2.97221038 1.9461713-4.75144208z" />
      <path d="m10.8683015 7.71633211c.9355539-2.69527064.2571009-5.6880021-1.74929441-7.71633211-2.01457098 2.03605136-2.69002403 5.04351548-1.73957613 7.74548701" />
      <path d="m2.42951878 5.53457322c1.77907496.00707358 3.48240549.72063255 4.73527292 1.98367601 1.25286743 1.26304347 1.95262444 2.97209037 1.94536376 4.75110757-1.77907496-.0070736-3.48240549-.7206326-4.73527292-1.983676-1.25286742-1.2630435-1.95262444-2.97209043-1.94536376-4.75110758z" />
      <path d="m9.110909 15.184848v-2.916301" />
    </g>
  </svg>
);

export const CarIcon = (props: ComponentProps<'svg'>) => (
  <svg height="18" viewBox="0 0 20 18" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(1.055372 1.546143)"
    >
      <path d="m16.6966397 12.5224802c.6586643 0 1.1926171-.5339528 1.1926171-1.1926171v-3.57785133c0-.38143468-.1516434-.74722275-.4213913-1.01690486l-1.9638429-1.96463793h-13.11878826l-1.96384285 1.96384285c-.26994286.2698769-.42139149.63598975-.42139149 1.01769994v3.57785133c0 .6586643.53395298 1.1926171 1.19261722 1.1926171z" />
      <path d="m2.38523434 4.77046898 1.36991952-3.65735916c.25318075-.67029731.89510483-1.11365879 1.61162327-1.11310982h7.15570267c.7164472-.00032011 1.3582537.4429602 1.6116233 1.11310982l1.3699195 3.65735916z" />
      <path d="m2.38523434 4.77126405-1.19261712-1.19261711h-1.19261712" />
      <path d="m15.5040226 4.77126405 1.1926171-1.19261711h1.1926171" />
      <path d="m1.19261722 12.5224802v1.1926171c0 .6586643.53395287 1.1926172 1.19261712 1.1926172.65866424 0 1.19261711-.5339529 1.19261711-1.1926172v-1.1926171z" />
      <path d="m16.6966397 12.5224802v1.1926171c0 .6586643-.5339528 1.1926172-1.1926171 1.1926172-.6586642 0-1.1926171-.5339529-1.1926171-1.1926172v-1.1926171z" />
      <path d="m17.7596591 7.15570321h-3.4482536l-1.4414766 2.40272595c-.2155491.35908632-.6036573.57881734-1.0224704.57881734h-5.80486501c-.41954044.0003671-.80841685-.21973451-1.02406056-.57961242l-1.44068148-2.40193087h-3.44825362" />
      <path d="m12.869929 9.540937h5.019328" />
      <path d="m5.019328 9.540937h-5.019328" />
      <path d="m14.311406 7.155703h-10.733555" />
    </g>
  </svg>
);

export const FactoryIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(1.009334 1.009334)"
    >
      <path d="m7.63207665 10.0207968c-.0295693-.58419355-.0431552-1.19236217-.0431552-1.82930092v-.59937775c0-.44136958-.35780074-.79917033-.79917033-.79917033h-3.5930698c-.44136959 0-.79917033.35780075-.79917033.79917033v.59937775c0 4.07576872-.544235 6.99274042-2.39751099 9.78983652h3.3964739" />
      <path d="m6.7929478 12.5869327h10.3892143c.4413696 0 .7991703.3578007.7991703.7991703v4.5952294h-11.98755493v-4.5952294c0-.4413696.35780075-.7991703.79917033-.7991703z" />
      <path d="m12.3871401 9.39025137h3.1966813c.4413696 0 .7991704.35780075.7991704.79917033v2.397511h-4.795022v-2.397511c0-.44136958.3578007-.79917033.7991703-.79917033z" />
      <path d="m15.184236 9.390251v-1.59834" />
      <path d="m8.391288 15.184236h.799171" />
      <path d="m14.784651 15.184236h.79917" />
      <path d="m11.58797 15.184236h.79917" />
      <path d="m8.99066621 0c-.77263558.00144747-1.45724178.49822994-1.69823695 1.23232065-.89057503-.66585201-2.13899351-.55756796-2.90162299.25167802-.76262948.80924597-.79674058 2.06188741-.07928234 2.91143814" />
      <path d="m7.68322355 4.39543681c.24145098-.29218819.40331871-.64180046.46991215-1.01494632.55514904.30126461 1.22819426.2866282 1.76972173-.03848532.54152747-.32511353.87085507-.91226551.86594207-1.54387193" />
    </g>
  </svg>
);

export const WarningSign = ({className, ...props}: React.ComponentProps<'svg'>) => (
  <ExclamationCircleIcon
    color={'currentColor'}
    className={classNames(className, 'shrink-0 w-[14px] h-[14px]')}
    {...props}
  />
);

export const RevertIcon = (props: ComponentProps<'svg'>) => (
  <svg height="21" viewBox="0 0 20 21" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="1.5">
      <circle cx="9.891878" cy="10.5" r="9" />
      <g strokeLinecap="round" strokeLinejoin="round" transform="translate(6.142047 7.49022)">
        <path d="m3.79657427 6.01955909c1.66225534 0 3.00977954-1.3475242 3.00977954-3.00977954 0-1.66225535-1.3475242-3.00977955-3.00977954-3.00977955-1.66225535 0-3.00977955 1.3475242-3.00977955 3.00977955v.2315215" />
        <path d="m0 2.61638219.78679472.78679472.78679472-.78679472" />
      </g>
    </g>
  </svg>
);

export const MinusCircleIcon = (props: ComponentProps<'svg'>) => (
  <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="1.5">
      <circle cx="11.253782" cy="11" r="10" />
      <path d="m7.01207 11h8.508639" strokeLinecap="round" />
    </g>
  </svg>
);

export const PlusCircleIcon = (props: ComponentProps<'svg'>) => (
  <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="1.5">
      <circle cx="11.253782" cy="11" r="10" />
      <g strokeLinecap="round">
        <path d="m7.01207 11h8.508639" />
        <path d="m11.253782 15.254319v-8.508639" />
      </g>
    </g>
  </svg>
);

export const WebsiteIcon = (props: ComponentProps<'svg'>) => (
  <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#0D988B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.05"
      transform="translate(.931197 .931197)"
    >
      <circle cx="6.068803" cy="6.068803" r="6.068803" />
      <path d="m6.0688027 0c3.03440136 4.04586847 3.03440136 8.09173694 0 12.1376054" />
      <path d="m6.0688027 0c-3.03440135 4.04586847-3.03440135 8.09173694 0 12.1376054" />
      <path d="m.398807 3.901373h11.339124" />
      <path d="m.398807 8.236232h11.339991" />
    </g>
  </svg>
);

export const ContactIcon = (props: ComponentProps<'svg'>) => (
  <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      stroke="#0D988B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.05"
      transform="translate(.824132 .824228)"
    >
      <path d="m4.53925599 3.59439635c.50701677-.50716991.50701677-1.3292924 0-1.83646232l-1.37799613-1.37734674c-.24358193-.24368063-.57400918-.38058729-.91855585-.38058729-.34454668 0-.67497392.13690666-.91855586.38058729l-.75523538.75523539c-.65337206.65500881-.75595414 1.67920136-.24546774 2.45078105 2.22425043 3.34769321 5.09431887 6.21776165 8.44201209 8.44201207.77159018.5099597 1.79538518.4071189 2.45013168-.2461171l.7558848-.7558848c.5070167-.5071699.5070167-1.32929239 0-1.8364623l-1.3773468-1.37604797c-.5071699-.50701678-1.32929239-.50701678-1.83646231 0l-.45911558.45911558c-1.54034461-1.26702253-2.95398352-2.68066144-4.22100604-4.22100605z" />
    </g>
  </svg>
);

export const ChevronDownIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m15 12.4589636h-10v-9.99999997"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 22.345377 9.255758)"
    />
  </svg>
);

export const ChevronUpDownIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path
        d="m14.0836004 17.4069021h-8.16720083v-8.16720089"
        transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 26.492065 10.973373)"
      />
      <path
        d="m14.0836004 10.7441219h-8.16720083v-8.16720091"
        transform="matrix(-.70710678 .70710678 -.70710678 -.70710678 21.780767 4.299153)"
      />
    </g>
  </svg>
);

export const IdeaIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(3.6304 1.7656)"
    >
      <path d="m5.24669313 12.7259428v-6.36297138c0-.62014802-.50274092-1.12287731-1.12290326-1.12287731-.62016235 0-1.12290327.50272929-1.12290327 1.12287731 0 .62014801.50274092 1.12287731 1.12290327 1.12287731h4.49161305c.62016235 0 1.12290326-.5027293 1.12290326-1.12287731 0-.62014802-.50274091-1.12287731-1.12290326-1.12287731s-1.12290326.50272929-1.12290326 1.12287731v6.36297138" />
      <path d="m8.24110183 14.597405c0 1.03358-.83790152 1.8714622-1.87150544 1.8714622-1.03360391 0-1.87150544-.8378822-1.87150544-1.8714622v-1.8714622h3.74301088z" />
      <path d="m8.24110183 12.7259428c2.77387217-.8474709 4.62194867-3.46551881 4.49161307-6.36297138 0-3.51417208-2.8488652-6.36297142-6.36311851-6.36297142-3.5142533 0-6.36311849 2.84879934-6.36311849 6.36297142-.13033566 2.89745257 1.7177409 5.51550048 4.49161305 6.36297138" />
    </g>
  </svg>
);
export const LeafIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path d="m10.01173 8.317143-.023508 9.958708" />
      <path d="m10.0287159 1.72414912c1.8755049 1.89047892 4.4199897 4.44862225 4.409253 7.11157422-.0108049 2.66295196-2.5759487 5.21253716-4.46668477 7.08778286-1.87550493-1.8904789-4.41998969-4.4486222-4.409253-7.11157417.01080485-2.66295198 2.5759487-5.2125372 4.46668477-7.08778291z" />
    </g>
  </svg>
);

export const YieldGraphIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path d="m2.10549662 2.10005801v15.79988399h15.78900678" />
      <path d="m2.10549662 17.899942 4.58596991-6.913984 1.69778288 1.9298549 1.03099353-1.7791801 1.03099356 1.7791801 4.2236185-7.28867613.5910456 1.0199643 2.6286028-4.53616584" />
    </g>
  </svg>
);

export const GoalIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <g transform="translate(.8684 11.9819)">
        <rect height="6.352387" rx=".5" width="3.176193" />
        <path d="m3.17619332 5.13749269c8.52013858 2.84269302 5.37570719 2.86651447 15.08691828-1.98512082-.5472434-.74041476-1.5001014-1.05803409-2.382145-.79404833l-3.5176341 1.19107249" />
        <path d="m3.17619332.79404833h2.38214499c1.35135055.04855649 2.63163136.61757019 3.57321748 1.58809666h2.38214501c.4385408 0 .7940483.35550755.7940483.79404833s-.3555075.79404833-.7940483.79404833h-4.36726583" />
      </g>
      <path d="m14.465857 5.438395-.015446 6.543458" />
      <path
        d="m11.1806329 2.42438088c1.7497169.00695708 4.1204533.01330299 5.3526855 1.25554359 1.2322321 1.24224059 1.2250034 3.61859921 1.2178064 5.36831518-1.7497169-.00695708-4.1204533-.01330299-5.3526854-1.25554359-1.2322322-1.24224059-1.2250035-3.61859921-1.2178065-5.36831518z"
        transform="matrix(.70710678 .70710678 -.70710678 .70710678 8.293141 -8.548813)"
      />
    </g>
  </svg>
);

export const PhotoIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path d="m14.1770014 5.3522193-.9613274-3.00414811h-6.60912581l-.9613274 3.00414811h-2.64365034c-.9613274 0-1.80248887.84116148-1.80248887 1.80248887v7.45028733c0 .9613274.84116147 1.8024889 1.80248887 1.8024889h13.81908135c.9613274 0 1.8024888-.8411615 1.8024888-1.8024889v-7.45028733c0-.96132739-.8411614-1.80248887-1.8024888-1.80248887z" />
      <path d="m9.97119407 13.2831703c1.59277943 0 2.88398223-1.2912028 2.88398223-2.8839822 0-1.59277935-1.2912028-2.88398215-2.88398223-2.88398215-1.59277938 0-2.88398219 1.2912028-2.88398219 2.88398215 0 1.5927794 1.29120281 2.8839822 2.88398219 2.8839822z" />
    </g>
  </svg>
);

export const DeleteIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(1.1342 1.1342)"
    >
      <path d="m15.8042065 3.0837476-1.3969377 13.2670531c-.0824365.7845482-.7437553 1.380334-1.5326225 1.380748h-8.01774382c-.78916207 0-1.45092606-.5959066-1.5333935-1.380748l-1.39616673-13.2670531" />
      <path d="m0 3.083748h17.731549" />
      <path d="m5.39655831 3.0837476v-2.3128107c0-.42577669.34516021-.7709369.7709369-.7709369h5.39655829c.4257767 0 .7709369.34516021.7709369.7709369v2.3128107" />
      <path d="m8.865774 6.552964v8.094837" />
      <path d="m12.33499 6.552964-.385468 8.094837" />
      <path d="m5.396558 6.552964.385469 8.094837" />
    </g>
  </svg>
);

export const SettingsIcon = (props: ComponentProps<'svg'>) => (
  <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(1 1.0024)"
    >
      <path d="m16.889065 5.83573101c-.1981555.41651933-.2105058.89750821-.0339873 1.32364847.1765186.42614026.525367.75750437.9600071.91189133l1.0999201.39128468c.6504138.23085792 1.0849951.84626162 1.0849951 1.53644451 0 .6901829-.4345813 1.3055866-1.0849951 1.5364445l-1.0999201.3912847c-.4346401.154387-.7834885.4857511-.9600071.9118913-.1765185.4261403-.1641682.9071292.0339873 1.3236485l.5025722 1.0529905c.2977535.623461.1702013 1.3669064-.318339 1.8554576-.4885404.4885513-1.2319691.6161063-1.8554162.3183462l-1.054706-.5008444c-.41651-.1981599-.8974882-.2105106-1.3236189-.033988-.4261307.1765225-.7574875.5253787-.911871.9600284l-.3912759 1.0999447c-.231211.6497955-.8462843 1.083796-1.5359754 1.083796-.68969117 0-1.30476454-.4340005-1.53597549-1.083796l-.39127594-1.0999447c-.1545803-.4347064-.48610241-.7835626-.91236763-.9600722s-.90735697-.1641436-1.32399174.0340318l-1.05296702.5008444c-.62347941.2989346-1.3677303.1718178-1.85664976-.3171125-.48891945-.4889304-.61603337-1.2331979-.31710546-1.8566913l.5008332-1.0547296c.19815552-.4165193.21050587-.8975082.0339873-1.3236484-.17651857-.4261403-.52536701-.7575044-.96000702-.9118914l-1.09992015-.3912846c-.65041383-.2308579-1.08499509-.8462616-1.08499509-1.53644454 0-.6901829.43458126-1.3055866 1.08499509-1.53644451l1.09992015-.39128468c.43417549-.15444712.78265252-.48551982.95912846-.91122575.17647594-.42570594.16444665-.90623282-.03310874-1.32257501l-.5008332-1.05472959c-.29892791-.62349333-.17181399-1.36776085.31710546-1.85669122.48891946-.48893038 1.23317035-.61604714 1.85664976-.31711255l1.05470603.50084439c.41623034.1976514.89665968.20993768 1.3224482.03381966.42578851-.17611802.75716956-.52419173.91217216-.95812103l.39127594-1.09994471c.23121095-.6497955.84628432-1.08379596 1.53597549-1.08379596.6896911 0 1.3047644.43400046 1.5359754 1.08379596l.3912759 1.09994471c.1543835.43464973.4857403.78350596.911871.96002847s.9071089.16417189 1.3236189-.03398806l1.054706-.50258343c.6234471-.29776012 1.3668758-.17020506 1.8554162.31834619.4885403.48855125.6160925 1.23199663.318339 1.85545758z" />
      <path d="m6.08724061 9.999c0 2.1610056 1.75180205 3.9128468 3.91275939 3.9128468 2.1609573 0 3.9127594-1.7518412 3.9127594-3.9128468 0-2.16100561-1.7518021-3.91284679-3.9127594-3.91284679-2.16095734 0-3.91275939 1.75184118-3.91275939 3.91284679z" />
    </g>
  </svg>
);

export const CrownIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="currentColor" transform="translate(0 .639)">
      <path d="m20 4.55688147c-.0115201-1.23857321-.9281905-2.28206006-2.1549898-2.45292569s-2.3937267.58242277-2.7430976 1.77075588c-.3493708 1.1883331.2241846 2.45331147 1.3482574 2.97358604-.3916289 1.14987433-1.2748773 3.1579882-2.6997401 3.1579882-1.9164822 0-2.4997594-2.61638072-2.9413835-5.14110479 1.1568102-.39526187 1.8580489-1.56918387 1.6577068-2.77511548-.2003422-1.2059316-1.243487-2.09006563-2.4659624-2.09006563-1.22247527 0-2.26562013.88413403-2.46596229 2.09006563-.20034216 1.20593161.50089658 2.37985361 1.65770681 2.77511548-.46662175 2.5747186-1.03323387 5.14110479-2.94138353 5.14110479-1.42486284 0-2.30811115-2.00811387-2.69974012-3.1579882 1.09424219-.50735744 1.67015246-1.72369773 1.36913778-2.89166128s-1.39310024-1.95442899-2.59626486-1.86970019c-1.20316461.08472879-2.17424701 1.01648586-2.30859851 2.21510861-.1343515 1.19862274.60634703 2.3222453 1.76089644 2.6712392l1.35820259 8.16577426c.0660173.4075036.42046554.7052362.83325312.6999934h12.08217027c.4127876.0052428.7672359-.2924898.8332532-.6999934l1.3582025-8.16577426c1.0560004-.32796172 1.7710622-1.31073527 1.7583358-2.41640257z" />
      <path d="m16.041876 17.0555155h-12.0821703c-.46019299 0-.83325312.3730552-.83325312.8332422s.37306013.8332423.83325312.8332423h12.0821703c.460193 0 .8332531-.3730553.8332531-.8332423s-.3730601-.8332422-.8332531-.8332422z" />
    </g>
  </svg>
);

export const FeedbackIcon = (props: ComponentProps<'svg'>) => (
  <svg height="45" viewBox="0 0 45 45" width="45" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <circle id="a" cx="22.5" cy="22.5" r="22.5" />
      <mask id="b" fill="#fff">
        <use fill="#fff" fillRule="evenodd" xlinkHref="#a" />
      </mask>
    </defs>
    <g fill="none" fillRule="evenodd">
      <use fill="#50a5f9" xlinkHref="#a" />
      <path
        d="m22.5 0c12.4264069 0 22.5 10.0735931 22.5 22.5s-10.0735931 22.5-22.5 22.5-22.5-10.0735931-22.5-22.5 10.0735931-22.5 22.5-22.5zm0 5.4c-9.4440692 0-17.1 7.6559308-17.1 17.1s7.6559308 17.1 17.1 17.1 17.1-7.6559308 17.1-17.1-7.6559308-17.1-17.1-17.1z"
        fill="#787878"
        fillOpacity=".35"
        mask="url(#b)"
      />
      <path
        d="m30.7090079 11.551444c1.1334275 0 2.1595535.3784682 2.9023226.9903685s1.2021814 1.4572326 1.2021814 2.390961v13.5253178c0 .9337284-.4594123 1.7790607-1.2021814 2.390961s-1.7688951.9903685-2.9023226.9903685l-15.3505198-.0009768-2.0815492 3.7747946c-.2657613.4816532-.7522995.7959471-1.2937872.8449846l-.1489163.0067237c-.9100257 0-1.6477473-.7377216-1.6477473-1.6477473l.0001386-2.9155732c.0001049-.0117436.0002677-.0234731.0004883-.0351883l-.0006269-16.9336646c0-.9337284.4594123-1.7790607 1.2021814-2.390961s1.7688951-.9903685 2.9023226-.9903685z"
        fill="#096b62"
        mask="url(#b)"
        stroke="#096b62"
      />
      <path
        d="m30.7090079 10.0432485c1.1334275 0 2.1595535.3784682 2.9023226.9903685s1.2021814 1.4572327 1.2021814 2.390961v13.5253178c0 .9337284-.4594123 1.7790608-1.2021814 2.390961-.7427691.6119003-1.7688951.9903685-2.9023226.9903685l-15.3505198-.0009768-2.0815492 3.7747946c-.2657613.4816532-.7522995.7959471-1.2937872.8449846l-.1489163.0067238c-.9100257 0-1.6477473-.7377217-1.6477473-1.6477474l.0001386-2.9155731c.0001049-.0117437.0002677-.0234732.0004883-.0351883l-.0006269-16.9336647c0-.9337283.4594123-1.7790607 1.2021814-2.390961s1.7688951-.9903685 2.9023226-.9903685z"
        fill="#2d2d42"
        mask="url(#b)"
        stroke="#02de98"
      />
      <g fill="#fff">
        <rect height="1.637107" mask="url(#b)" rx=".818553" width="18.177089" x="13.698871" y="13.961326" />
        <rect height="1.637107" mask="url(#b)" rx=".818553" width="18.177089" x="13.698871" y="17.687428" />
        <rect height="1.637107" mask="url(#b)" rx=".818553" width="18.177089" x="13.698871" y="21.41353" />
        <rect height="1.637107" mask="url(#b)" rx=".818553" width="12.384145" x="13.698871" y="25.139633" />
      </g>
    </g>
  </svg>
);
export const LeaderboardIcon = (props: ComponentProps<'svg'>) => (
  <svg height="45" viewBox="0 0 45 45" width="45" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="22.5" cy="22.5" fill="#096b62" r="22.5" />
      <g fill="#faff1a">
        <path
          d="m29.3562813 11.25h8.7874374l-4.3937187 22.5z"
          opacity=".297131"
          transform="matrix(-0 1 -1 -0 56.25 -11.25)"
        />
        <path
          d="m26.0609304 3.2968733h8.7874374l-4.3937187 22.5z"
          opacity=".297131"
          transform="matrix(.70710678 .70710678 -.70710678 .70710678 19.206157 -17.273966)"
        />
        <path
          d="m10.156531 3.2968733h8.7874375l-4.3937187 22.5z"
          opacity=".297131"
          transform="matrix(-.70710678 .70710678 .70710678 .70710678 14.552533 -6.027857)"
        />
        <path
          d="m26.0609304 19.2067759h8.7874374l-4.3937187 22.5z"
          opacity=".297131"
          transform="matrix(-.70710678 .70710678 -.70710678 -.70710678 73.525464 30.458356)"
        />
        <path
          d="m10.156531 19.2067759h8.7874375l-4.3937187 22.5z"
          opacity=".297131"
          transform="matrix(.70710678 .70710678 .70710678 -.70710678 -17.274555 41.704465)"
        />
        <path d="m18.1062813 0h8.7874374l-4.3937187 22.5z" opacity=".297131" />
        <path
          d="m18.1062813 22.5h8.7874374l-4.3937187 22.5z"
          opacity=".297131"
          transform="matrix(-1 -0 0 -1 45 67.5)"
        />
        <path
          d="m6.85628127 11.25h8.78743743l-4.3937187 22.5z"
          opacity=".297131"
          transform="matrix(0 1 1 -0 -11.25 11.25)"
        />
        <path d="m21.9852417 29.7303862-5.5621976 2.9242204c-.5407505.2842893-1.2095774.0763865-1.4938667-.4643639-.1132055-.2153297-.1522699-.4619727-.1111456-.7017458l1.0622852-6.1935981c.0615456-.3588385-.0574225-.7249845-.3181339-.9791153l-4.4999124-4.3863306c-.4374763-.426434-.4464279-1.1267717-.0199939-1.564248.1698083-.1742053.3923082-.2875747.6330541-.3225571l6.218726-.9036338c.3602943-.0523538.6717567-.2786445.8328852-.6051265l2.7810988-5.6351218c.2703753-.54784.9336698-.7727697 1.4815099-.5023945.2181527.1076649.3947296.2842418.5023945.5023945l2.7810988 5.6351218c.1611285.326482.4725909.5527727.8328852.6051265l6.2187261.9036338c.6045773.0878502 1.0234675.6491737.9356172 1.2537511-.0349824.2407459-.1483517.4632458-.3225571.633054l-4.4999124 4.3863306c-.2607114.2541308-.3796795.6202768-.3181339.9791153l1.0622853 6.1935981c.1032741.6021345-.3011321 1.1739811-.9032666 1.2772553-.2397731.0411243-.4864161.0020599-.7017458-.1111456l-5.5621976-2.9242204c-.322257-.1694205-.7072458-.1694205-1.0295028 0z" />
      </g>
      <path
        d="m22.5 0c12.4264069 0 22.5 10.0735931 22.5 22.5s-10.0735931 22.5-22.5 22.5-22.5-10.0735931-22.5-22.5 10.0735931-22.5 22.5-22.5zm0 5.4c-9.4440692 0-17.1 7.6559308-17.1 17.1s7.6559308 17.1 17.1 17.1 17.1-7.6559308 17.1-17.1-7.6559308-17.1-17.1-17.1z"
        fill="#787878"
        fillOpacity=".2"
      />
    </g>
  </svg>
);

export const PreviewIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(1.3333 4.8)"
    >
      <path d="m8.6655111.00092967c-3.10540092-.05238743-6.31711424 2.11783889-8.33627966 4.34045263-.43897525.48735929-.43897525 1.22755863 0 1.71491792 1.97525377 2.17561914 5.17772254 4.39592168 8.33627966 4.34276388 3.1585571.0531578 6.3617963-2.16714474 8.3385908-4.34276388.4389752-.48735929.4389752-1.22755863 0-1.71491792-2.0214766-2.22261374-5.2331899-4.39284006-8.3385908-4.34045263z" />
      <path d="m11.5544357 5.20038207c-.0004259 1.59545728-1.2940296 2.88852584-2.88943805 2.88824226-1.59540846-.00028366-2.88855241-1.29381206-2.88841063-2.8892694.00014177-1.59545733 1.2935156-2.88875604 2.88892408-2.88875604.76638651-.00020443 1.5014313.3042129 2.0432762.84621887.5418449.54200596.8460569 1.2771544.8456484 2.04356431z" />
    </g>
  </svg>
);

export const Plant5LeavesIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(2.9089 1.2564)"
    >
      <path d="m8.83868368 3.78890277c-.11595003 1.4309624-.73721014 2.77400457-1.75265843 3.78890277-1.01544829-1.0148982-1.63670841-2.35794037-1.75265843-3.78890277.1162165-1.43089235.73743607-2.77384687 1.75265843-3.78890277 1.01522235 1.0150559 1.63644193 2.35801042 1.75265843 3.78890277z" />
      <path d="m11.2550983 10.8110026c-1.37987562.3962214-2.85569546.2887818-4.16363243-.3031123.59153932-1.30831331 1.6290202-2.36367187 2.92705613-2.97749462 1.3799459-.39618342 2.8558405-.28846287 4.1636325.30388943-.5913493 1.30825591-1.6289142 2.36342449-2.9270562 2.97671749z" />
      <path d="m11.2550983 16.6400837c-1.37987562.3962215-2.85569546.2887819-4.16363243-.3031122.59153932-1.3083133 1.6290202-2.3636719 2.92705613-2.9774946 1.3799459-.3961835 2.8558405-.2884629 4.1636325.3038894-.5913493 1.3082559-1.6289142 2.3634245-2.9270562 2.9767174z" />
      <path d="m2.92472447 10.8110026c1.37987566.3962214 2.85569551.2887818 4.16363247-.3031123-.59111888-1.30833725-1.62837476-2.36374718-2.92627893-2.97749462-1.379493-.39552695-2.8546708-.2878185-4.16207801.30388943.5911106 1.30762719 1.62769607 2.36264009 2.92472447 2.97671749z" />
      <path d="m2.92472447 16.6400837c1.37987566.3962215 2.85569551.2887819 4.16363247-.3031122-.59111888-1.3083373-1.62837476-2.3637472-2.92627893-2.9774946-1.379493-.395527-2.8546708-.2878185-4.16207801.3038894.5911106 1.3076272 1.62769607 2.3626401 2.92472447 2.9767174z" />
      <path d="m7.08758 7.577806.006218 9.909438" />
    </g>
  </svg>
);

export const MarketplaceOutlineIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(1.4728 1.6654)"
    >
      <path d="m1.483978 11.86209v-6.051149" />
      <path d="m15.570209 5.810941v6.051149" />
      <path d="m15.1120361 0h-13.16988523c-.28073542.00014992-.53730556.15885606-.66279427.40998348l-1.27814017 2.55553897h17.05175407l-1.2781402-2.55553897c-.1254887-.25112742-.3820588-.40983356-.6627942-.40998348z" />
      <path d="m17.0529705 3.70690306c.0319245.89442781-.5010029 1.71264802-1.3319871 2.04504169-.8309842.33239368-1.7811869.10742553-2.3749159-.56228046-.4869088.82340663-1.3371871 1.36536513-2.289181 1.45909991s-1.89164362-.27198465-2.52979303-.98461632c-.63814941.71263167-1.57779913 1.0783511-2.52979302.98461632s-1.80227225-.63569328-2.28918096-1.45909991c-.59443926.66789282-1.54367847.89166086-2.37384197.55959546-.83016349-.33206539-1.36322082-1.14875205-1.33306109-2.04235669v-.74138061h17.05175407z" />
      <path d="m3.70811949 5.18966429v-2.22414184l.74138061-2.96552245" />
      <path d="m8.52709347 5.66859616v-2.70307371-2.96552245" />
      <path d="m13.3460675 5.18966429v-2.22414184l-.7413807-2.96552245" />
      <rect height="4.807208" rx="2" width="17.051754" x=".001216" y="11.86209" />
    </g>
  </svg>
);

export const CopyIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(1.6557 1.6556)"
    >
      <path
        d="m11.609489 2.94714413v-2.22155503c0-.4007319-.3248476-.7255891-.7255921-.7255891h-10.15830339c-.40073506 0-.72559351.32485647-.72559351.7255891v10.1582343c0 .4007421.32485845.7255876.72559351.7255876h2.18537235"
        strokeLinecap="round"
      />
      <path d="m5.07916041 5.80399155c0-.40072755.32486207-.72558765.72559206-.72558765h10.15828893c.4007444 0 .725592.3248601.725592.72558765v10.15821975c0 .4007421-.3248476.7255877-.725592.7255877h-10.15828893c-.40072999 0-.72559206-.3248456-.72559206-.7255877z" />
    </g>
  </svg>
);

export const CircleDotsIcon = (props: ComponentProps<'svg'>) => (
  <svg height="15pt" viewBox="0 0 15 15" width="15pt" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="1.5">
      <path
        d="m6.5 13c3.58985 0 6.5-2.91015 6.5-6.5 0-3.589851-2.91015-6.5-6.5-6.5-3.589851 0-6.5 2.910149-6.5 6.5 0 3.58985 2.910149 6.5 6.5 6.5z"
        strokeMiterlimit="10"
        transform="translate(1.121673 1)"
      />
      <g strokeLinecap="round" strokeLinejoin="round">
        <path
          d="m.0982202.02455505c-.04068414 0-.07366515.03298101-.07366515.07366515 0 .0406841.03298101.0736651.07366515.0736651.0406841 0 .0736651-.032981.0736651-.0736651 0-.04068414-.032981-.07366515-.0736651-.07366515"
          transform="translate(7.523453 7.40178)"
        />
        <path
          d="m.0982202.02455505c-.04068414 0-.07366515.03298101-.07366515.07366515 0 .0406841.03298101.0736651.07366515.0736651.0406841 0 .0736651-.032981.0736651-.0736651 0-.04068414-.032981-.07366515-.0736651-.07366515"
          transform="translate(9.811268 7.40178)"
        />
        <path
          d="m.0982202.02455505c-.04068414 0-.07366515.03298101-.07366515.07366515 0 .0406841.03298101.0736651.07366515.0736651.0406841 0 .0736651-.032981.0736651-.0736651 0-.04068414-.032981-.07366515-.0736651-.07366515"
          transform="translate(5.235637 7.40178)"
        />
      </g>
    </g>
  </svg>
);

export const StarIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m10 14.5572808-5.35740495 2.8165545 1.0231733-5.9655581-4.33423164-4.22483166 5.98976082-.87036319 2.67870247-5.42764405 2.6787025 5.42764405 5.9897608.87036319-4.3342317 4.22483166 1.0231733 5.9655581z"
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
    />
  </svg>
);

export const LockIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(3.3191 .8899)"
    >
      <path d="m1.21470729 7.28807806h10.93236561s1.2147073 0 1.2147073 1.21467969v8.50275785s0 1.2146796-1.2147073 1.2146796h-10.93236561s-1.21470729 0-1.21470729-1.2146796v-8.50275785s0-1.21467969 1.21470729-1.21467969" />
      <path d="m2.42941458 7.28807806v-3.03669922c0-2.34797171 1.90345045-4.25137884 4.25147551-4.25137884 2.34802507 0 4.25147551 1.90340713 4.25147551 4.25137884v3.03669922" />
      <path d="m6.68089 11.539457v2.429359" />
    </g>
  </svg>
);

export const EnvLogoIcon = (props: ComponentProps<'svg'>) => (
  <svg height="29.4" viewBox="0 0 16.8549917 29.4" width="16.854992" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="m7.28410812 9.57088359h-7.28410812c0-3.06686297 1.44250356-5.7971692 3.68648942-7.54907455 1.62353653-1.26723074 3.6659175-2.02180904 5.88439417-2.02180904h7.28410811c0 2.64308125-1.071386 5.03600787-2.8035423 6.7673413-1.7313334 1.7321563-4.12426003 2.80354229-6.76734128 2.80354229"
        fill="#096b62"
      />
      <path
        d="m7.28410812 19.4854006h-7.28410812c0-2.6430812 1.07138599-5.0360078 2.80354229-6.7673412 1.73133342-1.7321563 4.12426004-2.80354234 6.7673413-2.80354234h7.28410811c0 3.17877424-1.5503005 5.99630544-3.9358212 7.73669054-1.5807469 1.1536737-3.528497 1.834193-5.63506238 1.834193"
        fill="#04978a"
      />
      <path
        d="m7.28410812 29.4h-7.28410812c0-2.5649079 1.00884733-4.8936501 2.65131003-6.6118175 1.74203082-1.8234957 4.19831898-2.9590661 6.91957356-2.9590661h7.28410811c0 3.0084387-1.3881937 5.6926638-3.5581206 7.4470378-1.6432856 1.3281236-3.73503916 2.1238458-6.01276298 2.1238458"
        fill="#02dd97"
      />
    </g>
  </svg>
);

export const ComparisonIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="1.5">
      <circle cx="13" cy="10.602515" r="6.25" />
      <circle cx="7" cy="10.602515" r="6.25" />
    </g>
  </svg>
);

export const FeedbackSquareIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" role={'img'} {...props}>
    <title>Feedback</title>
    <g fill="none" fillRule="evenodd">
      <path
        d="m16 0h28c8.836556 0 16 7.163444 16 16v28c0 8.836556-7.163444 16-16 16h-28c-8.836556 0-16-7.163444-16-16v-28c0-8.836556 7.163444-16 16-16z"
        fill="#50a5f9"
      />
      <path
        d="m9 16.7666667c0-1.5924211.78350169-3.0340877 2.0502525-4.0776491 1.2667509-1.0435614 3.0167509-1.6890176 4.9497475-1.6890176h28c1.9329966 0 3.6829966.6454562 4.9497475 1.6890176 1.2667508 1.0435614 2.0502525 2.485228 2.0502525 4.0776491v23.0666666c0 1.5924211-.7835017 3.0340877-2.0502525 4.0776491-1.2667509 1.0435614-3.0167509 1.6890176-4.9497475 1.6890176h-26.019l-3.3873633 5.8297054c-.5034811.8661395-1.4032702 1.4198914-2.3943038 1.4857271l-.1993329.0066095c-1.6568542 0-3-1.3431457-3-3z"
        fill="#096b62"
        stroke="#096b62"
        strokeWidth="2"
      />
      <path
        d="m9 14.7666667c0-1.5924211.78350169-3.0340877 2.0502525-4.0776491 1.2667509-1.04356145 3.0167509-1.6890176 4.9497475-1.6890176h28c1.9329966 0 3.6829966.64545615 4.9497475 1.6890176 1.2667508 1.0435614 2.0502525 2.485228 2.0502525 4.0776491v23.0666666c0 1.5924211-.7835017 3.0340877-2.0502525 4.0776491-1.2667509 1.0435614-3.0167509 1.6890176-4.9497475 1.6890176h-26.179l-3.1943167 5.7906659c-.4948599.8968606-1.4101595 1.4750079-2.4229261 1.543773l-.2037572.0069047c-1.6568542 0-3-1.3431457-3-3z"
        fill="#2d2d42"
        stroke="#02de98"
        strokeWidth="2"
      />
      <g fill="#fff">
        <rect height="2.791993" rx="1.395997" width="31" x="14.990171" y="15.68206" />
        <rect height="2.791993" rx="1.395997" width="31" x="14.990171" y="22.036717" />
        <rect height="2.791993" rx="1.395997" width="31" x="14.990171" y="28.391374" />
        <rect height="2.791993" rx="1.395997" width="21.120461" x="14.990171" y="34.746031" />
      </g>
    </g>
  </svg>
);

export const DragHandleIcon = (props: ComponentProps<'svg'>) => (
  <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <circle cx="5.672607" cy="2.971097" r="1.480391" />
      <circle cx="5.672607" cy="10.058201" r="1.480391" />
      <circle cx="5.672607" cy="17.145305" r="1.480391" />
      <circle cx="14.327393" cy="10.058201" r="1.480391" />
      <circle cx="14.327393" cy="17.145305" r="1.480391" />
      <circle cx="14.327393" cy="2.971097" r="1.480391" />
    </g>
  </svg>
);

export const QuestionMarkCircleIcon = (props: ComponentProps<'svg'>) => (
  <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="1.5">
      <circle className="outer-circle" cx="11" cy="11" r="10" />
      <g strokeLinecap="round" strokeLinejoin="round" transform="translate(6.5 6.5)">
        <path d="m2.4850748 2.69497264c.00019566-1.02455978.76927655-1.88582101 1.78728447-2.00150443 1.01800792-.11568343 1.96072609.551054 2.19080405 1.54944616s-.32575988 2.01046955-1.29172411 2.3519895c-.40268057.14236901-.67181501.52319425-.67159111.9503014v.17192733" />
        <circle cx="4.5" cy="8.3" r="1" fill={'currentColor'} strokeWidth={0} />
      </g>
    </g>
  </svg>
);

export const CropStrengthsIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m16 0h28c8.836555-0 16 7.163444 16 16v28c0 8.836555-7.163445 16-16 16h-28c-8.836556 0-16-7.163445-16-16v-28c-0-8.836556 7.163444-16 16-16z"
      fill="#d3e9fe"
      fillRule="evenodd"
    />
    <path
      d="m9 0h26.96904c4.970566 0 9 4.0294371 9 9v27c0 4.970562-4.029434 9-9 9h-26.96904c-4.9705629 0-9-4.029438-9-9v-27c-0-4.9705629 4.0294371-9 9-9z"
      fill="#2d2d42"
      fillRule="evenodd"
      transform="translate(7.53098 7.45353)"
    />
    <g fill="#02de98">
      <path d="m0 0h5.8510957v7.7599506h-5.8510957z" transform="translate(13.3351 36.1936)" />
      <path d="m0 0h5.8510957v14.811066h-5.8510957z" transform="translate(22.4947 29.1425)" />
      <path d="m0 0h5.8510957v22.41391h-5.8510957z" transform="translate(31.6542 21.5396)" />
      <path d="m0 0h5.8510957v28h-5.8510957z" transform="translate(40.8138 15.9535)" />
    </g>
  </svg>
);

export const CropWeaknessesIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m16 0h28c8.836555-0 16 7.163444 16 16v28c0 8.836555-7.163445 16-16 16h-28c-8.836556 0-16-7.163445-16-16v-28c-0-8.836556 7.163444-16 16-16z"
      fill="#d3e9fe"
      fillRule="evenodd"
    />
    <path
      d="m9 0h26.96904c4.970566 0 9 4.0294371 9 9v27c0 4.970562-4.029434 9-9 9h-26.96904c-4.9705629 0-9-4.029438-9-9v-27c-0-4.9705629 4.0294371-9 9-9z"
      fill="#2d2d42"
      fillRule="evenodd"
      transform="translate(7.51548 7.45353)"
    />
    <g fill="#a8d2fc">
      <path d="m0 0h5.8510957v14.8h-5.8510957z" transform="translate(13.3196 29.1535)" />
      <path d="m0 0h5.8510957v14.811066h-5.8510957z" transform="translate(22.4792 29.1425)" />
      <path d="m0 0h5.8510957v14.8h-5.8510957z" transform="translate(31.6387 29.1535)" />
      <path d="m0 0h5.8510957v14.8h-5.8510957z" transform="translate(40.7983 29.1535)" />
    </g>
  </svg>
);

export const CropHeightIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m16 0h28c8.836555-0 16 7.163444 16 16v28c0 8.836555-7.163445 16-16 16h-28c-8.836556 0-16-7.163445-16-16v-28c-0-8.836556 7.163444-16 16-16z"
      fill="#02de98"
      fillRule="evenodd"
    />
    <path
      d="m0 5.8221579v-5.8221579h5.8221579"
      fill="none"
      stroke="#2d2d42"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="matrix(.707107 .707107 -.707107 .707107 22.816 11)"
    />
    <path
      d="m0 5.8221579v-5.8221579h5.8221579"
      fill="none"
      stroke="#2d2d42"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="matrix(-.707107 -.707107 .707107 -.707107 22.816 48.3)"
    />
    <path
      d="m.79116112 0v37.299999"
      fill="none"
      stroke="#2d2d42"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      transform="translate(22.0248 11)"
    />
    <path
      d="m1 0h7c.5522852-0 1 .44771525 1 1v38c0 .552284-.4477148 1-1 1h-7c-.55228475 0-1-.447716-1-1v-38c-0-.55228475.44771525-1 1-1z"
      fill="#fff"
      fillRule="evenodd"
      transform="translate(32.3009 10)"
    />
    <g fill="none">
      <path d="m0 .5h2.5237303" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 13.722)" />
      <path d="m0 .5h2.5237303" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 20.7345)" />
      <path d="m0 .5h2.5237303" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 27.7469)" />
      <path d="m0 .5h2.5237303" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 34.7593)" />
      <path d="m0 .5h2.5237303" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 41.7718)" />
      <path d="m0 .5h4.407218" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 17.2282)" />
      <path d="m0 .5h4.407218" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 24.2407)" />
      <path d="m0 .5h4.407218" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 31.2531)" />
      <path d="m0 .5h4.407218" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 38.2655)" />
      <path d="m0 .5h4.407218" stroke="#50a5f9" strokeMiterlimit="10" transform="translate(32.3009 45.278)" />
    </g>
  </svg>
);

export const CropIdealSoilTypeIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m16 0h28c8.836555-0 16 7.163444 16 16v28c0 8.836555-7.163445 16-16 16h-28c-8.836556 0-16-7.163445-16-16v-28c-0-8.836556 7.163444-16 16-16z"
      fill="#50a5f9"
      fillRule="evenodd"
    />
    <path d="m0 0h61v14h-61z" fill="#096b62" transform="translate(-1 46)" />
    <g fillRule="evenodd">
      <path
        d="m7.9252453 7.9252453h6.0316667c0-2.5397473-1.194615-4.8006129-3.05279-6.250921-1.3438898-1.04927364-3.0351917-1.6743243-4.8724552-1.6743243h-6.0316668c0 2.1884019.88695496 4.169765 2.321321 5.6039243 1.4341591 1.4341588 3.4153152 2.321321 5.6039243 2.321321"
        fill="#02de98"
        transform="translate(16.043 21.9397)"
      />
      <path
        d="m7.9252453 7.9252453h6.0316667c0-2.1886091-.886955-4.1697652-2.321114-5.6039243-1.434159-1.43436604-3.4155221-2.321321-5.6041312-2.321321h-6.0316668c0 2.6325006 1.2834346 4.965209 3.2587936 6.4064074 1.3091075.9552774 2.921941 1.5188379 4.6664517 1.5188379"
        fill="#02de98"
        transform="translate(16.043 29.865)"
      />
      <path
        d="m7.9252453 7.9252453h6.0316667c0-2.123806-.835196-4.0523741-2.195234-5.4751461-1.443062-1.50972816-3.476599-2.4500992-5.7300112-2.4500992h-6.0316668c0 2.4910929 1.1492734 4.7136564 2.9465787 6.166656 1.3606604 1.0997911 3.0927484 1.7585893 4.9786666 1.7585893"
        fill="#02de98"
        transform="translate(16.043 38.0748)"
      />
      <path
        d="m6.0316668 7.9252453h-6.0316668c0-2.5397473 1.1946149-4.8006129 3.0527897-6.250921 1.3438902-1.04927364 3.0351915-1.6743243 4.8724556-1.6743243h6.0316667c0 2.1884019-.886955 4.169765-2.321321 5.6039243-1.43416 1.4341588-3.4153151 2.321321-5.6039242 2.321321"
        fill="#02de98"
        transform="translate(30.0001 21.9397)"
      />
      <path
        d="m6.0316668 7.9252453h-6.0316668c0-2.1886091.88695496-4.1697652 2.3211141-5.6039243 1.434159-1.43436604 3.4155221-2.321321 5.6041312-2.321321h6.0316667c0 2.6325006-1.283435 4.965209-3.258794 6.4064074-1.3091076.9552774-2.9219411 1.5188379-4.6664512 1.5188379"
        fill="#02de98"
        transform="translate(30.0001 29.865)"
      />
      <path
        d="m6.0316668 7.9252453h-6.0316668c0-2.123806.83519524-4.0523741 2.1952343-5.4751461 1.4430616-1.50972816 3.4765987-2.4500992 5.730011-2.4500992h6.0316667c0 2.4910929-1.149274 4.7136564-2.946579 6.166656-1.3606605 1.0997911-3.0927481 1.7585893-4.9786662 1.7585893"
        fill="#02de98"
        transform="translate(30.0001 38.0748)"
      />
      <path
        d="m0 5.9697618c0-3.2970955 2.6728733-5.9697618 5.9697618-5.9697618 3.2970963 0 5.9699692 2.6726663 5.9699692 5.9697618 0 3.2970963-2.6728729 5.9697622-5.9699692 5.9697622-3.2968885 0-5.9697618-2.6726659-5.9697618-5.9697622"
        fill="#faff1a"
        transform="translate(24.0301 10)"
      />
    </g>
  </svg>
);

export const CropPersistenceIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m16 0h28c8.836555-0 16 7.163444 16 16v28c0 8.836555-7.163445 16-16 16h-28c-8.836556 0-16-7.163445-16-16v-28c-0-8.836556 7.163444-16 16-16z"
      fill="#096b62"
      fillRule="evenodd"
    />
    <path
      d="m38 19q0 .466423-.022888.932285-.022885.465863-.0686.930041-.045719.464178-.114159.925552-.068439.461374-.159435.918837-.090996.457462-.204323.909908-.113334.452446-.248725.898786-.135399.446339-.292534.885497-.157135.439159-.335625.870077-.178494.430919-.377914.852564-.199421.421642-.419289.83299-.219872.411349-.459664.811415-.239791.400063-.498924.78788-.259132.387817-.536976.762453-.277851.374636-.573745.735186-.295895.36055-.609127.706148-.313233.345598-.643044.675409-.329811.329811-.675407.643044-.345599.313232-.706148.60913-.360552.295895-.73519.573742-.374634.277844-.762451.536976-.387817.259133-.78788.498921-.400066.239792-.811415.459663-.411348.219868-.832992.419293-.421643.19942-.852562.377914-.430918.17849-.870077.335625-.439158.157135-.885497.292534-.44634.135391-.898786.248722-.452446.11333-.909908.204326-.457463.090996-.918837.159435-.461374.06844-.92555.114155-.46418.045716-.930041.068604-.465864.022888-.932287.022888-.466423 0-.932285-.022888-.465863-.022885-.930041-.0686-.464178-.045719-.925554-.114159-.461374-.068439-.918837-.159435-.457462-.090996-.909907-.204323-.452445-.113334-.898785-.248725-.44634-.135399-.885499-.292534-.439159-.157135-.870078-.335625-.430919-.178494-.852561-.377914-.421642-.199421-.832991-.419289-.4113495-.219872-.8114149-.459664-.4000645-.239791-.7878819-.498924-.3878174-.259132-.7624521-.536976-.3746352-.277851-.7351856-.573745-.3605509-.295895-.7061477-.609127-.3455977-.313233-.6754088-.643044-.3298111-.329811-.6430426-.675407-.313231-.345599-.609127-.706148-.2958966-.360552-.5737448-.73519-.2778483-.374634-.5369794-.762451-.2591312-.387817-.4989207-.78788-.23979-.400066-.4596606-.811415-.2198708-.411348-.4192926-.832992-.1994219-.421643-.3779146-.852562-.1784927-.430918-.3356261-.870077-.15713336-.439158-.29252901-.885497-.13539576-.44634-.24872744-.898786-.11333179-.452446-.20432654-.909908-.09099474-.457463-.15943332-.918837-.06843857-.461374-.1141561-.92555-.04571753-.46418-.06860386-.930041-.02288633-.465864-.02288633-.932287 0-.466423.02288633-.932285.02288633-.465863.06860386-.930041.04571753-.464178.11415609-.925554.06843859-.461374.15943333-.918837.09099475-.457462.20432648-.909907.11333174-.452445.2487275-.898785.13539565-.44634.29252911-.885499.1571333-.439159.335626-.870078.1784927-.430919.3779146-.852561.1994218-.421642.4192926-.832991.2198706-.4113495.4596603-.8114149.2397898-.4000645.498921-.7878819.2591311-.3878174.5369796-.7624521.277848-.3746352.5737446-.7351856.295896-.3605509.609127-.7061477.3132315-.3455977.6430426-.6754088.3298111-.3298111.6754088-.6430426.3455968-.313231.7061477-.609127.3605504-.2958966.7351856-.5737448.3746347-.2778483.7624521-.5369794.3878165-.2591312.7878809-.4989207.4000654-.23979.8114149-.4596606.411348-.2198708.83299-.4192926.421643-.1994219.852562-.3779146.43092-.1784927.870079-.3356261.439158-.15713336.885499-.29252901.446339-.13539576.898784-.24872744.452446-.11333179.909908-.20432654.457463-.09099474.918837-.15943332.461376-.06843857.925554-.1141561.464178-.04571753.930041-.06860386.465862-.02288633.932285-.02288633.466423 0 .932285.02288633.465863.02288633.930041.06860386.464178.04571753.925552.11415609.461374.06843859.918837.15943333.457462.09099475.909908.20432648.452446.11333174.898786.2487275.446339.13539565.885497.29252911.439159.1571333.870077.335626.430919.1784927.852564.3779146.421642.1994218.83299.4192926.411349.2198706.811415.4596603.400063.2397898.78788.498921.387817.2591311.762453.5369796.374636.277848.735186.5737446.36055.295896.706148.609127.345598.3132315.675409.6430426.329811.3298111.643044.6754088.313232.3455968.60913.7061477.295895.3605504.573742.7351856.277844.3746347.536976.7624521.259133.3878165.498921.7878809.239792.4000654.459663.8114149.219868.411348.419293.83299.19942.421643.377914.852562.17849.43092.335625.870079.157135.439158.292534.885499.135391.446339.248722.898784.11333.452446.204326.909908.090996.457463.159435.918837.06844.461376.114155.925554.045716.464178.068604.930041.022888.465862.022888.932285z"
      fill="#02de98"
      transform="translate(11 11)"
    />
    <path
      d="m31.244444 15.622222q0 .383504-.018816.766545-.018818.383042-.056408.7647-.03759.381657-.093863.761009-.056274.379355-.131092.755488-.074819.376137-.168001.748146-.093183.372011-.204508.739002-.111326.366989-.240526.728075-.129196.361086-.275959.715397-.146761.354311-.31073.700995-.163969.346683-.344749.684906-.180785.338218-.377945.66716-.197163.328945-.410225.647815-.213062.318873-.441515.626906-.228453.308035-.471743.604486-.243294.296452-.500839.58061-.257545.284159-.528725.555336-.271179.271178-.555336.528723-.284158.257546-.580612.500839-.296451.24329-.604484.471743-.308035.228453-.626908.441519-.31887.213062-.647814.410225-.328941.19716-.66716.377945-.33822.18078-.684904.344749-.346683.163969-.700996.31073-.354313.146763-.715397.275961-.361086.129198-.728075.240524-.366991.111325-.739004.204508-.372009.093182-.748146.168001-.376133.074818-.755488.131091-.379352.056274-.761009.093864-.381658.03759-.7647.056408-.383041.018814-.766545.018816-.383504-.000002-.766546-.018818-.383043-.018816-.764699-.056406-.381658-.03759-.761011-.093863-.379354-.056274-.755489-.131092-.376136-.074819-.748147-.168001-.372009-.093183-.739-.204508-.36699-.111326-.728076-.240526-.361086-.129196-.715398-.275959-.3543109-.146761-.7009944-.31073-.3466835-.163969-.6849041-.344749-.3382206-.180785-.6671629-.377945-.3289423-.197163-.6478143-.410225-.318872-.213062-.626905-.441515-.308033-.228453-.6044855-.471743-.296453-.243294-.5806112-.500839-.2841578-.257545-.555336-.528725-.2711783-.271179-.5287237-.555336-.2575455-.284158-.5008378-.580612-.2432926-.296451-.4717458-.604484-.2284531-.308035-.4415164-.626908-.2130634-.31887-.4102237-.647814-.1971605-.328941-.377943-.66716-.1807826-.33822-.3447519-.684904-.163969-.346683-.3107296-.700996-.1467606-.354313-.27595918-.715397-.12919861-.361086-.24052387-.728075-.11132538-.366991-.20450923-.739004-.0931839-.372009-.16800183-.748146-.07481791-.376133-.13108964-.755488-.05627172-.379352-.09386168-.761009-.03758997-.381658-.05640762-.7647-.01881765-.383041-.01881765-.766545 0-.383504.01881765-.766546.01881765-.383043.05640762-.764699.03758996-.381658.09386169-.761011.05627172-.379354.13108963-.755489.07481793-.376136.1680018-.748147.09318388-.372009.20450926-.739.11132526-.36699.24052387-.728076.12919858-.361086.27595918-.715398.1467606-.3543109.3107298-.7009944.1639691-.3466835.3447517-.6849041.1807825-.3382206.3779428-.6671629.1971605-.3289423.4102239-.6478143.2130633-.318872.4415164-.626905.2284532-.308033.4717458-.6044855.2432923-.296453.5008378-.5806112.2575454-.2841578.5287237-.555336.2711782-.2711783.555336-.5287237.2841577-.2575455.5806107-.5008378.2964521-.2432926.6044851-.4717458.3080334-.2284531.6269054-.4415164.3188715-.2130634.6478143-.4102237.3289428-.1971605.6671634-.377943.3382206-.1807826.6849041-.3447519.3466835-.163969.7009944-.3107296.354312-.1467606.715398-.27595918.361087-.12919861.728077-.24052387.36699-.11132538.739-.20450923.37201-.0931839.748146-.16800183.376135-.07481791.755489-.13108964.379353-.05627172.761011-.09386168.381656-.03758997.7647-.05640762.383041-.01881765.766545-.01881765.383504 0 .766545.01881765.383042.01881765.7647.05640762.381657.03758996.761009.09386169.379355.05627172.755488.13108963.376137.07481793.748146.1680018.372011.09318388.739002.20450926.366989.11132526.728075.24052387.361086.12919858.715397.27595918.354311.1467606.700995.3107298.346683.1639691.684906.3447517.338218.1807825.66716.3779428.328945.1971605.647815.4102239.318873.2130633.626906.4415164.308035.2284532.604486.4717458.296452.2432923.58061.5008378.284159.2575454.555336.5287237.271178.2711782.528723.555336.257546.2841577.500839.5806107.24329.2964521.471743.6044851.228453.3080334.441519.6269054.213062.3188715.410225.6478143.19716.3289428.377945.6671634.18078.3382206.344749.6849041.163969.3466835.31073.7009944.146763.354312.275961.715398.129198.361087.240524.728077.111325.36699.204508.739.093182.37201.168001.748146.074818.376135.131091.755489.056274.379353.093864.761011.03759.381656.056408.7647.018816.383041.018816.766545z"
      fill="#c0f7e5"
      transform="translate(14.3778 14.3778)"
    />
    <path
      d="m0 0v10.302222h7.4313536"
      fill="none"
      stroke="#2d2d42"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(30 19.6978)"
    />
  </svg>
);

export const CropRiskIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m16 0h28c8.836555-0 16 7.163444 16 16v28c0 8.836555-7.163445 16-16 16h-28c-8.836556 0-16-7.163445-16-16v-28c-0-8.836556 7.163444-16 16-16z"
      fill="#2d2d42"
      fillRule="evenodd"
    />
    <path d="m19.205732 0 19.205733 36h-38.411465z" fill="#fff" fillRule="evenodd" transform="translate(10.7943 12)" />
    <g fill="none" strokeLinejoin="round">
      <path
        d="m19.205732 0 19.205733 36h-38.411465z"
        stroke="#ff3c3c"
        strokeWidth="3.5"
        transform="translate(10.7943 12)"
      />
      <path
        d="m.59898627.14974657c-.24810824 0-.4492397.20113146-.4492397.4492397 0 .24810827.20113146.44923973.4492397.44923973.24810827 0 .44923973-.20113146.44923973-.44923973 0-.24810824-.20113146-.4492397-.44923973-.4492397z"
        stroke="#2d2d42"
        strokeLinecap="round"
        strokeWidth="1.5"
        transform="translate(29.4007 39.173)"
      />
      <path
        d="m.40162206.79146159v8.33579381"
        stroke="#2d2d42"
        strokeLinecap="round"
        strokeWidth="1.5"
        transform="translate(29.5984 25.8925)"
      />
    </g>
  </svg>
);

export const HowIsCropPlantedIcon = (props: ComponentProps<'svg'>) => (
  <svg height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m16 0h28c8.836555-0 16 7.163444 16 16v28c0 8.836555-7.163445 16-16 16h-28c-8.836556 0-16-7.163445-16-16v-28c-0-8.836556 7.163444-16 16-16z"
      fill="#0d988b"
      fillRule="evenodd"
    />
    <path
      d="m43 21.5q0 .527796-.025894 1.054955-.025898.52716-.077629 1.052413-.051735.525254-.129181 1.047335-.077446.522085-.180412 1.039738-.102967.517652-.231209 1.029631-.128247.511978-.281456 1.017047-.153214.505068-.331024 1.002011-.177811.496942-.379788.984562-.20198.487621-.427643.964742-.225658.477122-.474456.942595-.248806.465473-.520146.918178-.271343.452706-.564567.891552-.293229.438847-.607636.862778-.314407.423931-.649239.831921-.334831.407989-.689273.799061-.354447.391071-.727654.764278-.373207.373207-.764278.727653-.391068.354447-.799061.689278-.407993.334828-.831921.649231-.423931.314407-.862777.607636-.438847.293228-.891549.564567-.452705.271343-.918178.520146-.465475.248798-.942597.47446-.477123.225662-.964742.427639-.48762.201977-.984562.379788-.496943.17781-1.002009.331024-.505069.153209-1.017047.281452-.511979.128246-1.029633.231213-.517654.102966-1.039734.180412-.522083.077446-1.047337.129181-.525253.051727-1.052413.077625-.527159.025898-1.054955.025898-.527794 0-1.054955-.025894-.52716-.025902-1.052413-.077629-.525254-.051735-1.047337-.129181-.522083-.077446-1.039738-.180412-.517654-.102967-1.029632-.231209-.511978-.128247-1.017046-.281456-.505069-.153214-1.002012-.331024-.496943-.177811-.984562-.379788-.487619-.20198-.96474-.427643-.477121-.225658-.942594-.474456-.465474-.248806-.918179-.520146-.4527057-.271343-.8915523-.564567-.4388457-.293229-.8627749-.607636-.4239292-.314407-.8319201-.649239-.4079914-.334831-.7990623-.689273-.3910703-.354447-.7642784-.727654-.373208-.373207-.7276535-.764278-.3544454-.391068-.6892753-.799061-.3348298-.407993-.6492371-.831921-.3144076-.423931-.607635-.862777-.2932275-.438847-.5645685-.891549-.2713409-.452705-.5201419-.918178-.248801-.465475-.4744627-.942597-.2256617-.477123-.4276401-.964742-.2019786-.48762-.3797875-.984562-.1778087-.496943-.33101966-1.002009-.15321094-.505069-.28145474-1.017047-.12824381-.511979-.23121157-1.029633-.10296777-.517654-.18041143-1.039734-.07744363-.522083-.12917663-1.047337-.05173299-.525253-.07763068-1.052413-.02589769-.527159-.02589769-1.054955 0-.527794.02589769-1.054955.02589769-.52716.07763068-1.052413.051733-.525254.12917664-1.047337.07744365-.522083.18041142-1.039738.10296776-.517654.23121157-1.029632.1282438-.511978.28145468-1.017046.15321092-.505069.33101992-1.002012.1778087-.496943.3797873-.984562.2019784-.487619.4276401-.96474.2256617-.477121.4744627-.942594.248801-.465474.5201421-.918179.2713408-.4527057.5645683-.8915523.2932274-.4388457.607635-.8627749.3144073-.4239292.6492371-.8319201.3348299-.4079914.6892753-.7990623.3544455-.3910703.7276535-.7642784.3732081-.373208.7642789-.7276535.3910708-.3544454.7990623-.6892753.4079904-.3348298.8319196-.6492371.4239292-.3144076.8627749-.607635.4388466-.2932275.8915523-.5645685.452705-.2713409.918179-.5201419.465473-.248801.942595-.4744627.47712-.2256617.964739-.4276401.487619-.2019786.984562-.3797875.496944-.1778087 1.002013-.33101966.505068-.15321094 1.017045-.28145474.511978-.12824381 1.029632-.23121157.517655-.10296777 1.039738-.18041143.522083-.07744363 1.047337-.12917663.525253-.05173299 1.052413-.07763068.527161-.02589769 1.054955-.02589769.527796 0 1.054955.02589769.52716.02589769 1.052413.07763068.525254.051733 1.047335.12917664.522085.07744365 1.039738.18041142.517652.10296776 1.029631.23121157.511978.1282438 1.017047.28145468.505068.15321092 1.002011.33101992.496942.1778087.984562.3797873.487621.2019784.964742.4276401.477122.2256617.942595.4744627.465473.248801.918178.5201421.452706.2713408.891552.5645683.438847.2932274.862778.607635.423931.3144073.831921.6492371.407989.3348299.799061.6892753.391071.3544455.764278.7276535.373207.3732081.727653.7642789.354447.3910708.689278.7990623.334828.4079904.649231.8319196.314407.4239292.607636.8627749.293228.4388466.564567.8915523.271343.452705.520146.918179.248798.465473.47446.942595.225662.47712.427639.964739.201977.487619.379788.984562.17781.496944.331024 1.002013.153209.505068.281452 1.017045.128246.511978.231213 1.029632.102966.517655.180412 1.039738.077446.522083.129181 1.047337.051731.525253.077629 1.052413.025894.527161.025894 1.054955z"
      fill="#096b62"
      transform="translate(8.5 8.5)"
    />
    <g fillRule="evenodd">
      <path
        d="m4.6912622 4.6912622h3.5703793c0-1.5033755-.707139-2.8416702-1.8070655-3.70016421-.7955007-.62110606-1.7966485-.99109799-2.8841967-.99109799h-3.5703793c0 1.2954007.52502334 2.4682469 1.3740807 3.3171818.8489348.8489349 2.0216584 1.3740804 3.3171815 1.3740804"
        fill="#02de98"
        transform="translate(21.7383 20.4629)"
      />
      <path
        d="m3.5703793 4.6912622h-3.5703793c0-1.5033755.70713925-2.8416702 1.8070656-3.70016421.7955011-.62110606 1.7966484-.99109799 2.8841966-.99109799h3.5703793c0 1.2954007-.525023 2.4682469-1.3740807 3.3171818-.8489346.8489349-2.0216584 1.3740804-3.3171815 1.3740804"
        fill="#02de98"
        transform="translate(30 20.4629)"
      />
      <path
        d="m12.664948 6.3324738c0-3.4973286-2.8351455-6.3324738-6.3324742-6.3324738-3.4973286 0-6.3324738 2.8351452-6.3324738 6.3324738 0 3.4973287 12.664948 3.4973287 12.664948 0z"
        fill="#2d2d42"
        transform="translate(23.6675 29.0765)"
      />
    </g>
    <path
      d="m11.822288 0c-.794653-.0027883-1.578681.18216726-2.2882027.54001039l-9.52934294 3.75367981c-.11044864.050633 1.74402394 7.1368248 1.84174874 7.0734678l8.5103189-4.1425124c.160294-.1037588.35968-.1275015.539913-.0642753 13.189298 4.4221437 8.715736 4.4992737 23.280527-2.8666801.431171-.2180114.486393-.8117058.10284-1.105536-.847385-.7461185-2.029396-.9815762-3.09807-.6170432l-4.396435 1.4526226c-.163442.0507646-.29842.1672473-.372797.3213768-.430513.8787356-1.322496 1.4368816-2.301056 1.4397674h-5.142026c-.354958 0-.642754-.287796-.642754-.6427531 0-.3549576.287796-.6427536.642754-.6427536h5.142026c.989579 0 1.608063-1.071168 1.113276-1.9282601-.229555-.3977199-.654036-.6427533-1.113276-.6427533h-4.280736c-.138522-.0034106-.272843-.048141-.385653-.1285507-1.437407-1.09045081-3.172447-1.71811914-4.974912-1.799807z"
      fill="#fff"
      transform="translate(6.39905 29.9999)"
    />
    <path
      d="m.49086758 5.2510099v-5.2510099"
      fill="none"
      stroke="#02de98"
      strokeLinecap="round"
      strokeMiterlimit="10"
      transform="translate(29.5092 24.7489)"
    />
  </svg>
);
